import * as E from "react";
import m, { useState as ve, useRef as ya, useEffect as ne, useCallback as te, useMemo as we, Suspense as b1 } from "react";
import { h as y, k as K, l as cu, m as y1, n as Ze, o as lu, p as uu, q as du, _ as ze, r as H, s as I1, t as pu, v as fu, w as mu, x as gu, y as vu, z as st, A as $t, N as hu, V as Eu, B as Ee, S as Au, C as Cu, T as bu, D as yu, E as Iu, G as w1, I as R1, J as Vr, K as Ke, L as wu } from "./index-C6PUpRWC.mjs";
import { f as q, a as Rt } from "./variables-Diba8hnz.mjs";
import { u as B, c as nt, P as ue, s as Ru, d as T1 } from "./contexts-r4a1IsAZ.mjs";
import { c as Tu } from "./index-rLJ7Bey3.mjs";
import { t as ht } from "./breakpoints-Cn2bjDpi.mjs";
import { u as Et } from "./hooks-B13bmCE_.mjs";
import Vn from "axios";
import oe from "relay-runtime";
import { b as Su } from "./tracking-impression-event-BfIQAsaT.mjs";
import { v as ie, w as qe, x as _u, y as Pu, z as jr, A as S1, B as Lu, C as pi, D as fi, E as mi, F as Nu, t as _1, n as xu, d as Ou, f as ku, k as jn, u as gi } from "./index-CLx2OILg.mjs";
import { useWindowSize as Mu, useAsync as ct, useMountEffect as De, useSyncedRef as Ia, useUpdateEffect as Bu, useMap as Uu, useDeepCompareEffect as P1, useToggle as Du, useIntersectionObserver as Hu } from "@react-hookz/web";
import { s as Fu, t as L1 } from "./transient-options-CnVow8zz.mjs";
import { CacheProvider as Gu, Global as zu, ThemeContext as Vu, css as jt, keyframes as Xn } from "@emotion/react";
import { ThemeProvider as ju, Badge as Xu, badgeClasses as Yu, IconButton as Yn, CircularProgress as N1, Popover as Wu, Drawer as Qu, Popper as Zu, Tooltip as Ku, tooltipClasses as vi, ClickAwayListener as qu, Fade as Ju } from "@mui/material";
import { M as $u, _ as e2, h as Wn, j as en, k as Tt, l as x1, m as t2, n as O1, o as wa, p as Ra, q as k1, r as M1, s as Ta, t as Sa, u as _a, v as n2, w as Qn, x as r2, y as a2, z as B1, B as i2, C as U1, D as D1, E as o2, G as s2 } from "./component-B7oPnr60.mjs";
import { onMessage as c2, isSupported as l2, getMessaging as u2, getToken as d2 } from "@firebase/messaging";
import { isFirefox as p2 } from "react-device-detect";
import { g as tn, b as lt } from "./environment-nVMLUumw.mjs";
import { u as ye } from "./fallback-storage-value-DraZAU_d.mjs";
import { readInlineData as Nn, useRelayEnvironment as H1, fetchQuery as F1, usePreloadedQuery as f2, useQueryLoader as m2 } from "react-relay";
import { Z as Zn } from "./z-index-CEuzp1gH.mjs";
import { TabList as g2, TabPanel as v2, TabContext as h2 } from "@mui/lab";
import E2 from "@emotion/styled";
import { Memo as A2, ForwardRef as C2 } from "react-is";
import { useIdleCallback as b2, UnsupportedBehavior as y2 } from "@shopify/react-idle";
import { u as I2 } from "./notification-utils-ToQt-VGm.mjs";
import { TransitionGroup as w2 } from "react-transition-group";
import R2, { bindTrigger as T2, bindPopover as S2 } from "material-ui-popup-state";
import { WhatsappShareButton as _2, TwitterShareButton as P2, TelegramShareButton as L2, FacebookMessengerShareButton as N2, LineShareButton as x2, FacebookShareButton as O2, EmailShareButton as k2 } from "react-share";
import { useCopyToClipboard as M2 } from "react-use";
import * as B2 from "react-dom";
let U2 = {};
function nn() {
  return U2;
}
function Qt(e, t) {
  var s, c, l, u;
  const n = nn(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = ie(e), i = a.getDay(), o = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function xn(e) {
  return Qt(e, { weekStartsOn: 1 });
}
function G1(e) {
  const t = ie(e), n = t.getFullYear(), r = qe(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = xn(r), i = qe(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const o = xn(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function On(e) {
  const t = ie(e);
  return t.setHours(0, 0, 0, 0), t;
}
function kn(e) {
  const t = ie(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function D2(e, t) {
  const n = On(e), r = On(t), a = +n - kn(n), i = +r - kn(r);
  return Math.round((a - i) / _u);
}
function H2(e) {
  const t = G1(e), n = qe(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), xn(n);
}
function F2(e, t) {
  const n = ie(e), r = ie(t), a = n.getTime() - r.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function z1(e) {
  return qe(e, Date.now());
}
function V1(e, t) {
  const n = On(e), r = On(t);
  return +n == +r;
}
function Pa(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function j1(e, t) {
  return +ie(e) - +ie(t);
}
function G2(e, t, n) {
  const r = j1(e, t) / Pu;
  return Pa(n == null ? void 0 : n.roundingMethod)(r);
}
function X1(e, t, n) {
  const r = j1(e, t) / jr;
  return Pa(n == null ? void 0 : n.roundingMethod)(r);
}
function z2(e) {
  const t = ie(e), n = qe(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const V2 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, j2 = (e, t, n) => {
  let r;
  const a = V2[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function br(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const X2 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Y2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, W2 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Q2 = {
  date: br({
    formats: X2,
    defaultWidth: "full"
  }),
  time: br({
    formats: Y2,
    defaultWidth: "full"
  }),
  dateTime: br({
    formats: W2,
    defaultWidth: "full"
  })
}, Z2 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, K2 = (e, t, n, r) => Z2[e];
function Mt(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const q2 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, J2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $2 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, e0 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, t0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, n0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, r0 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, a0 = {
  ordinalNumber: r0,
  era: Mt({
    values: q2,
    defaultWidth: "wide"
  }),
  quarter: Mt({
    values: J2,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Mt({
    values: $2,
    defaultWidth: "wide"
  }),
  day: Mt({
    values: e0,
    defaultWidth: "wide"
  }),
  dayPeriod: Mt({
    values: t0,
    defaultWidth: "wide",
    formattingValues: n0,
    defaultFormattingWidth: "wide"
  })
};
function Bt(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? o0(s, (f) => f.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      i0(s, (f) => f.test(o))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(l)
    ) : l;
    const u = t.slice(o.length);
    return { value: l, rest: u };
  };
}
function i0(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function o0(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function s0(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const c0 = /^(\d+)(th|st|nd|rd)?/i, l0 = /\d+/i, u0 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, d0 = {
  any: [/^b/i, /^(a|c)/i]
}, p0 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, f0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, m0 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, g0 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, v0 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, h0 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, E0 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, A0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, C0 = {
  ordinalNumber: s0({
    matchPattern: c0,
    parsePattern: l0,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Bt({
    matchPatterns: u0,
    defaultMatchWidth: "wide",
    parsePatterns: d0,
    defaultParseWidth: "any"
  }),
  quarter: Bt({
    matchPatterns: p0,
    defaultMatchWidth: "wide",
    parsePatterns: f0,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Bt({
    matchPatterns: m0,
    defaultMatchWidth: "wide",
    parsePatterns: g0,
    defaultParseWidth: "any"
  }),
  day: Bt({
    matchPatterns: v0,
    defaultMatchWidth: "wide",
    parsePatterns: h0,
    defaultParseWidth: "any"
  }),
  dayPeriod: Bt({
    matchPatterns: E0,
    defaultMatchWidth: "any",
    parsePatterns: A0,
    defaultParseWidth: "any"
  })
}, Y1 = {
  code: "en-US",
  formatDistance: j2,
  formatLong: Q2,
  formatRelative: K2,
  localize: a0,
  match: C0,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function b0(e) {
  const t = ie(e);
  return D2(t, z2(t)) + 1;
}
function y0(e) {
  const t = ie(e), n = +xn(t) - +H2(t);
  return Math.round(n / S1) + 1;
}
function W1(e, t) {
  var u, f, d, v;
  const n = ie(e), r = n.getFullYear(), a = nn(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((v = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, o = qe(e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Qt(o, t), c = qe(e, 0);
  c.setFullYear(r, 0, i), c.setHours(0, 0, 0, 0);
  const l = Qt(c, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= l.getTime() ? r : r - 1;
}
function I0(e, t) {
  var s, c, l, u;
  const n = nn(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = W1(e, t), i = qe(e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), Qt(i, t);
}
function w0(e, t) {
  const n = ie(e), r = +Qt(n, t) - +I0(n, t);
  return Math.round(r / S1) + 1;
}
function j(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const We = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return j(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : j(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return j(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return j(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return j(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return j(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return j(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return j(a, t.length);
  }
}, ft = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, hi = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return We.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = W1(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return j(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : j(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = G1(e);
    return j(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return j(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return j(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return j(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return We.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return j(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = w0(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : j(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = y0(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : j(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : We.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = b0(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : j(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return j(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return j(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return j(a, t.length);
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = ft.noon : r === 0 ? a = ft.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = ft.evening : r >= 12 ? a = ft.afternoon : r >= 4 ? a = ft.morning : a = ft.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return We.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : We.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : j(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : j(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : We.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : We.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return We.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Ai(r);
      case "XXXX":
      case "XX":
        return rt(r);
      case "XXXXX":
      case "XXX":
      default:
        return rt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Ai(r);
      case "xxxx":
      case "xx":
        return rt(r);
      case "xxxxx":
      case "xxx":
      default:
        return rt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ei(r, ":");
      case "OOOO":
      default:
        return "GMT" + rt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ei(r, ":");
      case "zzzz":
      default:
        return "GMT" + rt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return j(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return j(r, t.length);
  }
};
function Ei(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + j(i, 2);
}
function Ai(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + j(Math.abs(e) / 60, 2) : rt(e, t);
}
function rt(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = j(Math.trunc(r / 60), 2), i = j(r % 60, 2);
  return n + a + t + i;
}
const Ci = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Q1 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, R0 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return Ci(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ci(r, t)).replace("{{time}}", Q1(a, t));
}, T0 = {
  p: Q1,
  P: R0
}, S0 = /^D+$/, _0 = /^Y+$/, P0 = ["D", "DD", "YY", "YYYY"];
function L0(e) {
  return S0.test(e);
}
function N0(e) {
  return _0.test(e);
}
function x0(e, t, n) {
  const r = O0(e, t, n);
  if (console.warn(r), P0.includes(e)) throw new RangeError(r);
}
function O0(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const k0 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, M0 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, B0 = /^'([^]*?)'?$/, U0 = /''/g, D0 = /[a-zA-Z]/;
function Z1(e, t, n) {
  var u, f, d, v;
  const r = nn(), a = r.locale ?? Y1, i = r.firstWeekContainsDate ?? ((f = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = r.weekStartsOn ?? ((v = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = ie(e);
  if (!Lu(s))
    throw new RangeError("Invalid time value");
  let c = t.match(M0).map((g) => {
    const p = g[0];
    if (p === "p" || p === "P") {
      const h = T0[p];
      return h(g, a.formatLong);
    }
    return g;
  }).join("").match(k0).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const p = g[0];
    if (p === "'")
      return { isToken: !1, value: H0(g) };
    if (hi[p])
      return { isToken: !0, value: g };
    if (p.match(D0))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: g };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return c.map((g) => {
    if (!g.isToken) return g.value;
    const p = g.value;
    (N0(p) || L0(p)) && x0(p, t, String(e));
    const h = hi[p[0]];
    return h(s, p, a.localize, l);
  }).join("");
}
function H0(e) {
  const t = e.match(B0);
  return t ? t[1].replace(U0, "'") : e;
}
function bi(e, t, n) {
  const r = nn(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? Y1, i = F2(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const o = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: i
  });
  let s, c;
  i > 0 ? (s = ie(t), c = ie(e)) : (s = ie(e), c = ie(t));
  const l = Pa((n == null ? void 0 : n.roundingMethod) ?? "round"), u = c.getTime() - s.getTime(), f = u / jr, d = kn(c) - kn(s), v = (u - d) / jr, g = n == null ? void 0 : n.unit;
  let p;
  if (g ? p = g : f < 1 ? p = "second" : f < 60 ? p = "minute" : f < pi ? p = "hour" : v < fi ? p = "day" : v < mi ? p = "month" : p = "year", p === "second") {
    const h = l(u / 1e3);
    return a.formatDistance("xSeconds", h, o);
  } else if (p === "minute") {
    const h = l(f);
    return a.formatDistance("xMinutes", h, o);
  } else if (p === "hour") {
    const h = l(f / 60);
    return a.formatDistance("xHours", h, o);
  } else if (p === "day") {
    const h = l(v / pi);
    return a.formatDistance("xDays", h, o);
  } else if (p === "month") {
    const h = l(v / fi);
    return h === 12 && g !== "month" ? a.formatDistance("xYears", 1, o) : a.formatDistance("xMonths", h, o);
  } else {
    const h = l(v / mi);
    return a.formatDistance("xYears", h, o);
  }
}
function Xr(e) {
  return Math.trunc(+ie(e) / 1e3);
}
function F0(e) {
  return V1(e, z1(e));
}
function G0(e, t) {
  return Nu(e, -t);
}
function z0(e) {
  return V1(e, G0(z1(e), 1));
}
const V0 = /* @__PURE__ */ y("div", {
  target: "etb51bn5"
})("padding-block:21px 20px;color:#ffffff;border-block-end:1px solid #484848;", (e) => e.theme.breakpoints.up("tablet"), "{padding:0;border:0;}"), j0 = /* @__PURE__ */ y("span", {
  target: "etb51bn4"
})({
  name: "1efi8gv",
  styles: "font-weight:bold"
}), X0 = /* @__PURE__ */ y("div", {
  target: "etb51bn3"
})("font-size:16px;font-family:", q, ";line-height:18.75px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{text-align:start;}"), Y0 = /* @__PURE__ */ y("div", {
  target: "etb51bn2"
})("display:flex;flex-flow:row wrap;justify-content:center;align-items:stretch;margin-block-start:16px;", (e) => e.theme.breakpoints.up("tablet"), "{justify-content:flex-start;}");
var W0 = {
  name: "1o82tng",
  styles: "margin-inline-end:12px"
};
const Q0 = /* @__PURE__ */ y("img", {
  target: "etb51bn1"
})("inline-size:144px;block-size:48px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:120px;block-size:40px;margin-inline-end:12px;}", (e) => {
  if (e.$containerWidth > 306)
    return W0;
}, ";"), Z0 = /* @__PURE__ */ y("img", {
  target: "etb51bn0"
})("inline-size:162px;block-size:48px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:135px;block-size:40px;}");
function Yr() {
  return Yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yr.apply(null, arguments);
}
const K0 = "data:image/png;base64,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", q0 = "data:image/png;base64,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", K1 = ({
  ...e
}) => {
  const {
    currentPageType: t,
    handleTrackGA4: n
  } = B(), {
    width: r
  } = Mu(), [a, i] = ve(0), o = ya(null);
  ne(() => {
    o != null && o.current && i(o.current.offsetWidth);
  }, [r, o]);
  const s = (l, u) => /* @__PURE__ */ m.createElement("a", {
    href: "https://scmp.onelink.me/3586748601/43f04bbb",
    rel: "noreferrer",
    target: "_blank",
    onClick: () => c(u),
    "data-qa": "render-url"
  }, l), c = (l) => {
    n({
      action: "click",
      category: "footer",
      customized_parameters: {
        destination_url: "https://scmp.onelink.me/3586748601/43f04bbb",
        link_name: l
      },
      subcategory: ""
    }), n({
      action: "click",
      category: "appdl",
      customized_parameters: {
        click_type: "download",
        os: l === "App Store" ? "ios" : "android",
        page_type: t,
        position: "footer",
        ..._1() && {
          inapp_browser: "fb"
        }
      },
      subcategory: ""
    });
  };
  return /* @__PURE__ */ m.createElement(V0, Yr({}, e, {
    "data-qa": "download-app-widget"
  }), /* @__PURE__ */ m.createElement(X0, null, /* @__PURE__ */ m.createElement(j0, null, "Read more in "), "the SCMP App"), /* @__PURE__ */ m.createElement(Y0, {
    ref: o
  }, s(/* @__PURE__ */ m.createElement(Q0, {
    $containerWidth: a,
    alt: "app store",
    src: K0
  }), "App Store"), s(/* @__PURE__ */ m.createElement(Z0, {
    alt: "google play",
    src: q0
  }), "Google Play")));
};
K1.displayName = "DownloadAppWidget";
const J0 = (e) => /* @__PURE__ */ E.createElement("svg", { width: 25, height: 25, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M12.536 22.5c5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10s4.477 10 10 10ZM12.536 8.5v4M12.536 16.5h.01", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), $0 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi6"
})({
  name: "t5e8y3",
  styles: "margin-inline-end:10px"
}), q1 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi5"
})("max-inline-size:666px;color:#ffffff;font-size:14px;font-family:", q, ";line-height:16px;"), e4 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi4"
})("max-inline-size:666px;color:#ffffff;font-size:16px;font-family:", q, ";line-height:19px;", (e) => e.theme.breakpoints.up("desktop"), "{font-size:18px;line-height:21px;}"), J1 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi3"
})({
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
}), $1 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi2"
})("padding-block:8px;padding-inline:12px;color:#ffffff;font-size:14px;font-family:", q, ";line-height:16px;white-space:nowrap;border-radius:3px;background:#4585ff;", (e) => e.theme.breakpoints.up("desktop"), "{padding-block:12px;padding-inline:20px;font-size:16px;line-height:19px;}"), t4 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi1"
})('display:grid;grid-template-areas:"Content" "." "Description" "." "Button";grid-template-rows:min-content 12px min-content 20px min-content;gap:0 0;padding-block:24px;padding-inline:20px;border:1px solid #999999;border-radius:8px;', J1, "{grid-area:Content;}", q1, "{grid-area:Description;}", $1, "{grid-area:Button;place-self:center center;}", (e) => e.theme.breakpoints.up("desktop"), '{grid-template:"Content Content . Button" min-content ". . . Button" 14px "Description Description . Button" min-content "Description Description . Button" min-content/1fr 1fr 28px min-content;padding:28px;}'), n4 = /* @__PURE__ */ y("div", {
  target: "e5ztbbi0"
})("max-inline-size:908px;margin-block-end:15px;cursor:pointer;", (e) => e.theme.breakpoints.up("desktop"), "{padding:40px;}");
function Wr() {
  return Wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wr.apply(null, arguments);
}
const es = ({
  config: e,
  ...t
}) => {
  const {
    buttonText: n,
    desc: r,
    text: a,
    url: i
  } = e, {
    handleRoutePush: o
  } = B();
  return /* @__PURE__ */ m.createElement(n4, Wr({}, t, {
    "data-qa": "print-edition-footer"
  }), /* @__PURE__ */ m.createElement(t4, {
    onClick: () => {
      o(i, {
        query: {
          module: "covid-19_update_footer",
          pgtype: "homepage"
        },
        type: nt.Article
      });
    }
  }, /* @__PURE__ */ m.createElement(J1, null, /* @__PURE__ */ m.createElement($0, null, /* @__PURE__ */ m.createElement(J0, null)), /* @__PURE__ */ m.createElement(e4, {
    dangerouslySetInnerHTML: {
      __html: a
    }
  })), /* @__PURE__ */ m.createElement(q1, null, r), /* @__PURE__ */ m.createElement($1, null, n)));
};
es.displayName = "PrintEditionFooter";
var r4 = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_CHARTBEAT_DOMAIN: "dev.scmp.com", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.7.0 npm/? node/v20.16.0 linux x64", NODE_VERSION: "20.16.0", SENTRY_RELEASE: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", SHLVL: "2", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", NEXT_PUBLIC_OPTIMIZELY_AB_TEST_HARD_LINK: "28040870026", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "17710558103988413064", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function a4(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function i4(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var o4 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, i), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? r4.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(i4(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = a4(a);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), le = "-ms-", Mn = "-moz-", G = "-webkit-", ts = "comm", La = "rule", Na = "decl", s4 = "@import", ns = "@keyframes", c4 = "@layer", l4 = Math.abs, Kn = String.fromCharCode, u4 = Object.assign;
function d4(e, t) {
  return se(e, 0) ^ 45 ? (((t << 2 ^ se(e, 0)) << 2 ^ se(e, 1)) << 2 ^ se(e, 2)) << 2 ^ se(e, 3) : 0;
}
function rs(e) {
  return e.trim();
}
function p4(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function z(e, t, n) {
  return e.replace(t, n);
}
function Qr(e, t) {
  return e.indexOf(t);
}
function se(e, t) {
  return e.charCodeAt(t) | 0;
}
function Zt(e, t, n) {
  return e.slice(t, n);
}
function ke(e) {
  return e.length;
}
function xa(e) {
  return e.length;
}
function En(e, t) {
  return t.push(e), e;
}
function f4(e, t) {
  return e.map(t).join("");
}
var qn = 1, At = 1, as = 0, me = 0, ae = 0, St = "";
function Jn(e, t, n, r, a, i, o) {
  return { value: e, root: t, parent: n, type: r, props: a, children: i, line: qn, column: At, length: o, return: "" };
}
function Ut(e, t) {
  return u4(Jn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function m4() {
  return ae;
}
function g4() {
  return ae = me > 0 ? se(St, --me) : 0, At--, ae === 10 && (At = 1, qn--), ae;
}
function ge() {
  return ae = me < as ? se(St, me++) : 0, At++, ae === 10 && (At = 1, qn++), ae;
}
function Me() {
  return se(St, me);
}
function Rn() {
  return me;
}
function rn(e, t) {
  return Zt(St, e, t);
}
function Kt(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function is(e) {
  return qn = At = 1, as = ke(St = e), me = 0, [];
}
function os(e) {
  return St = "", e;
}
function Tn(e) {
  return rs(rn(me - 1, Zr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function v4(e) {
  for (; (ae = Me()) && ae < 33; )
    ge();
  return Kt(e) > 2 || Kt(ae) > 3 ? "" : " ";
}
function h4(e, t) {
  for (; --t && ge() && !(ae < 48 || ae > 102 || ae > 57 && ae < 65 || ae > 70 && ae < 97); )
    ;
  return rn(e, Rn() + (t < 6 && Me() == 32 && ge() == 32));
}
function Zr(e) {
  for (; ge(); )
    switch (ae) {
      case e:
        return me;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Zr(ae);
        break;
      case 40:
        e === 41 && Zr(e);
        break;
      case 92:
        ge();
        break;
    }
  return me;
}
function E4(e, t) {
  for (; ge() && e + ae !== 57; )
    if (e + ae === 84 && Me() === 47)
      break;
  return "/*" + rn(t, me - 1) + "*" + Kn(e === 47 ? e : ge());
}
function A4(e) {
  for (; !Kt(Me()); )
    ge();
  return rn(e, me);
}
function C4(e) {
  return os(Sn("", null, null, null, [""], e = is(e), 0, [0], e));
}
function Sn(e, t, n, r, a, i, o, s, c) {
  for (var l = 0, u = 0, f = o, d = 0, v = 0, g = 0, p = 1, h = 1, A = 1, C = 0, b = "", I = a, w = i, R = r, T = b; h; )
    switch (g = C, C = ge()) {
      case 40:
        if (g != 108 && se(T, f - 1) == 58) {
          Qr(T += z(Tn(C), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        T += Tn(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        T += v4(g);
        break;
      case 92:
        T += h4(Rn() - 1, 7);
        continue;
      case 47:
        switch (Me()) {
          case 42:
          case 47:
            En(b4(E4(ge(), Rn()), t, n), c);
            break;
          default:
            T += "/";
        }
        break;
      case 123 * p:
        s[l++] = ke(T) * A;
      case 125 * p:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            h = 0;
          case 59 + u:
            A == -1 && (T = z(T, /\f/g, "")), v > 0 && ke(T) - f && En(v > 32 ? Ii(T + ";", r, n, f - 1) : Ii(z(T, " ", "") + ";", r, n, f - 2), c);
            break;
          case 59:
            T += ";";
          default:
            if (En(R = yi(T, t, n, l, u, a, s, b, I = [], w = [], f), i), C === 123)
              if (u === 0)
                Sn(T, t, R, R, I, i, f, s, w);
              else
                switch (d === 99 && se(T, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Sn(e, R, R, r && En(yi(e, R, R, 0, 0, a, s, b, a, I = [], f), w), a, w, f, s, r ? I : w);
                    break;
                  default:
                    Sn(T, R, R, R, [""], w, 0, s, w);
                }
        }
        l = u = v = 0, p = A = 1, b = T = "", f = o;
        break;
      case 58:
        f = 1 + ke(T), v = g;
      default:
        if (p < 1) {
          if (C == 123)
            --p;
          else if (C == 125 && p++ == 0 && g4() == 125)
            continue;
        }
        switch (T += Kn(C), C * p) {
          case 38:
            A = u > 0 ? 1 : (T += "\f", -1);
            break;
          case 44:
            s[l++] = (ke(T) - 1) * A, A = 1;
            break;
          case 64:
            Me() === 45 && (T += Tn(ge())), d = Me(), u = f = ke(b = T += A4(Rn())), C++;
            break;
          case 45:
            g === 45 && ke(T) == 2 && (p = 0);
        }
    }
  return i;
}
function yi(e, t, n, r, a, i, o, s, c, l, u) {
  for (var f = a - 1, d = a === 0 ? i : [""], v = xa(d), g = 0, p = 0, h = 0; g < r; ++g)
    for (var A = 0, C = Zt(e, f + 1, f = l4(p = o[g])), b = e; A < v; ++A)
      (b = rs(p > 0 ? d[A] + " " + C : z(C, /&\f/g, d[A]))) && (c[h++] = b);
  return Jn(e, t, n, a === 0 ? La : s, c, l, u);
}
function b4(e, t, n) {
  return Jn(e, t, n, ts, Kn(m4()), Zt(e, 2, -2), 0);
}
function Ii(e, t, n, r) {
  return Jn(e, t, n, Na, Zt(e, 0, r), Zt(e, r + 1, -1), r);
}
function vt(e, t) {
  for (var n = "", r = xa(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function y4(e, t, n, r) {
  switch (e.type) {
    case c4:
      if (e.children.length) break;
    case s4:
    case Na:
      return e.return = e.return || e.value;
    case ts:
      return "";
    case ns:
      return e.return = e.value + "{" + vt(e.children, r) + "}";
    case La:
      e.value = e.props.join(",");
  }
  return ke(n = vt(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function I4(e) {
  var t = xa(e);
  return function(n, r, a, i) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](n, r, a, i) || "";
    return o;
  };
}
function w4(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var R4 = function(t, n, r) {
  for (var a = 0, i = 0; a = i, i = Me(), a === 38 && i === 12 && (n[r] = 1), !Kt(i); )
    ge();
  return rn(t, me);
}, T4 = function(t, n) {
  var r = -1, a = 44;
  do
    switch (Kt(a)) {
      case 0:
        a === 38 && Me() === 12 && (n[r] = 1), t[r] += R4(me - 1, n, r);
        break;
      case 2:
        t[r] += Tn(a);
        break;
      case 4:
        if (a === 44) {
          t[++r] = Me() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += Kn(a);
    }
  while (a = ge());
  return t;
}, S4 = function(t, n) {
  return os(T4(is(t), n));
}, wi = /* @__PURE__ */ new WeakMap(), _4 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, a = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !wi.get(r)) && !a) {
      wi.set(t, !0);
      for (var i = [], o = S4(n, i), s = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = i[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, P4 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function ss(e, t) {
  switch (d4(e, t)) {
    case 5103:
      return G + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return G + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return G + e + Mn + e + le + e + e;
    case 6828:
    case 4268:
      return G + e + le + e + e;
    case 6165:
      return G + e + le + "flex-" + e + e;
    case 5187:
      return G + e + z(e, /(\w+).+(:[^]+)/, G + "box-$1$2" + le + "flex-$1$2") + e;
    case 5443:
      return G + e + le + "flex-item-" + z(e, /flex-|-self/, "") + e;
    case 4675:
      return G + e + le + "flex-line-pack" + z(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return G + e + le + z(e, "shrink", "negative") + e;
    case 5292:
      return G + e + le + z(e, "basis", "preferred-size") + e;
    case 6060:
      return G + "box-" + z(e, "-grow", "") + G + e + le + z(e, "grow", "positive") + e;
    case 4554:
      return G + z(e, /([^-])(transform)/g, "$1" + G + "$2") + e;
    case 6187:
      return z(z(z(e, /(zoom-|grab)/, G + "$1"), /(image-set)/, G + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return z(e, /(image-set\([^]*)/, G + "$1$`$1");
    case 4968:
      return z(z(e, /(.+:)(flex-)?(.*)/, G + "box-pack:$3" + le + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + G + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return z(e, /(.+)-inline(.+)/, G + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ke(e) - 1 - t > 6) switch (se(e, t + 1)) {
        case 109:
          if (se(e, t + 4) !== 45) break;
        case 102:
          return z(e, /(.+:)(.+)-([^]+)/, "$1" + G + "$2-$3$1" + Mn + (se(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Qr(e, "stretch") ? ss(z(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (se(e, t + 1) !== 115) break;
    case 6444:
      switch (se(e, ke(e) - 3 - (~Qr(e, "!important") && 10))) {
        case 107:
          return z(e, ":", ":" + G) + e;
        case 101:
          return z(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + G + (se(e, 14) === 45 ? "inline-" : "") + "box$3$1" + G + "$2$3$1" + le + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (se(e, t + 11)) {
        case 114:
          return G + e + le + z(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return G + e + le + z(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return G + e + le + z(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return G + e + le + e + e;
  }
  return e;
}
var L4 = function(t, n, r, a) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Na:
        t.return = ss(t.value, t.length);
        break;
      case ns:
        return vt([Ut(t, {
          value: z(t.value, "@", "@" + G)
        })], a);
      case La:
        if (t.length) return f4(t.props, function(i) {
          switch (p4(i, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return vt([Ut(t, {
                props: [z(i, /:(read-\w+)/, ":" + Mn + "$1")]
              })], a);
            case "::placeholder":
              return vt([Ut(t, {
                props: [z(i, /:(plac\w+)/, ":" + G + "input-$1")]
              }), Ut(t, {
                props: [z(i, /:(plac\w+)/, ":" + Mn + "$1")]
              }), Ut(t, {
                props: [z(i, /:(plac\w+)/, le + "input-$1")]
              })], a);
          }
          return "";
        });
    }
}, N4 = [L4], x4 = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(p) {
      var h = p.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || N4, i = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(p) {
      for (var h = p.getAttribute("data-emotion").split(" "), A = 1; A < h.length; A++)
        i[h[A]] = !0;
      s.push(p);
    }
  );
  var c, l = [_4, P4];
  {
    var u, f = [y4, w4(function(p) {
      u.insert(p);
    })], d = I4(l.concat(a, f)), v = function(h) {
      return vt(C4(h), d);
    };
    c = function(h, A, C, b) {
      u = C, v(h ? h + "{" + A.styles + "}" : A.styles), b && (g.inserted[A.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new o4({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return g.sheet.hydrate(s), g;
};
let Kr;
typeof document == "object" && (Kr = x4({
  key: "css",
  prepend: !0
}));
function O4(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && Kr ? /* @__PURE__ */ K.jsx(Gu, {
    value: Kr,
    children: n
  }) : n;
}
function k4(e) {
  return e == null || Object.keys(e).length === 0;
}
function M4(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (a) => t(k4(a) ? n : a) : t;
  return /* @__PURE__ */ K.jsx(zu, {
    styles: r
  });
}
var B4 = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_CHARTBEAT_DOMAIN: "dev.scmp.com", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.7.0 npm/? node/v20.16.0 linux x64", NODE_VERSION: "20.16.0", SENTRY_RELEASE: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", SHLVL: "2", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", NEXT_PUBLIC_OPTIMIZELY_AB_TEST_HARD_LINK: "28040870026", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "17710558103988413064", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function U4(e, t) {
  const n = E2(e, t);
  return B4.NODE_ENV !== "production" ? (...r) => {
    const a = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${a})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${a})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const D4 = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, H4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: M4,
  StyledEngineProvider: O4,
  ThemeContext: Vu,
  css: jt,
  default: U4,
  internal_processStyles: D4,
  keyframes: Xn
}, Symbol.toStringTag, { value: "Module" })), F4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cu,
  isPlainObject: y1
}, Symbol.toStringTag, { value: "Module" })), G4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ze
}, Symbol.toStringTag, { value: "Module" })), z4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lu,
  private_createBreakpoints: uu,
  unstable_applyStyles: du
}, Symbol.toStringTag, { value: "Module" })), V4 = ["sx"], j4 = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, a = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : I1;
  return Object.keys(e).forEach((i) => {
    a[i] ? r.systemProps[i] = e[i] : r.otherProps[i] = e[i];
  }), r;
};
function X4(e) {
  const {
    sx: t
  } = e, n = ze(e, V4), {
    systemProps: r,
    otherProps: a
  } = j4(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...o) => {
    const s = t(...o);
    return y1(s) ? H({}, r, s) : r;
  } : i = H({}, r, t), H({}, a, {
    sx: i
  });
}
const Y4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pu,
  extendSxProp: X4,
  unstable_createStyleFunctionSx: fu,
  unstable_defaultSxConfig: I1
}, Symbol.toStringTag, { value: "Module" })), Ri = (e) => e, W4 = () => {
  let e = Ri;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Ri;
    }
  };
}, cs = W4();
function ls(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = ls(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function de() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = ls(e)) && (r && (r += " "), r += t);
  return r;
}
const us = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function $n(e, t, n = "Mui") {
  const r = us[t];
  return r ? `${n}-${r}` : `${cs.generate(e)}-${t}`;
}
function er(e, t, n = "Mui") {
  const r = {};
  return t.forEach((a) => {
    r[a] = $n(e, a, n);
  }), r;
}
const Q4 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function ds(e) {
  const t = `${e}`.match(Q4);
  return t && t[1] || "";
}
function ps(e, t = "") {
  return e.displayName || e.name || ds(e) || t;
}
function Ti(e, t, n) {
  const r = ps(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function Z4(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return ps(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case C2:
          return Ti(e, e.render, "ForwardRef");
        case A2:
          return Ti(e, e.type, "memo");
        default:
          return;
      }
  }
}
const K4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z4,
  getFunctionName: ds
}, Symbol.toStringTag, { value: "Module" }));
function fs(e, t) {
  const n = H({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = H({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const a = e[r] || {}, i = t[r];
      n[r] = {}, !i || !Object.keys(i) ? n[r] = a : !a || !Object.keys(a) ? n[r] = i : (n[r] = H({}, i), Object.keys(a).forEach((o) => {
        n[r][o] = fs(a[o], i[o]);
      }));
    } else n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function q4(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : fs(t.components[n].defaultProps, r);
}
function J4({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let a = mu(n);
  return r && (a = a[r] || a), q4({
    theme: a,
    name: t,
    props: e
  });
}
const Ct = typeof window < "u" ? E.useLayoutEffect : E.useEffect;
function $4(...e) {
  return e.reduce((t, n) => n == null ? t : function(...a) {
    t.apply(this, a), n.apply(this, a);
  }, () => {
  });
}
function ed(e, t = 166) {
  let n;
  function r(...a) {
    const i = () => {
      e.apply(this, a);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function td(e, t) {
  return () => null;
}
function nd(e, t) {
  var n, r;
  return /* @__PURE__ */ E.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (r = e.type) == null || (r = r._payload) == null || (r = r.value) == null ? void 0 : r.muiName
  ) !== -1;
}
function Bn(e) {
  return e && e.ownerDocument || document;
}
function rd(e) {
  return Bn(e).defaultView || window;
}
function ad(e, t) {
  return () => null;
}
let Si = 0;
function id(e) {
  const [t, n] = E.useState(e), r = e || t;
  return E.useEffect(() => {
    t == null && (Si += 1, n(`mui-${Si}`));
  }, [t]), r;
}
const _i = E.useId;
function od(e) {
  if (_i !== void 0) {
    const t = _i();
    return e ?? t;
  }
  return id(e);
}
function sd(e, t, n, r, a) {
  return null;
}
var cd = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_CHARTBEAT_DOMAIN: "dev.scmp.com", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.7.0 npm/? node/v20.16.0 linux x64", NODE_VERSION: "20.16.0", SENTRY_RELEASE: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", SHLVL: "2", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", NEXT_PUBLIC_OPTIMIZELY_AB_TEST_HARD_LINK: "28040870026", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "17710558103988413064", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function ms({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: a
  } = E.useRef(e !== void 0), [i, o] = E.useState(t), s = a ? e : i;
  if (cd.NODE_ENV !== "production") {
    E.useEffect(() => {
      a !== (e !== void 0) && console.error([`MUI: A component is changing the ${a ? "" : "un"}controlled ${r} state of ${n} to be ${a ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: l
    } = E.useRef(t);
    E.useEffect(() => {
      !a && l !== t && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = E.useCallback((l) => {
    a || o(l);
  }, []);
  return [s, c];
}
function Gt(e) {
  const t = E.useRef(e);
  return Ct(() => {
    t.current = e;
  }), E.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
const Pi = {};
function ld(e, t) {
  const n = E.useRef(Pi);
  return n.current === Pi && (n.current = e(t)), n;
}
const ud = [];
function dd(e) {
  E.useEffect(e, ud);
}
class tr {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new tr();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function pd() {
  const e = ld(tr.create).current;
  return dd(e.disposeEffect), e;
}
let nr = !0, qr = !1;
const fd = new tr(), md = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function gd(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && md[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function vd(e) {
  e.metaKey || e.altKey || e.ctrlKey || (nr = !0);
}
function yr() {
  nr = !1;
}
function hd() {
  this.visibilityState === "hidden" && qr && (nr = !0);
}
function Ed(e) {
  e.addEventListener("keydown", vd, !0), e.addEventListener("mousedown", yr, !0), e.addEventListener("pointerdown", yr, !0), e.addEventListener("touchstart", yr, !0), e.addEventListener("visibilitychange", hd, !0);
}
function Ad(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return nr || gd(t);
}
function Oa() {
  const e = E.useCallback((a) => {
    a != null && Ed(a.ownerDocument);
  }, []), t = E.useRef(!1);
  function n() {
    return t.current ? (qr = !0, fd.start(100, () => {
      qr = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(a) {
    return Ad(a) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function an(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (a) => {
      r[a] = e[a].reduce((i, o) => {
        if (o) {
          const s = t(o);
          s !== "" && i.push(s), n && n[o] && i.push(n[o]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
const Cd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), bd = /* @__PURE__ */ y("div", {
  target: "e1ylzbp51"
})("font-size:14px;font-family:", q, ";"), yd = /* @__PURE__ */ y(Cd, {
  target: "e1ylzbp50"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), Id = () => /* @__PURE__ */ m.createElement(bd, {
  "data-qa": "article-theme-sign-up-button-display"
}, /* @__PURE__ */ m.createElement(yd, null), "GET OUR NEWSLETTER");
Id.displayName = "ArticleThemeSignUpButtonDisplay";
const wd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), Rd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ E.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), Td = (e) => /* @__PURE__ */ E.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ E.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), Sd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), _d = (e) => /* @__PURE__ */ E.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1567 3.20829L19.7717 4.20332L11.0769 10.0104L2.3814 4.20332L2.95515 3.20829L11.0769 8.5998L19.1567 3.20829ZM20.4279 2.42031C20.4279 2.08813 20.3184 1.80524 20.1002 1.57014C19.8812 1.33503 19.6209 1.21748 19.3209 1.21748H2.83215C2.5314 1.21748 2.27115 1.33503 2.0529 1.57014C1.8339 1.80524 1.72515 2.08813 1.72515 2.42031V15.6507C1.72515 15.9829 1.8339 16.2665 2.0529 16.5009C2.27115 16.7367 2.5314 16.8535 2.83215 16.8535H19.3209C19.6209 16.8535 19.8812 16.7367 20.1002 16.5009C20.3184 16.2665 20.4279 15.9829 20.4279 15.6507V2.42031ZM20.9207 0.719966C21.3579 1.19018 21.5769 1.75671 21.5769 2.42031V15.6097C21.5769 16.2733 21.3579 16.8406 20.9207 17.3101C20.4827 17.7803 19.9494 18.0146 19.3209 18.0146H2.83215C2.20365 18.0146 1.6704 17.7803 1.23315 17.3101C0.795154 16.8406 0.576904 16.2733 0.576904 15.6097V2.42031C0.576904 1.75671 0.795154 1.19018 1.23315 0.719966C1.6704 0.250513 2.20365 0.0146484 2.83215 0.0146484H19.3209C19.9494 0.0146484 20.4827 0.250513 20.9207 0.719966Z", fill: "black" })), Pd = /* @__PURE__ */ y(_d, {
  target: "e5xr1380"
})({
  name: "afd8d5",
  styles: "margin-inline-start:12px"
}), Ld = () => {
  var e;
  const {
    config: t
  } = B(), {
    newsletterItemForDisplay: n
  } = gu(), r = {
    [t.newsletter.globalImpact]: /* @__PURE__ */ m.createElement(wd, null),
    [t.newsletter.lunar]: /* @__PURE__ */ m.createElement(Rd, null),
    [t.newsletter.postMag]: /* @__PURE__ */ m.createElement(Td, null),
    [t.newsletter.thisWeekInAsia]: /* @__PURE__ */ m.createElement(Sd, null)
  }, a = vu(n), i = (e = n == null ? void 0 : n.entityId) !== null && e !== void 0 ? e : "";
  return i in r ? /* @__PURE__ */ m.createElement(m.Fragment, null, r[i], /* @__PURE__ */ m.createElement(Pd, null)) : /* @__PURE__ */ m.createElement(m.Fragment, null, a);
};
Ld.displayName = "ArticleThemeTitle";
const Nd = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 491, height: 50, viewBox: "0 0 491 50", className: "large-logo", ...e }, /* @__PURE__ */ E.createElement("g", { fill: "none" }, /* @__PURE__ */ E.createElement("path", { fill: "#FFF", d: "M344.522 20.758l.007.223c0 1.717-1.026 2.891-2.822 2.891-1.266 0-2.215-.834-2.215-1.954 0-.38.116-.787.341-1.193-.916 0-2.983 1.489-2.983 2.966v12.033c0 .937.344 1.133 1.096 1.199l1.003.088v.456h-10.193v-.456l.855-.108c.846-.129 1.051-.222 1.051-1.24V23.134c0-1.745-.624-2.178-2.112-2.387v-.439l8.175-2.019v3.039c1.34-1.816 3.243-3.039 4.963-3.039 1.47 0 2.485.751 2.764 1.973l7.985-1.973v3.279c1.521-1.441 3.433-3.246 6.143-3.246 3.349 0 4.896 2.044 4.896 4.752v12.735c0 .92.36.995 1.032 1.093l.884.108v.456h-9.977v-.456l.951-.108c.624-.084.949-.222.949-1.02V23.524c0-1.208-.675-2.019-1.899-2.019-1.579 0-2.871 1.237-2.871 2.569v11.62c0 .998.309 1.11 1.003 1.208l.906.108v.456h-9.798v-.456l.884-.146c.482-.087.833-.098.833-1.055V23.285c0-1.666-.364-2.303-1.849-2.528zm-88.417 16.681h-9.968v-.454l.964-.121c.627-.075.932-.204.932-1.022V23.488c0-1.197-.662-2.02-1.896-2.02-1.566 0-2.855 1.23-2.855 2.571v11.624c0 1.017.303 1.111.987 1.201l.91.121v.454h-9.804v-.454l.89-.15c.482-.085.842-.112.842-1.053V23.253c0-1.754-.386-2.297-2.118-2.529v-.449l8.18-2.014v3.266c1.501-1.427 3.43-3.239 6.14-3.239 3.362 0 4.895 2.045 4.895 4.766V35.78c0 .92.367.992 1.019 1.082l.881.121v.454zm-23.08-23.618c0 1.764-1.412 3.163-3.327 3.163-1.922 0-3.301-1.399-3.301-3.163 0-1.768 1.379-3.188 3.301-3.188 1.916 0 3.327 1.42 3.327 3.188zm1.713 23.618h-9.936v-.454c.305-.063.906-.121.906-.121.656-.09.984-.184.984-1.054V23.286c0-1.758-.402-2.33-2.099-2.561v-.449l8.28-2.014v17.295c0 1.124.267 1.217 1.163 1.346l.701.082v.454zm-10.621 0h-9.959v-.454l1.022-.121c.604-.061.874-.33.874-1.054V23.582c0-1.465-.73-2.113-1.932-2.113-1.465 0-2.812 1.23-2.812 2.478v11.776c0 1 .321 1.051 1.019 1.141l.865.121v.454h-9.962v-.454l1.132-.15c.517-.061.755-.346.755-.85V14.533c0-2.165-.646-2.372-2.103-2.61v-.436l8.294-2.011v12.051c1.24-1.573 3.69-3.266 6.049-3.266 2.685 0 4.876 1.549 4.876 4.758v12.732c0 .998.331 1 1.077 1.112l.803.121v.454zm-21.649-4.309c-1.286 2.006-4.112 5.017-9.209 5.017-8.805 0-13.504-5.174-13.504-13.197 0-9.832 6.478-13.926 13.472-13.926 3.562 0 5.414 1.164 6.767 1.164.412 0 1.064-.124 1.575-.235l.083 6.36h-.82l-2.475-4.522c-1.038-.79-2.446-1.311-4.783-1.311-4.349 0-6.853 4.904-6.853 11.438 0 7.482 3.472 11.539 7.837 11.539 4.76 0 6.378-1.949 7.384-3.032l.527.705zm-28.246 4.309h-9.975v-.454l1.022-.121c.592-.061.884-.33.884-1.054V23.582c0-1.465-.752-2.113-1.942-2.113-1.443 0-2.822 1.23-2.822 2.478v11.776c0 1 .331 1.051 1.025 1.141l.871.121v.454h-9.975v-.454l1.148-.15c.514-.061.749-.346.749-.85V14.533c0-2.165-.637-2.372-2.096-2.61v-.436l8.278-2.011v12.051c1.257-1.573 3.7-3.266 6.059-3.266 2.687 0 4.86 1.549 4.86 4.758v12.732c0 .998.363 1 1.099 1.112l.813.121v.454zm-19.807-3.1c-1.013 1.766-3.231 3.522-6.755 3.522-3.38 0-4.957-2.294-4.957-4.619V20.454h-2.274v-.443l8.047-6.457h.466v5.38h4.639l-.537 1.52h-4.103v12.254c0 1.647.873 2.321 2.044 2.321 1.075 0 2.302-.713 3.122-1.375l.305.684zm-13.551 2.584l-7.99.732v-3.047c-1.294 1.497-3.725 3.282-6.186 3.282-3.184 0-4.822-2.08-4.822-4.789v-9.966c0-1.745-.59-2.246-2.099-2.41v-.449l8.276-2.014v13.931c0 1.428.551 2.247 1.932 2.247.906 0 1.244-.142 1.921-.58.784-.525.864-.95.864-1.908v-8.818c0-1.745-.575-2.178-2.094-2.41v-.449l8.279-2.014v16.722c0 1.28.995 1.383 1.919 1.505v.433zm-40.776-7.824c0 5.385-4.4 8.821-10.432 8.821-3.208 0-6.161-.875-7.798-2.055v-5.921h.729l2.231 4.934c1.336.863 2.739 1.611 5.043 1.611 3.193 0 4.928-2.076 4.928-4.483 0-2.152-1.625-3.841-5.565-5.062-4.917-1.533-7.646-3.744-7.646-7.954 0-4.554 4.576-7.943 9.647-7.943 3.172 0 5.476 1.347 6.125 1.347.281 0 .755-.061 1.016-.092v5.869h-.695l-2.453-4.394c-.762-.802-2.767-1.151-4.228-1.151-2.679 0-4.689 1.505-4.689 3.736 0 2.204 1.446 3.246 6.026 4.76 5.304 1.751 7.76 3.778 7.76 7.976zm166.538 3.438v-6.439c-1.749 2.067-4.513 2.203-4.513 6.439 0 1.574.736 2.632 2.048 2.632 1.337 0 2.465-1.497 2.465-2.632zm9.225 2.801c-.437.86-2.282 2.552-4.992 2.552s-3.677-1.453-3.996-3.128c-1.077 1.674-2.517 3.128-5.716 3.128-3.227 0-5.043-1.905-5.043-4.6 0-2.862 1.649-4.355 5.924-6.006 2.778-1.071 4.674-1.467 4.674-4.472 0-2.535-1.006-3.415-2.286-3.415-1.694 0-2.735 1.079-2.906 1.351.308.169 1.443.672 1.443 2.273 0 1.658-1.401 2.635-2.964 2.635-1.723 0-2.533-1.322-2.533-2.845 0-2.571 3.488-4.549 8.711-4.549 4.42 0 6.647 2.105 6.647 5.742v9.733c0 1.477.167 2.073 1.132 2.073.521 0 1.08-.353 1.578-.85l.324.378zm-162.307-7.203c0-6.636-.628-8.908-2.899-8.908-2.355 0-2.92 2.242-2.92 8.849 0 6.19.565 8.847 2.92 8.847 2.271 0 2.899-2.631 2.899-8.788zm6.336 0c0 5.763-4.122 9.755-9.235 9.755-5.158 0-9.279-4.012-9.279-9.815 0-5.758 4.163-9.813 9.279-9.813 5.113 0 9.235 4.063 9.235 9.873zm371.029 6.164c-1.015 1.75-3.214 3.591-6.734 3.591-3.385 0-4.96-2.298-4.96-4.612V20.492h-2.279v-.452l8.062-6.432h.454v5.358h4.641l-.533 1.526h-4.108v12.263c0 1.634.887 2.299 2.048 2.299 1.093 0 2.006-.677 2.922-1.349l.488.594zm-14.018-3.067c0 4.106-3.642 6.629-8.159 6.629-3.999 0-5.635-1.056-6.409-1.437V31.55h.449l2.138 4.085c.865.594 2.53 1.14 3.864 1.14 2.167 0 3.674-1.051 3.674-2.896 0-1.962-2.427-2.627-4.973-3.496-2.832-.957-5.339-2.5-5.339-5.789 0-3.989 3.536-6.304 7.531-6.304 3.401 0 4.857 1.262 5.767 1.032v4.696h-.414l-2.186-3.587c-.681-.52-1.903-1.034-3.15-1.034-2.54 0-3.729.869-3.729 2.434 0 1.718 2.392 2.402 4.985 3.326 3.276 1.165 5.95 2.399 5.95 6.075zm-79.77 6.235h-9.949v-.456l.952-.108c.62-.084.935-.222.935-1.02V23.525c0-1.208-.675-2.164-1.887-2.164-1.594 0-2.867 1.381-2.867 2.714v11.62c0 .998.305 1.11.98 1.208l.906.108v.456H376.4v-.456l.878-.146c.498-.087.842-.098.842-1.055V23.286c0-1.757-.383-2.305-2.089-2.538v-.439l8.155-2.019v3.279c1.517-1.441 3.437-3.246 6.136-3.246 3.375 0 4.906 2.044 4.906 4.752V35.81c0 .92.363.995 1.032 1.093l.862.108v.456zM374.07 13.86c0 1.75-1.408 3.147-3.33 3.147-1.916 0-3.289-1.397-3.289-3.147 0-1.76 1.373-3.179 3.289-3.179 1.922 0 3.33 1.42 3.33 3.179zm1.765 23.607h-9.932v-.456c.318-.053.903-.108.903-.108.663-.092 1.001-.18 1.001-1.061V23.325c0-1.763-.412-2.344-2.106-2.577v-.439l8.29-2.019v17.29c0 1.143.241 1.232 1.151 1.343l.694.088v.456zm-65.032 0h-12.254v-.456l1.433-.175c1.097-.134 1.351-.31 1.351-1.46v-.497l-.44-17.809h-.113l-7.464 20.609h-1.19l-7.22-20.491h-.096l-.241 16.091-.029 1.038c0 2.173.582 2.461 2.299 2.694v.456h-6.59v-.456c1.726-.33 2.588-1.104 2.655-3.713l.508-18.203.019-.687c0-1.09-.324-2.061-1.739-2.218 0 0-.708-.078-1.144-.115v-.468h9.148l5.484 16.408h.096l5.947-16.408h8.036v.468c-1.408.115-2.154.502-2.154 1.533l.042 1.511.707 20.166c.042 1.056.469 1.418 1.521 1.552l1.427.175v.456zm143.567-9.301c0-6.637-.63-8.896-2.903-8.896-2.356 0-2.915 2.242-2.915 8.828 0 6.201.56 8.854 2.915 8.854 2.273 0 2.903-2.635 2.903-8.786zm6.339 0c0 5.749-4.134 9.755-9.242 9.755-5.146 0-9.267-4.023-9.267-9.823 0-5.755 4.153-9.808 9.267-9.808 5.108 0 9.242 4.069 9.242 9.876zm-23.79-9.544c0-4.263-1.514-5.961-4.465-5.961-.717 0-1.28.092-1.723.193v12.047c.289.024.537.105 1.617.105 3.057 0 4.571-1.671 4.571-6.385zm6.676.08c0 4.728-4.484 7.36-10.373 7.36-.874 0-1.317.014-2.491-.066v9.407c0 .826.354 1.278 1.906 1.432l1.109.116v.515h-12.163v-.515l1.514-.177c.964-.108 1.299-.38 1.299-1.258V14.171c0-1.511-.849-1.862-2.812-2.096v-.468h10.553c7.438 0 11.459 1.703 11.459 7.095zm-32.443 23.361c0-1.371-1.115-1.785-4.112-2.394l-5.075-1.032c-.829.699-1.723 1.297-1.723 3.21 0 1.897 2.048 3.08 5.31 3.08 3.585 0 5.6-1.467 5.6-2.864zm-3.244-17.021c0-4.25-.662-5.771-2.24-5.771-1.694 0-2.208 1.521-2.208 5.771 0 4.192.514 5.596 2.208 5.596 1.578 0 2.24-1.404 2.24-5.596zm8.489-6.275l-1.144 2.317-3.112-.166c1.003.954 1.8 2.158 1.8 4.124 0 3.991-3.709 6.722-8.274 6.722-1.044 0-2.282-.147-3.14-.362-.17.297-.299.657-.299.963 0 .465.887.799 1.925.997l5.333 1.015c4.735.932 6.673 2.205 6.673 5.207 0 3.944-5.153 6.389-10.669 6.389-5.101 0-9.531-.906-9.531-3.732 0-2.394 2.584-3.327 4.725-3.939-1.71-.697-2.302-2.164-2.302-3.21 0-1.977 1.527-3.016 3.06-4.134-2.555-1.073-4.034-3.198-4.034-5.917 0-3.956 3.726-6.835 8.258-6.835 1.81 0 2.909.401 3.71.76l7.02-.2zm-94.364 9.399c0-6.637-.637-8.896-2.919-8.896-2.353 0-2.909 2.242-2.909 8.828 0 6.201.556 8.854 2.909 8.854 2.282 0 2.919-2.635 2.919-8.786zm6.323 0c0 5.749-4.13 9.755-9.241 9.755-5.143 0-9.268-4.023-9.268-9.823 0-5.755 4.153-9.808 9.268-9.808 5.111 0 9.241 4.069 9.241 9.876z" }), /* @__PURE__ */ E.createElement("path", { fill: "#FEFEFE", d: "M0 49.95h63.74V0H0z" }), /* @__PURE__ */ E.createElement("path", { fill: "#ffca05", d: "M5.499 44.357h23.61V5.587H5.498z" }), /* @__PURE__ */ E.createElement("path", { fill: "#001246", d: "M34.632 44.357h23.61V5.587h-23.61z" }))), xd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 170, height: 68, viewBox: "0 0 170 68", xmlns: "http://www.w3.org/2000/svg", className: "small-logo", ...e }, /* @__PURE__ */ E.createElement("g", { fill: "none" }, /* @__PURE__ */ E.createElement("path", { d: "M72.432 64.145h-4.137v-.187l.4-.05c.26-.031.387-.084.387-.422V58.39c0-.494-.275-.834-.787-.834-.65 0-1.185.508-1.185 1.061v4.797c0 .42.126.458.41.495l.377.05v.187h-4.069v-.187l.37-.062c.2-.035.35-.046.35-.434v-5.17c0-.724-.16-.948-.88-1.044v-.185l3.396-.831v1.347c.623-.588 1.423-1.336 2.548-1.336 1.395 0 2.031.844 2.031 1.967v5.252c0 .38.153.409.423.446l.366.05v.187zM62.853 54.4c0 .727-.585 1.304-1.38 1.304-.798 0-1.37-.577-1.37-1.305 0-.73.572-1.315 1.37-1.315.795 0 1.38.586 1.38 1.315m.711 9.746h-4.123v-.187l.376-.05c.272-.037.408-.076.408-.435v-5.168c0-.726-.167-.961-.87-1.057v-.185l3.436-.831v7.137c0 .463.11.502.483.555l.29.034v.187zm-4.407 0h-4.133v-.187l.424-.05c.25-.025.363-.136.363-.435v-5.046c0-.604-.303-.872-.802-.872-.608 0-1.167.508-1.167 1.023v4.859c0 .413.133.434.423.471l.359.05v.187h-4.135v-.187l.47-.062c.215-.025.313-.143.313-.35v-8.853c0-.893-.268-.979-.872-1.077v-.18l3.442-.83v4.973c.514-.648 1.531-1.347 2.51-1.347 1.114 0 2.024.639 2.024 1.963v5.254c0 .412.138.413.447.459l.334.05v.187zm-8.985-1.778c-.534.828-1.707 2.07-3.822 2.07-3.654 0-5.605-2.134-5.605-5.445 0-4.058 2.688-5.747 5.591-5.747 1.478 0 2.247.48 2.808.48.171 0 .442-.05.654-.097l.035 2.625h-.34l-1.028-1.866c-.43-.326-1.015-.541-1.985-.541-1.805 0-2.844 2.024-2.844 4.72 0 3.087 1.441 4.762 3.253 4.762 1.975 0 2.646-.805 3.064-1.252l.219.291zM38.45 64.145h-4.14v-.187l.424-.05c.245-.025.367-.136.367-.435v-5.046c0-.604-.312-.872-.806-.872-.599 0-1.171.508-1.171 1.023v4.859c0 .413.137.434.425.471l.362.05v.187h-4.14v-.187l.476-.062c.214-.025.311-.143.311-.35v-8.853c0-.893-.264-.979-.87-1.077v-.18l3.436-.83v4.973c.521-.648 1.535-1.347 2.515-1.347 1.115 0 2.017.639 2.017 1.963v5.254c0 .412.15.413.456.459l.337.05v.187zm-8.221-1.279c-.42.729-1.341 1.453-2.803 1.453-1.403 0-2.057-.946-2.057-1.906v-5.276h-.944v-.183l3.34-2.665h.193v2.22h1.925l-.223.628h-1.702v5.056c0 .68.362.958.848.958.446 0 .956-.294 1.296-.567l.127.282zm-5.624 1.066l-3.316.302v-1.257c-.537.618-1.546 1.354-2.567 1.354-1.322 0-2.002-.858-2.002-1.976v-4.112c0-.72-.244-.927-.87-.995v-.185l3.434-.831v5.748c0 .59.228.928.801.928.377 0 .517-.059.798-.24.325-.216.359-.391.359-.787v-3.638c0-.72-.24-.9-.87-.995v-.185l3.436-.831v6.9c0 .528.413.57.797.621v.18zM7.682 60.704c0 2.222-1.826 3.64-4.33 3.64-1.33 0-2.557-.362-3.236-.848v-2.444H.42l.926 2.037c.554.355 1.136.665 2.093.665 1.325 0 2.045-.857 2.045-1.85 0-.889-.675-1.586-2.31-2.09C1.134 59.182 0 58.269 0 56.532c0-1.88 1.9-3.277 4.004-3.277 1.316 0 2.272.555 2.542.555l.422-.037v2.422h-.29l-1.016-1.814c-.316-.33-1.148-.475-1.755-.475-1.112 0-1.946.621-1.946 1.542 0 .91.6 1.339 2.501 1.964 2.202.723 3.22 1.56 3.22 3.292m69.116 1.419v-2.658c-.725.853-1.873.91-1.873 2.658 0 .65.306 1.086.85 1.086.555 0 1.023-.618 1.023-1.086zm3.829 1.156c-.181.354-.947 1.053-2.072 1.053-1.124 0-1.526-.6-1.658-1.291-.447.69-1.045 1.29-2.372 1.29-1.34 0-2.093-.785-2.093-1.898 0-1.181.684-1.797 2.459-2.479 1.152-.441 1.94-.605 1.94-1.845 0-1.046-.418-1.409-.95-1.409-.702 0-1.135.445-1.205.557.128.07.599.278.599.938 0 .685-.582 1.088-1.23 1.088-.715 0-1.051-.546-1.051-1.174 0-1.06 1.447-1.877 3.615-1.877 1.834 0 2.759.869 2.759 2.37v4.015c0 .61.069.856.47.856.215 0 .448-.145.654-.35l.135.156zm-67.36-2.973c0-2.738-.261-3.676-1.204-3.676-.977 0-1.212.925-1.212 3.651 0 2.554.235 3.651 1.212 3.651.943 0 1.204-1.085 1.204-3.626m2.63 0c0 2.378-1.712 4.025-3.834 4.025-2.14 0-3.851-1.655-3.851-4.05 0-2.376 1.728-4.05 3.851-4.05 2.122 0 3.833 1.677 3.833 4.075M169.88 62.85c-.422.722-1.334 1.482-2.795 1.482-1.405 0-2.058-.948-2.058-1.904v-5.276h-.946v-.185l3.346-2.656h.188v2.212h1.927l-.222.63h-1.705v5.06c0 .674.368.948.85.948.454 0 .832-.28 1.212-.556l.203.245zm-5.818-1.266c0 1.694-1.511 2.736-3.386 2.736-1.66 0-2.338-.436-2.66-.594v-2.011h.187l.887 1.686c.359.245 1.05.47 1.604.47.898 0 1.524-.434 1.524-1.195 0-.81-1.007-1.084-2.064-1.443-1.175-.394-2.215-1.031-2.215-2.389 0-1.646 1.467-2.601 3.125-2.601 1.412 0 2.016.52 2.394.426v1.937h-.173l-.907-1.48a2.314 2.314 0 0 0-1.307-.426c-1.054 0-1.548.359-1.548 1.005 0 .708.993.99 2.07 1.372 1.359.48 2.469.99 2.469 2.507m-33.106 2.573h-4.129v-.189l.395-.044c.257-.034.388-.092.388-.421v-5.1c0-.498-.28-.892-.783-.892-.662 0-1.19.57-1.19 1.12v4.795c0 .412.127.458.407.498l.376.044v.189h-4.064v-.189l.365-.06c.207-.036.35-.04.35-.435v-5.168c0-.725-.16-.951-.868-1.048v-.181l3.385-.833v1.353c.63-.594 1.426-1.339 2.546-1.339 1.401 0 2.036.844 2.036 1.96v5.256c0 .38.15.41.428.45l.358.045v.189zm-9.566-9.742c0 .722-.585 1.299-1.383 1.299-.795 0-1.365-.577-1.365-1.299 0-.726.57-1.312 1.365-1.312.798 0 1.382.586 1.382 1.312m.733 9.742h-4.123v-.189a7.34 7.34 0 0 1 .375-.044c.275-.038.415-.074.415-.438v-5.165c0-.727-.17-.967-.874-1.064v-.181l3.44-.833v7.135c0 .472.101.508.478.554l.289.036v.189zm-4.335 0h-4.14v-.189l.394-.044c.26-.034.394-.092.394-.421v-5.1c0-.498-.28-.833-.789-.833-.655 0-1.19.51-1.19 1.06v4.796c0 .412.127.458.415.498l.377.044v.189h-4.067v-.189l.367-.06c.2-.036.345-.04.345-.435v-5.168c0-.725-.167-.978-.872-1.057v-.172l3.39-.833v1.353c.631-.594 1.425-1.339 2.55-1.339 1.39 0 2.031.844 2.031 1.96v5.256c0 .38.15.41.429.45l.366.045v.189zm-8.657-6.803c0 .709-.426 1.193-1.172 1.193-.526 0-.919-.344-.919-.807 0-.156.048-.325.141-.492-.38 0-1.238.615-1.238 1.224v4.965c0 .387.143.468.455.495l.416.037v.188h-4.23v-.188l.355-.045c.35-.053.436-.092.436-.511v-5.17c0-.72-.259-.9-.876-.986v-.18l3.392-.834v1.254c.556-.75 1.346-1.254 2.06-1.254.722 0 1.18.434 1.18 1.11m-13.998 6.804h-5.085v-.189l.595-.072c.455-.055.56-.128.56-.602v-.205l-.183-7.35h-.046l-3.098 8.505h-.494l-2.996-8.456h-.04l-.1 6.64-.012.429c0 .897.241 1.015.954 1.111v.189h-2.735v-.189c.717-.136 1.074-.455 1.102-1.532l.21-7.512.009-.283c0-.45-.135-.85-.722-.916l-.475-.047v-.193h3.797l2.276 6.771h.04l2.468-6.771h3.335v.193c-.584.047-.894.208-.894.633l.017.623.294 8.322c.017.436.195.585.63.64l.593.072v.189zm59.583-3.839c0-2.738-.261-3.67-1.204-3.67-.978 0-1.21.925-1.21 3.642 0 2.56.232 3.654 1.21 3.654.943 0 1.204-1.087 1.204-3.626m2.631 0c0 2.373-1.715 4.026-3.835 4.026-2.136 0-3.846-1.66-3.846-4.054 0-2.374 1.723-4.047 3.846-4.047 2.12 0 3.835 1.68 3.835 4.075m-9.873-3.938c0-1.76-.628-2.46-1.853-2.46a3.14 3.14 0 0 0-.715.08v4.971c.12.01.222.043.67.043 1.27 0 1.898-.689 1.898-2.634m2.77.033c0 1.951-1.86 3.037-4.304 3.037-.363 0-.547.006-1.034-.027v3.882c0 .34.147.528.79.591l.461.048v.213h-5.048v-.213l.629-.073c.4-.044.538-.157.538-.52v-8.808c0-.623-.352-.768-1.167-.865v-.193h4.38c3.087 0 4.756.703 4.756 2.928m-13.465 9.64c0-.566-.463-.737-1.706-.988l-2.107-.425c-.344.288-.715.535-.715 1.324 0 .783.85 1.271 2.204 1.271 1.488 0 2.324-.605 2.324-1.182zm-1.346-7.024c0-1.753-.275-2.381-.93-2.381-.703 0-.916.628-.916 2.38 0 1.731.213 2.31.916 2.31.655 0 .93-.579.93-2.31zm3.523-2.59l-.475.956-1.291-.068c.416.394.747.89.747 1.702 0 1.647-1.54 2.774-3.434 2.774-.433 0-.947-.06-1.303-.15a.854.854 0 0 0-.124.398c0 .192.368.33.799.411l2.213.42c1.965.384 2.77.91 2.77 2.148 0 1.628-2.139 2.637-4.428 2.637-2.117 0-3.956-.374-3.956-1.54 0-.988 1.073-1.373 1.961-1.626-.71-.287-.955-.892-.955-1.324 0-.816.634-1.245 1.27-1.706-1.06-.443-1.674-1.32-1.674-2.442 0-1.633 1.546-2.82 3.427-2.82.75 0 1.207.165 1.54.313l2.913-.082zm-39.163 3.879c0-2.738-.264-3.67-1.21-3.67-.977 0-1.208.925-1.208 3.642 0 2.56.23 3.654 1.207 3.654.947 0 1.211-1.087 1.211-3.626m2.625 0c0 2.373-1.715 4.026-3.836 4.026-2.134 0-3.846-1.66-3.846-4.054 0-2.374 1.724-4.047 3.846-4.047 2.121 0 3.836 1.68 3.836 4.075M60.245 37.936h49.39V0h-49.39z", fill: "#FEFEFE" }), /* @__PURE__ */ E.createElement("path", { fill: "#ffca05", d: "M64.506 33.69H82.8V4.242H64.506z" }), /* @__PURE__ */ E.createElement("path", { fill: "#001B54", d: "M87.08 33.69h18.294V4.242H87.08z" }))), Od = /* @__PURE__ */ y(Nd, {
  target: "emqcp92"
})("display:none;inline-size:100%;block-size:auto;min-inline-size:270px;max-inline-size:320px;", (e) => e.theme.breakpoints.up("tablet"), "{display:block;}"), kd = /* @__PURE__ */ y(xd, {
  target: "emqcp91"
})("display:block;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), Md = /* @__PURE__ */ y("a", {
  target: "emqcp90"
})({
  name: "1i1khhi",
  styles: "block-size:auto;cursor:pointer;fill:#ffffff"
});
function Jr() {
  return Jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jr.apply(null, arguments);
}
const gs = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    homeAsPath: n
  } = B();
  return /* @__PURE__ */ m.createElement(Md, Jr({}, e, {
    href: n,
    onClick: (r) => {
      r.preventDefault(), t(n);
    },
    "data-qa": "logo"
  }), /* @__PURE__ */ m.createElement(Od, null), /* @__PURE__ */ m.createElement(kd, null));
};
gs.displayName = "Logo";
const Bd = () => {
  var e;
  const {
    config: t
  } = B(), n = {
    description: "Mobile sitemap display on the bottom of the page",
    links: [{
      isExternal: !0,
      label: "Digital Subscription",
      url: {
        alias: t.subscribe.host
      }
    }, {
      isExternal: !0,
      label: "Bundle Subscription",
      url: {
        alias: `${t.subscribe.host}/bundle`
      }
    }, {
      isExternal: !0,
      label: "Group Subscriptions",
      url: {
        alias: `${t.subscribe.host}/group`,
        applicationId: "group-subscriptions"
      }
    }, {
      label: "Mobile Editions",
      url: {
        alias: "/mobile"
      }
    }, {
      isExternal: !0,
      label: "ePaper",
      url: {
        alias: "/epaper"
      }
    }, {
      label: "RSS Feeds",
      url: {
        alias: "/rss"
      }
    }, {
      label: "Newsletters",
      url: {
        alias: "/newsletters"
      }
    }, {
      isExternal: !0,
      label: "Buy SCMP Photos",
      url: {
        alias: "https://photo.scmp.com/",
        applicationId: "photo"
      }
    }, {
      isExternal: !0,
      label: "Syndication & Licensing",
      url: {
        alias: "https://enterprise.scmp.com/licensing"
      }
    }],
    linksSecondary: [{
      label: "All Topics",
      url: {
        alias: "/topics"
      }
    }, {
      label: "All Authors",
      url: {
        alias: "/authors"
      }
    }, {
      isExternal: !0,
      label: "SCMP Publishers",
      url: {
        alias: "https://corp.scmp.com/",
        applicationId: "scmp-publishers"
      }
    }, {
      label: "Policies and Standards",
      url: {
        alias: "/policies-and-standards",
        entityId: "3074375",
        entityUuid: "dd1bc258-b7b9-437c-bc4c-99130d8a5a3f",
        type: nt.Page
      }
    }, {
      label: "Privacy Policy",
      url: {
        alias: "/privacy-policy",
        entityId: "800172",
        entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
        type: nt.Page
      }
    }, {
      label: "Terms & Conditions",
      url: {
        alias: "/terms-conditions",
        entityId: "800173",
        entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
        type: nt.Page
      }
    }, {
      label: "Commenting Guidelines",
      url: {
        alias: "/commenting-submission-guidelines",
        entityId: "3076709",
        entityUuid: "3460b664-d04c-44d0-83db-cec47ac0152c",
        type: nt.Page
      }
    }, {
      isExternal: !0,
      label: "Help Center",
      url: {
        alias: "https://help.scmp.com/hc",
        applicationId: "help-center"
      }
    }, {
      isExternal: !0,
      label: "Career with SCMP",
      url: {
        alias: "https://corp.scmp.com/work-for-us/",
        applicationId: "career-with-scmp"
      }
    }, {
      label: "Contact Us",
      url: {
        alias: "/contact-us",
        entityId: "800171",
        entityUuid: "b580e1d5-6698-42df-a1c2-1f7bdb2a0a04",
        type: nt.Page
      }
    }],
    name: "Mobile Footer sitemap"
  };
  return {
    desktopSitemap: {
      description: "Sitemap display on the bottom of the page.",
      name: "Footer sitemap",
      sections: [{
        label: "Products & Services",
        links: n.links
      }, {
        label: "About Us",
        links: (e = n.linksSecondary) !== null && e !== void 0 ? e : []
      }, {
        label: "Our Sites",
        links: [{
          isExternal: !0,
          label: "Young Post",
          url: {
            alias: "/yp",
            applicationId: "yp"
          }
        }, {
          isExternal: !0,
          label: "Posties",
          url: {
            alias: "/posties",
            applicationId: "posties"
          }
        }, {
          isExternal: !0,
          label: "Serviced Apartments",
          url: {
            alias: "http://www.ays.com.hk/",
            applicationId: "serviced-apartments"
          }
        }, {
          label: "SCMP Cooking",
          url: {
            alias: "/cooking",
            applicationId: "scmp-cooking"
          }
        }, {
          isExternal: !0,
          label: "Cosmopolitan",
          url: {
            alias: "https://www.cosmopolitan.com.hk",
            applicationId: "cosmopolitan"
          }
        }, {
          isExternal: !0,
          label: "ELLE",
          url: {
            alias: "https://www.elle.com.hk",
            applicationId: "elle"
          }
        }, {
          isExternal: !0,
          label: "Esquire",
          url: {
            alias: "https://www.esquirehk.com",
            applicationId: "esquire"
          }
        }, {
          label: "ELLE MEN",
          url: {
            alias: "https://www.ellemen.com.hk/ ",
            applicationId: "elle-men"
          }
        }, {
          isExternal: !0,
          label: "Harper's BAZAAR",
          url: {
            alias: "https://www.harpersbazaar.com.hk",
            applicationId: "harpers-bazaar"
          }
        }, {
          isExternal: !0,
          label: "CosMart",
          url: {
            alias: "https://www.cosmart.hk",
            applicationId: "cosmart"
          }
        }]
      }, {
        label: "Other",
        links: [{
          isExternal: !0,
          label: "Advertising+",
          url: {
            alias: "http://advertising.scmp.com/",
            applicationId: "advertising-with-us"
          }
        }, {
          isExternal: !0,
          label: "SCMP Live",
          url: {
            alias: "http://www.scmpevents.com",
            applicationId: "scmp-events"
          }
        }, {
          isExternal: !0,
          label: "Enterprise+",
          url: {
            alias: "https://enterprise.scmp.com/",
            applicationId: "enterprise"
          }
        }, {
          label: "Learn",
          url: {
            alias: "https://www.scmplearn.com/",
            applicationId: "scmp-learn"
          }
        }, {
          label: "SCMP PR Blog",
          url: {
            alias: "/topics/scmp-pr-blog",
            entityId: "512674",
            entityUuid: "b39eda92-a5a8-443c-8ebf-0d3989acb0f3",
            type: nt.Topic
          }
        }]
      }]
    },
    mobileSitemap: n
  };
}, Ud = /* @__PURE__ */ y("nav", {
  target: "eug6sto6"
})("display:flex;flex-flow:row;justify-content:flex-start;align-items:flex-start;inline-size:100%;", (e) => e.theme.breakpoints.only("tablet"), "{flex:1 1 auto;inline-size:auto;min-block-size:360px;}", (e) => e.theme.breakpoints.up("desktop"), "{flex:0.7 1 0;inline-size:auto;min-block-size:0;}"), Li = /* @__PURE__ */ y("div", {
  target: "eug6sto5"
})("display:flex;flex-flow:row;justify-content:space-between;align-items:flex-start;inline-size:100%;margin-block-start:27px;color:#ffffff;", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex:1 1 0;flex-flow:column;justify-content:flex-start;align-items:flex-start;margin-block-start:0;}"), Dd = /* @__PURE__ */ y("h3", {
  target: "eug6sto4"
})("margin:0;padding:0;font-weight:bold;font-size:14px;font-family:", q, ";line-height:16px;border:0;"), $r = /* @__PURE__ */ y("ul", {
  target: "eug6sto3"
})({
  name: "8jsgjm",
  styles: "margin:0;padding:0;border:0;list-style:none"
}), Hd = /* @__PURE__ */ y($r, {
  target: "eug6sto2"
})({
  name: "va2k03",
  styles: "text-align:end"
}), Ir = /* @__PURE__ */ y("li", {
  target: "eug6sto1"
})("margin-block-end:14px;font-size:12px;font-family:", q, ";line-height:14px;vertical-align:top;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block:10px;margin-inline:0;}"), Fd = /* @__PURE__ */ y("a", {
  target: "eug6sto0"
})({
  name: "a3w9x2",
  styles: "color:#ffffff;text-decoration:none"
});
function ea() {
  return ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ea.apply(null, arguments);
}
const vs = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = B(), {
    desktopSitemap: r,
    mobileSitemap: a
  } = Bd(), i = Et(ht.breakpoints.only("mobile"), !1), o = (l) => /* @__PURE__ */ m.createElement(Fd, {
    href: l.url.alias,
    onClick: (u) => {
      u.preventDefault(), t(l.url.alias, {
        applicationId: l.url.applicationId,
        entityId: l.url.entityId,
        entityUuid: l.url.entityUuid,
        isExternal: l.isExternal,
        type: l.url.type
      }), n({
        action: "click",
        category: "footer",
        customized_parameters: {
          destination_url: l.isExternal ? l.url.alias : `${window.location.origin}${l.url.alias}`,
          link_name: l.label
        },
        subcategory: ""
      });
    },
    "data-qa": "render-anchor"
  }, l.label), s = () => r.sections.map((l) => /* @__PURE__ */ m.createElement(Li, {
    key: l.label
  }, /* @__PURE__ */ m.createElement(Dd, null, l.label), /* @__PURE__ */ m.createElement($r, null, l.links.map((u, f) => /* @__PURE__ */ m.createElement(Ir, {
    key: f
  }, o(u)))))), c = () => {
    var l;
    return /* @__PURE__ */ m.createElement(Li, {
      "data-qa": "render-mobile-sitemap"
    }, /* @__PURE__ */ m.createElement($r, null, a.links.map((u, f) => /* @__PURE__ */ m.createElement(Ir, {
      key: f
    }, o(u)))), /* @__PURE__ */ m.createElement(Hd, null, (l = a.linksSecondary) === null || l === void 0 ? void 0 : l.map((u, f) => /* @__PURE__ */ m.createElement(Ir, {
      key: f
    }, o(u)))));
  };
  return /* @__PURE__ */ m.createElement(Ud, ea({}, e, {
    "data-qa": "sitemap"
  }), i ? c() : s());
};
vs.displayName = "Sitemap";
const Gd = "https://www.facebook.com/scmp", zd = "https://www.instagram.com/scmpnews", Vd = "https://www.linkedin.com/company/south-china-morning-post", jd = "https://www.twitter.com/scmpnews", Xd = "https://www.youtube.com/southchinamorningpost";
let xe = /* @__PURE__ */ function(e) {
  return e.Facebook = "facebook", e.Instagram = "instagram", e.Linkedin = "linkedin", e.Twitter = "twitter", e.Youtube = "youtube", e;
}({});
const Yd = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 18, viewBox: "0 0 10 18", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M2.696 18V9.95H0v-3.2h2.696V4.23C2.696 1.49 4.37 0 6.813 0 7.984 0 8.99.088 9.281.127v2.861H7.587C6.257 2.988 6 3.621 6 4.546V6.75h3l-.411 3.2H6V18" })), Wd = (e) => /* @__PURE__ */ E.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fill: "none", d: "M-3-3h24v24H-3z" }), /* @__PURE__ */ E.createElement("path", { d: "M9 1.624c2.402 0 2.687.01 3.636.052.877.04 1.353.187 1.67.31.392.144.746.374 1.036.673.3.29.53.645.673 1.036.124.317.27.794.31 1.67.043.95.053 1.234.053 3.636 0 2.403-.01 2.687-.053 3.636-.04.877-.186 1.354-.31 1.67a2.982 2.982 0 0 1-1.707 1.708c-.317.124-.794.27-1.67.31-.95.043-1.234.053-3.637.053-2.402 0-2.687-.01-3.635-.053-.877-.04-1.354-.186-1.671-.31a2.786 2.786 0 0 1-1.036-.673 2.777 2.777 0 0 1-.673-1.036c-.123-.317-.27-.793-.31-1.67-.043-.95-.052-1.233-.052-3.636 0-2.402.01-2.687.052-3.636.04-.877.187-1.353.31-1.67.144-.392.374-.746.673-1.036.29-.3.645-.53 1.036-.673.317-.124.794-.27 1.67-.31.95-.043 1.234-.052 3.636-.052H9zM9.001 0c-2.443 0-2.75.01-3.71.055C4.333.1 3.68.253 3.108.475c-.6.226-1.144.58-1.594 1.038-.458.45-.812.994-1.038 1.594C.253 3.68.101 4.334.057 5.291.014 6.25.003 6.556.003 9s.01 2.75.054 3.71.196 1.611.418 2.183c.226.6.58 1.144 1.038 1.593.45.458.994.813 1.594 1.039.572.222 1.227.374 2.184.418.958.043 1.266.054 3.71.054 2.443 0 2.75-.01 3.71-.054.959-.044 1.61-.196 2.182-.418a4.598 4.598 0 0 0 2.632-2.632c.222-.572.374-1.227.418-2.184.043-.958.054-1.266.054-3.71 0-2.443-.01-2.75-.054-3.71-.044-.959-.196-1.61-.418-2.182a4.411 4.411 0 0 0-1.038-1.593A4.417 4.417 0 0 0 14.893.475C14.32.253 13.666.101 12.709.057 11.75.014 11.444.003 9 .003L9.001 0z" }), /* @__PURE__ */ E.createElement("path", { d: "M9 4.38a4.62 4.62 0 1 0 0 9.24 4.62 4.62 0 0 0 0-9.24zM9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" }), /* @__PURE__ */ E.createElement("circle", { cx: 13.803, cy: 4.197, r: 1.08 })), Qd = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, viewBox: "0 0 21 20", ...e }, /* @__PURE__ */ E.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M4.846 6.611V19.75H.482V6.611h4.364zm.279-4.086c0 .681-.217 1.223-.65 1.625-.495.433-1.099.65-1.811.65-.743 0-1.331-.217-1.764-.65-.433-.402-.65-.944-.65-1.625S.467 1.302.9.9C1.395.467 1.999.25 2.711.25c.681 0 1.269.217 1.764.65.433.433.65.975.65 1.625zm15.461 9.657v7.568h-4.364v-7.057c0-.929-.17-1.656-.511-2.182-.371-.526-.929-.789-1.671-.789-.526 0-.99.155-1.393.464-.402.31-.696.696-.882 1.161-.093.248-.139.604-.139 1.068v7.336H7.262c.031-2.352.046-5.215.046-8.589V7.216l-.046-.604h4.364v1.904c.31-.464.48-.712.511-.743.155-.217.418-.449.789-.696.31-.248.681-.449 1.114-.604.402-.124.913-.186 1.532-.186 1.517 0 2.739.495 3.668 1.486.898.99 1.346 2.461 1.346 4.411z" })), Zd = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 17, viewBox: "0 0 20 17", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M20 2c-.6.8-1.3 1.5-2 2v.6c0 1.2-.2 2.3-.5 3.3C17.2 9 16.7 10 16 11c-.5.9-1.3 1.8-2.3 2.7-1 .8-2.1 1.4-3.3 1.9-1.2.4-2.6.7-4.1.7-2.3 0-4.4-.7-6.3-1.9.4.1.7.1 1 .1 1.8 0 3.6-.6 5.1-1.8-.9 0-1.7-.3-2.4-.8s-1.2-1.2-1.5-2c.4 0 .7.1.8.1.4 0 .8-.1 1.1-.2-.9-.2-1.7-.7-2.4-1.4-.6-.8-.9-1.6-.9-2.6v-.1c.6.4 1.2.5 1.9.5-.6-.3-1-.8-1.4-1.4-.3-.6-.5-1.2-.5-2 0-.7.2-1.4.6-2 1 1.2 2.3 2.2 3.7 3 1.5.7 3.1 1.2 4.8 1.3-.1-.4-.2-.7-.2-1 0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 3-1.2s2.2.4 3 1.3c.9-.2 1.8-.5 2.6-1-.3 1-.9 1.7-1.8 2.3.7-.1 1.5-.3 2.3-.6z" })), Kd = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 18, viewBox: "0 0 25 18", ...e }, /* @__PURE__ */ E.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M16.99 9.71c.284-.158.426-.395.426-.71 0-.316-.142-.553-.426-.71l-6.914-4.357c-.284-.189-.584-.189-.9 0-.284.158-.426.41-.426.758v8.619c0 .347.142.6.426.758a.69.69 0 0 0 .426.142.912.912 0 0 0 .474-.142l6.914-4.357zm7.341-2.747v4.073c0 .474-.047 1.089-.142 1.847-.032.758-.126 1.421-.284 1.989a3.243 3.243 0 0 1-.947 1.658c-.442.442-.995.71-1.658.805-2.368.221-5.399.332-9.093.332s-6.725-.111-9.093-.332c-.663-.095-1.216-.363-1.658-.805a3.236 3.236 0 0 1-.947-1.658c-.158-.568-.253-1.231-.284-1.989a15.477 15.477 0 0 1-.142-1.847V6.963c0-.474.047-1.089.142-1.847.032-.758.126-1.421.284-1.989a3.243 3.243 0 0 1 .947-1.658c.442-.442.995-.71 1.658-.805C5.482.443 8.513.332 12.207.332s6.725.111 9.093.332c.663.095 1.216.363 1.658.805.474.442.789.995.947 1.658.158.568.253 1.231.284 1.989.095.758.142 1.373.142 1.847z" })), hs = /* @__PURE__ */ y("div", {
  target: "eapy92n1"
})({
  name: "16cp6bs",
  styles: "display:inline-block;inline-size:22px;max-block-size:22px;margin-inline-start:20px;svg{inline-size:23px;block-size:23px;fill:#ffffff;}"
}), qd = /* @__PURE__ */ y("div", {
  target: "eapy92n0"
})("display:flex;", hs, ":first-child{margin-inline-start:0;}");
function ta() {
  return ta = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ta.apply(null, arguments);
}
const Es = ({
  ...e
}) => {
  const {
    handleTrackGA4: t
  } = B(), n = {
    [xe.Facebook]: {
      icon: Yd,
      url: Gd
    },
    [xe.Instagram]: {
      icon: Wd,
      url: zd
    },
    [xe.Linkedin]: {
      icon: Qd,
      url: Vd
    },
    [xe.Twitter]: {
      icon: Zd,
      url: jd
    },
    [xe.Youtube]: {
      icon: Kd,
      url: Xd
    }
  }, r = (a) => {
    const {
      icon: i,
      url: o
    } = n[a];
    return /* @__PURE__ */ m.createElement(hs, {
      key: a,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ m.createElement("a", {
      href: o,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Follow SCMP",
      onClick: () => {
        t({
          action: "click",
          category: "footer",
          customized_parameters: {
            destination_url: o,
            link_name: a,
            social_platform: a
          },
          subcategory: ""
        });
      }
    }, /* @__PURE__ */ m.createElement(i, null)));
  };
  return /* @__PURE__ */ m.createElement(qd, ta({}, e, {
    "data-qa": "social-media"
  }), [xe.Facebook, xe.Twitter, xe.Youtube, xe.Instagram, xe.Linkedin].map((a) => r(a)));
};
Es.displayName = "SocialMedia";
async function Jd(e) {
  const t = await Vn.post("/piano/renew", {
    subscriptionId: e
  }), {
    code: n,
    data: r
  } = t.data;
  return n === 0 && r === !0;
}
const _e = /* @__PURE__ */ y("button", {
  target: "e1uch9rj1"
})("padding-block:8px;padding-inline:12px;color:#001246;font-size:14px;font-family:", Rt, ";line-height:16px;white-space:nowrap;text-align:center;text-transform:uppercase;border-radius:2px;background:#ffca05;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{padding-block:6px;padding-inline:10px;}"), $d = /* @__PURE__ */ y("span", {
  target: "e1uch9rj0"
})((e) => {
  switch (e.$variant) {
    case "dark":
      return /* @__PURE__ */ jt(_e, "{color:#ffffff;background:#222222;}", "");
    case "dark-blue":
      return /* @__PURE__ */ jt(_e, "{color:#ffffff;font-weight:700;background:#001246;}", "");
    case "light-blue":
      return /* @__PURE__ */ jt(_e, "{padding-block:7px;padding-inline:8px;color:#ffffff;background:#4585ff;}", "");
    default:
      return null;
  }
}, ";"), As = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = B(), {
    computeGA4CommonParameters: r
  } = st(), [a, i] = ve(!1);
  ne(() => {
    n != null && n.rulesEngine.getOutcome("user.autoRenewEnabled") || i(!0);
  }, [n == null ? void 0 : n.rulesEngine]);
  const {
    captureTrackImpressionEventTargetElement: o
  } = $t({
    ga4Event: te(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "enable auto-renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r]),
    gaEvent: te(() => ({
      action: "Enable Auto Renew/Masthead/Impression",
      category: "Enable Auto Renew",
      label: window.location.href
    }), [])
  });
  return a ? /* @__PURE__ */ m.createElement(_e, {
    className: e,
    ref: o,
    onClick: () => {
      (async () => {
        const c = n == null ? void 0 : n.rulesEngine.getOutcome("user.autoRenewSubscriptionId");
        t({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...r(),
            call_to_action: "enable auto-renew",
            trigger_point: "masthead enable auto-renew button"
          },
          subcategory: "entry_point"
        }), !(!c || !await Jd(c)) && (window.postMessage({
          type: "PIANO_AUTORENEW_CONFIRMATION"
        }, "*"), n == null || n.rulesEngine.addRule(new n.Rule("user.autoRenewEnabled").priority(10).when(() => !0).then(!0)), await (n == null ? void 0 : n.rulesEngine.run()), i(!1));
      })();
    },
    "data-qa": "auto-renew-button"
  }, "Enable Auto-renew") : null;
};
As.displayName = "AutoRenewButton";
const e3 = (e) => /* @__PURE__ */ E.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M12 16.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z", fill: "#EB4254", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ E.createElement("path", { d: "M12 13.5V5.25", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ E.createElement("path", { d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Z", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ E.createElement("circle", { cx: 12, cy: 17, r: 1, fill: "#EB4254" })), t3 = /* @__PURE__ */ y(_e, {
  target: "e7roqsw1"
})("display:flex;color:#eb4254;border:1px solid #eb4254;background:#fff6f7;", (e) => e.theme.breakpoints.up("tablet"), "{border-radius:2px;}"), n3 = /* @__PURE__ */ y(e3, {
  target: "e7roqsw0"
})("inline-size:17.5px;margin-inline-end:5px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline-end:9px;}"), Cs = ({
  className: e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = B(), {
    computeGA4CommonParameters: r
  } = st(), {
    captureTrackImpressionEventTargetElement: a
  } = $t({
    ga4Event: te(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "update payment",
        trigger_point: "masthead grace period renewal failure banner"
      },
      subcategory: "entry_point"
    }), [r]),
    gaEvent: te(() => ({
      action: "Subscription Grace Period/Masthead/Renewal Failed/Impression",
      category: "Subscription Grace Period",
      label: window.location.href
    }), [])
  });
  return /* @__PURE__ */ m.createElement(t3, {
    className: e,
    ref: a,
    onClick: () => {
      n({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/settings`;
    },
    "data-qa": "grace-period-button"
  }, /* @__PURE__ */ m.createElement(n3, null), "Renewal Failed");
};
Cs.displayName = "GracePeriodButton";
const bs = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a,
    handleTrackMixPanel: i
  } = B(), {
    computeGA4CommonParameters: o
  } = st(), {
    captureTrackImpressionEventTargetElement: s
  } = $t({
    ga4Event: null,
    gaEvent: te(() => ({
      action: "Reactivate/Masthead/Impression",
      category: "Reactivate",
      label: window.location.href
    }), [])
  });
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    ref: s,
    onClick: () => {
      i({
        name: "Subscription Entry Point",
        property: {
          Location: `${r === ue.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const c = (() => {
        if (t === "masthead")
          return "masthead reactivation button";
        switch (r) {
          case ue.Article:
            return "article footer";
          case ue.Homepage:
            return "homepage footer";
          case ue.Section:
            return "section footer";
          default:
            return "footer";
        }
      })();
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...o(),
          call_to_action: "reactivation",
          trigger_point: c
        },
        subcategory: "entry_point"
      }), window.location.href = `${n.subscribe.host}/?product=winback`;
    },
    "data-qa": "reactivate-button"
  }, "Reactivate Access");
};
bs.displayName = "ReactivateButton";
const ys = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = B(), {
    computeGA4CommonParameters: r
  } = st(), {
    captureTrackImpressionEventTargetElement: a,
    intersection: i
  } = $t({
    ga4Event: te(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r]),
    gaEvent: null
  });
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    ref: a,
    onClick: () => {
      var o, s;
      t({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button"
        },
        subcategory: "entry_point"
      });
      const c = n == null || (o = n.rulesEngine.getOutcome("user")) === null || o === void 0 ? void 0 : o.expiryReminder, {
        bottom: l,
        left: u,
        right: f,
        top: d
      } = (s = i == null ? void 0 : i.boundingClientRect) !== null && s !== void 0 ? s : {};
      window.postMessage({
        bottom: l,
        expiryReminder: c,
        left: u,
        right: f,
        top: d,
        type: "PIANO_RENEW_POPUP"
      }, "*");
    },
    "data-qa": "renew-button"
  }, "Renew & Save");
};
ys.displayName = "RenewButton";
const ka = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a,
    handleTrackGTM: i,
    handleTrackMixPanel: o
  } = B(), {
    computeGA4CommonParameters: s
  } = st();
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    onClick: () => {
      o({
        name: "Subscription Entry Point",
        property: {
          Location: (() => {
            switch (t) {
              case "footer":
                return "Homepage Footer";
              case "print-button":
                return "Print Icon Pop-up";
              case "masthead":
                return r === ue.Article ? "Article Masthead" : "Homepage Masthead";
            }
          })()
        }
      });
      const c = {
        action: (() => {
          switch (t) {
            case "footer":
              return "Subscription Entry Point/Footer";
            case "print-button":
              return "Subscription Entry Point/Print Icon Pop-up/Click Subscribe";
            case "masthead":
              return r === ue.Article ? "Subscription Entry Point/Article Page Masthead" : "Subscription Entry Point/Masthead";
          }
        })(),
        category: "Subscription Entry Point",
        label: window.location.href
      };
      i({
        event: "subscribe-button",
        tracking: c
      }), a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...s(),
          call_to_action: "subscribe",
          trigger_point: (() => {
            switch (t) {
              case "footer":
                switch (r) {
                  case ue.Article:
                    return "article footer";
                  case ue.Section:
                    return "section footer";
                  case ue.Homepage:
                    return "homepage footer";
                  default:
                    return "footer";
                }
              case "masthead":
                return r === ue.Article ? "article masthead" : "masthead";
              case "print-button":
                return "print article";
            }
          })()
        },
        subcategory: "entry_point"
      }), window.location.href = n.subscribe.host;
    },
    "data-qa": "subscribe-button"
  }, "Subscribe");
};
ka.displayName = "SubscribeButton";
const Is = ({
  className: e
}) => {
  const {
    config: t,
    currentPageType: n,
    handleTrackGA4: r,
    handleTrackGTM: a,
    handleTrackMixPanel: i
  } = B(), {
    computeGA4CommonParameters: o
  } = st(), {
    captureTrackImpressionEventTargetElement: s
  } = $t({
    ga4Event: te(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...o(),
        call_to_action: "upgrade",
        trigger_point: n === ue.Article ? "article masthead upgrade button" : "masthead"
      },
      subcategory: "entry_point"
    }), [o, n]),
    gaEvent: te(() => ({
      action: n === ue.Article ? "Upgrade Entry Point/Article Page Masthead/Impression" : "Upgrade Entry Point/Masthead/Impression",
      category: "Upgrade Entry Point",
      label: window.location.href
    }), [n])
  });
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    ref: s,
    onClick: () => {
      i({
        name: "Subscription Entry Point",
        property: {
          Location: `${n === ue.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const c = {
        action: `Upgrade Entry Point/${n === ue.Article ? "Article Page Masthead" : "Masthead"}/Click`,
        category: "Upgrade Entry Point",
        label: window.location.href
      };
      a({
        event: "upgrade-button",
        tracking: c
      }), r({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...o(),
          call_to_action: "upgrade",
          trigger_point: n === ue.Article ? "article masthead upgrade button" : "masthead"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/manage/subscription?upgrade=true`, window.postMessage({
        type: "PIANO_UPGRADE_POPUP"
      }, "*");
    },
    "data-qa": "upgrade-button"
  }, "Upgrade & Save");
};
Is.displayName = "UpgradeButton";
const ws = ({
  className: e
}) => {
  const {
    handleTrackGA4: t
  } = B();
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    onClick: () => {
      t({
        action: "click",
        category: "plus",
        subcategory: "masthead"
      });
      const n = new URL("/plus", location.origin), r = new URL(location.href).searchParams;
      n.search = r.toString(), window.location.href = n.toString();
    },
    "data-qa": "scmp-plus-button"
  }, "SCMP ", /* @__PURE__ */ m.createElement("i", null, "Plus"));
};
ws.displayName = "ScmpPlusButton";
const Rs = ({
  className: e
}) => {
  const {
    currentPageType: t,
    handleTrackGA4: n,
    handleTrackGTM: r,
    handleTrackMixPanel: a
  } = B(), {
    computeGA4CommonParameters: i
  } = st();
  return /* @__PURE__ */ m.createElement(_e, {
    className: e,
    onClick: () => {
      a({
        name: "Subscription Entry Point",
        property: {
          Location: `${t === ue.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const o = {
        action: "Masthead/Read Epaper",
        category: "Masthead",
        label: window.location.href
      };
      r({
        event: "epaper-button",
        tracking: o
      }), n({
        action: "click",
        category: "epaper",
        customized_parameters: {
          call_to_action: "read epaper",
          ...i(),
          trigger_point: "masthead"
        },
        subcategory: ""
      }), window.location.href = "/epaper";
    },
    "data-qa": "epaper-button"
  }, "Read ePaper");
};
Rs.displayName = "EpaperButton";
const r3 = ({
  className: e,
  location: t = "masthead",
  variant: n
}) => {
  const {
    rosettaInstance: r
  } = B(), a = Et(ht.breakpoints.only("mobile"), !1), i = r == null ? void 0 : r.rulesEngine.getOutcome("ui.masthead.button"), o = we(() => i == null ? void 0 : i.getDisplayVariant({
    shouldIncludeEpaper: !0,
    shouldIncludeScmpPlus: !a
  }), [a, i]), s = we(() => o === "SCMPPLUS" ? "dark-blue" : n, [o, n]), c = () => {
    switch (o) {
      case "AUTORENEW":
        return /* @__PURE__ */ m.createElement(As, {
          className: e
        });
      case "GRACEPERIOD":
        return /* @__PURE__ */ m.createElement(Cs, {
          className: e
        });
      case "REACTIVATE":
        return /* @__PURE__ */ m.createElement(bs, {
          className: e,
          location: t
        });
      case "RENEW":
        return /* @__PURE__ */ m.createElement(ys, {
          className: e
        });
      case "SUBSCRIBE":
        return /* @__PURE__ */ m.createElement(ka, {
          className: e,
          location: t
        });
      case "UPGRADE":
        return /* @__PURE__ */ m.createElement(Is, {
          className: e
        });
      case "EPAPER":
        return /* @__PURE__ */ m.createElement(Rs, {
          className: e
        });
      case "SCMPPLUS":
        return /* @__PURE__ */ m.createElement(ws, {
          className: e
        });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ m.createElement($d, {
    $variant: s,
    "data-qa": "subscription-button"
  }, c());
};
r3.displayName = "SubscriptionButton";
const a3 = /* @__PURE__ */ y("div", {
  target: "e1smqk2m4"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;margin-block-end:16px;color:#d2d2d2;font-size:14px;font-family:", q, ";", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex-flow:row;justify-content:flex-start;align-items:center;}"), i3 = /* @__PURE__ */ y("div", {
  target: "e1smqk2m3"
})("display:flex;flex-flow:column;flex-grow:1;justify-content:center;align-items:center;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex-flow:column;justify-content:flex-start;align-items:flex-start;margin-inline-end:19px;text-align:start;}", (e) => e.theme.breakpoints.up("mediumDesktop"), "{margin-inline-end:38px;}"), o3 = /* @__PURE__ */ y("div", {
  target: "e1smqk2m2"
})({
  name: "643dng",
  styles: "display:inline-block;padding-block-start:16px;font-weight:bold;line-height:16px;border-block-start:1px solid #484848"
}), s3 = /* @__PURE__ */ y("div", {
  target: "e1smqk2m1"
})({
  name: "su6pk1",
  styles: "margin-block-start:4px;line-height:16px"
}), c3 = /* @__PURE__ */ y("div", {
  target: "e1smqk2m0"
})("flex-shrink:1;margin-block-start:16px;", (e) => e.theme.breakpoints.up("desktop"), "{margin-block-start:0;}");
function na() {
  return na = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, na.apply(null, arguments);
}
const Ts = ({
  ...e
}) => /* @__PURE__ */ m.createElement(a3, na({}, e, {
  "data-qa": "subscription-widget"
}), /* @__PURE__ */ m.createElement(i3, null, /* @__PURE__ */ m.createElement(o3, null, "Subscribe to the SCMP"), /* @__PURE__ */ m.createElement(s3, null, "Critical insights and analysis on China that matter to the world")), /* @__PURE__ */ m.createElement(c3, null, /* @__PURE__ */ m.createElement(ka, {
  location: "footer"
})));
Ts.displayName = "SubscriptionWidget";
const Ss = /* @__PURE__ */ y(gs, {
  target: "e1x94w6213"
})(""), _s = /* @__PURE__ */ y(Es, {
  target: "e1x94w6212"
})(""), Ps = /* @__PURE__ */ y(Ts, {
  target: "e1x94w6211"
})(""), Ls = /* @__PURE__ */ y(hu, {
  target: "e1x94w6210"
})("padding-block:16px;padding-inline:0;border-block-start:1px solid #484848;border-block-end:1px solid #484848;", (e) => e.theme.breakpoints.only("tablet"), "{border-block-end:0;}"), Ns = /* @__PURE__ */ y("div", {
  target: "e1x94w629"
})((e) => e.theme.breakpoints.up("desktop"), "{margin-block-start:22px;}"), xs = /* @__PURE__ */ y(vs, {
  target: "e1x94w628"
})(""), l3 = /* @__PURE__ */ y("div", {
  target: "e1x94w627"
})('display:grid;grid-template-areas:"Logo" "SocialMedia";row-gap:30px;justify-items:center;padding-block-end:20px;', Ss, "{grid-area:Logo;}", _s, "{grid-area:SocialMedia;}", (e) => e.theme.breakpoints.up("tablet"), '{grid-template-areas:"Logo . SocialMedia";grid-template-columns:max-content 1fr;justify-items:unset;padding-block-end:40px;}'), u3 = /* @__PURE__ */ y("div", {
  target: "e1x94w626"
})({
  name: "1vcob1d",
  styles: "display:flex;justify-content:center;align-items:center"
});
var d3 = {
  name: "rh8ts9",
  styles: 'grid-template-areas:"Newsletter DownloadApp"'
}, p3 = {
  name: "iyfgxq",
  styles: 'grid-template-areas:"Subscription DownloadApp" "Newsletter . "'
};
const Os = /* @__PURE__ */ y("div", {
  target: "e1x94w625"
})(Ps, "{grid-area:Subscription;}", Ls, "{grid-area:Newsletter;}", Ns, "{grid-area:DownloadApp;}", (e) => e.theme.breakpoints.up("tablet"), "{display:inline-grid;max-inline-size:396px;>div{max-inline-size:396px;}}", (e) => e.theme.breakpoints.only("tablet"), "{grid-template-rows:repeat(2, min-content);grid-template-columns:396px max-content;justify-content:space-between;align-items:center;max-inline-size:unset;margin-block-end:24px;border-block-end:1px #484848 solid;", (e) => e.$isShowSubscription ? p3 : d3, ";}", (e) => e.theme.breakpoints.up("desktop"), '{grid-template:"Subscription" min-content "Newsletter" min-content "DownloadApp" min-content/fit-content(100%);inline-size:auto;margin-inline-end:30px;}'), f3 = /* @__PURE__ */ y("div", {
  target: "e1x94w624"
})("inline-size:100%;", Os, "{grid-area:Widget;}", xs, "{grid-area:Sitemap;}", (e) => e.theme.breakpoints.only("tablet"), '{display:grid;grid-template-areas:"Widget" "Sitemap";}', (e) => e.theme.breakpoints.up("desktop"), '{display:grid;grid-template-areas:"Widget Sitemap" "Widget Sitemap" "Widget Sitemap";grid-template-columns:30% 1fr;}'), m3 = /* @__PURE__ */ y("div", {
  target: "e1x94w623"
})((e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:32px;}"), g3 = /* @__PURE__ */ y("p", {
  target: "e1x94w622"
})("color:#ffffff;font-size:9px;font-family:", q, ";line-height:10px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{color:#cccccc;font-size:14px;line-height:16px;text-align:start;}"), v3 = /* @__PURE__ */ y("div", {
  target: "e1x94w621"
})("margin-block:0;margin-inline:auto;", Fu(), ";"), h3 = /* @__PURE__ */ y("div", {
  target: "e1x94w620"
})("padding-block:32px;padding-inline:0;background-color:#222222;overflow:hidden;", (e) => e.theme.breakpoints.up("tablet"), "{padding-block:32px 17px;}");
function ra() {
  return ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ra.apply(null, arguments);
}
const ks = ({
  printEditionFooterConfig: e,
  ...t
}) => {
  const {
    currentPageType: n,
    handleTrackGA4: r,
    isShowSubscription: a
  } = B(), i = te(() => ({
    action: "imp",
    category: "appdl",
    customized_parameters: {
      page_type: n,
      position: "footer",
      ..._1() && {
        inapp_browser: "fb"
      }
    },
    subcategory: ""
  }), [n]), {
    captureTrackImpressionEventTargetElement: o
  } = Su({
    ga4TrackingHandler: r,
    getGa4Event: i,
    options: {
      isSendGA4Tracking: !0,
      shouldSendOnce: !0
    }
  });
  return /* @__PURE__ */ m.createElement(h3, {
    "data-qa": "base-footer"
  }, /* @__PURE__ */ m.createElement(v3, null, /* @__PURE__ */ m.createElement(l3, null, /* @__PURE__ */ m.createElement(Ss, null), /* @__PURE__ */ m.createElement(_s, null)), (e == null ? void 0 : e.isEnabled) && /* @__PURE__ */ m.createElement(u3, null, /* @__PURE__ */ m.createElement(es, {
    config: e
  })), /* @__PURE__ */ m.createElement(f3, null, /* @__PURE__ */ m.createElement(Os, {
    $isShowSubscription: a
  }, a && /* @__PURE__ */ m.createElement(Ps, null), /* @__PURE__ */ m.createElement(Ls, ra({}, t, {
    variant: Eu.Footer
  })), /* @__PURE__ */ m.createElement(Ns, {
    ref: o
  }, /* @__PURE__ */ m.createElement(K1, null))), /* @__PURE__ */ m.createElement(xs, null)), /* @__PURE__ */ m.createElement(m3, null, /* @__PURE__ */ m.createElement(g3, null, "Copyright © ", (/* @__PURE__ */ new Date()).getFullYear(), " South China Morning Post Publishers Ltd. All rights reserved."))));
};
ks.displayName = "BaseFooter";
var E3 = m, A3 = E3.createContext({
  wrapPrepareQueryResource: function(t) {
    return t();
  }
}), rr = A3, C3 = m, b3 = oe, y3 = b3.__internal.createRelayContext, Ms = y3(C3), I3 = function(e, t, n, r, a, i, o, s) {
  if (!e) {
    var c;
    if (t === void 0)
      c = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var l = [n, r, a, i, o, s], u = 0;
      c = new Error(
        t.replace(/%s/g, function() {
          return l[u++];
        })
      ), c.name = "Invariant Violation";
    }
    throw c.framesToPop = 1, c;
  }
}, Ve = I3, w3 = Ms, R3 = Ve, T3 = m, S3 = T3.useContext;
function _3() {
  var e = S3(w3);
  return e == null && R3(!1), e.environment;
}
var Ae = _3;
function ar(e) {
  return function() {
    return e;
  };
}
var _t = function() {
};
_t.thatReturns = ar;
_t.thatReturnsFalse = ar(!1);
_t.thatReturnsTrue = ar(!0);
_t.thatReturnsNull = ar(null);
_t.thatReturnsThis = function() {
  return this;
};
_t.thatReturnsArgument = function(e) {
  return e;
};
var P3 = rr, L3 = Ae, N3 = m, Bs = m, x3 = Bs.useContext, O3 = Bs.useEffect;
function k3(e) {
  var t = e.entryPointReference, n = e.props, r = t.getComponent, a = t.queries, i = t.entryPoints, o = t.extraProps, s = t.rootModuleID, c = r(), l = x3(P3), u = L3();
  return O3(function() {
    u.__log({
      name: "entrypoint.root.consume",
      profilerContext: l,
      rootModuleID: s
    });
  }, [u, l, s]), /* @__PURE__ */ N3.createElement(c, {
    entryPoints: i,
    extraProps: o,
    props: n,
    queries: a
  });
}
var M3 = k3, Us = { exports: {} }, Ds = { exports: {} }, Hs = { exports: {} }, Fs = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Fs);
var Gs = Fs.exports, zs = { exports: {} };
(function(e) {
  var t = Gs.default;
  function n(r, a) {
    if (t(r) != "object" || !r) return r;
    var i = r[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(r, a || "default");
      if (t(o) != "object") return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(zs);
var B3 = zs.exports;
(function(e) {
  var t = Gs.default, n = B3;
  function r(a) {
    var i = n(a, "string");
    return t(i) == "symbol" ? i : i + "";
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Hs);
var U3 = Hs.exports;
(function(e) {
  var t = U3;
  function n(r, a, i) {
    return (a = t(a)) in r ? Object.defineProperty(r, a, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[a] = i, r;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Ds);
var ir = Ds.exports;
(function(e) {
  var t = ir;
  function n(a, i) {
    var o = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(a);
      i && (s = s.filter(function(c) {
        return Object.getOwnPropertyDescriptor(a, c).enumerable;
      })), o.push.apply(o, s);
    }
    return o;
  }
  function r(a) {
    for (var i = 1; i < arguments.length; i++) {
      var o = arguments[i] != null ? arguments[i] : {};
      i % 2 ? n(Object(o), !0).forEach(function(s) {
        t(a, s, o[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function(s) {
        Object.defineProperty(a, s, Object.getOwnPropertyDescriptor(o, s));
      });
    }
    return a;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Us);
var ut = Us.exports, D3 = Ee.default, Ni = D3(ut), H3 = Ve, Vs = m, Je = oe, xi = Je.__internal.fetchQueryDeduped, Oi = Je.Observable, ki = Je.PreloadableQueryRegistry, Mi = Je.RelayFeatureFlags, Bi = Je.ReplaySubject, Ui = Je.createOperationDescriptor, F3 = Je.getRequest, G3 = Je.getRequestIdentifier, Di = null, Hi = 100001;
function z3() {
  if (Di === null) {
    var e, t;
    Di = (e = Vs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || e === void 0 || (t = e.ReactCurrentDispatcher) === null || t === void 0 ? void 0 : t.current;
  }
}
function V3(e, t, n, r, a) {
  var i, o, s;
  (i = Vs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (o = i.ReactCurrentDispatcher) === null || o === void 0 || o.current, Hi++;
  var c = (s = r == null ? void 0 : r.fetchPolicy) !== null && s !== void 0 ? s : "store-or-network", l = (0, Ni.default)((0, Ni.default)({}, r == null ? void 0 : r.networkCacheConfig), {}, {
    force: !0
  }), u, f = !1, d = function(Y, J) {
    return f = !0, e.executeWithSource({
      operation: Y,
      source: J
    });
  }, v = new Bi(), g = Oi.create(function(X) {
    return v.subscribe(X);
  }), p, h = null, A = !1, C = function(Y) {
    A = !0;
    var J, W = new Bi();
    if (Mi.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === !0) {
      var Q = "raw-network-request-" + G3(Y, n);
      J = xi(e, Q, function() {
        var Z = e.getNetwork();
        return Z.execute(Y, n, l);
      });
    } else {
      var re = e.getNetwork();
      J = re.execute(Y, n, l);
    }
    var Le = J.subscribe({
      error: function(Ne) {
        h = Ne, W.error(Ne);
      },
      next: function(Ne) {
        W.next(Ne);
      },
      complete: function() {
        W.complete();
      }
    }), ce = Le.unsubscribe;
    return p = ce, Oi.create(function(Z) {
      var Ne = W.subscribe(Z);
      return function() {
        Ne.unsubscribe(), p();
      };
    });
  }, b, I = function(Y, J) {
    Mi.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === !0 && (A = !0);
    var W = xi(e, Y.request.identifier, J).subscribe({
      error: function(re) {
        v.error(re);
      },
      next: function(re) {
        v.next(re);
      },
      complete: function() {
        v.complete();
      }
    });
    b = W.unsubscribe;
  }, w = function(Y) {
    var J = Ui(Y, n, l);
    if (u = e.retain(J), c !== "store-only") {
      var W = c !== "store-or-network" || e.check(J).status !== "available";
      W && I(J, function() {
        var Q = C(Y.params), re = d(J, Q);
        return re;
      });
    }
  }, R, T, S;
  if (t.kind === "PreloadableConcreteRequest") {
    var P = t;
    R = P.params;
    var _ = R;
    S = _.id, S === null && H3(!1);
    var N = ki.get(S);
    if (N != null)
      w(N);
    else {
      var L = c === "store-only" ? null : C(R), x = ki.onLoad(S, function(X) {
        T();
        var Y = Ui(X, n, l);
        u = e.retain(Y), L != null && I(Y, function() {
          return d(Y, L);
        });
      });
      T = x.dispose;
    }
  } else {
    var k = t, O = F3(k);
    R = O.params, S = R.cacheID != null ? R.cacheID : R.id, w(O);
  }
  var M = !1, D = !1, F = !1, V = function() {
    D || (u && u.dispose(), D = !0);
  }, ee = function() {
    F || (f ? b && b() : p && p(), T && T(), F = !0);
  };
  return {
    kind: "PreloadedQuery",
    environment: e,
    environmentProviderOptions: a,
    dispose: function() {
      M || (V(), ee(), M = !0);
    },
    releaseQuery: V,
    cancelNetworkRequest: ee,
    fetchKey: Hi,
    id: S,
    get isDisposed() {
      return M || D;
    },
    get networkError() {
      return h;
    },
    name: R.name,
    networkCacheConfig: l,
    fetchPolicy: c,
    source: A ? g : void 0,
    variables: n
  };
}
var dt = {
  loadQuery: V3,
  useTrackLoadQueryInRender: z3
}, j3 = dt, X3 = j3.loadQuery;
function js(e, t, n) {
  var r = null;
  t.root.getModuleIfRequired() == null && (r = t.root.load());
  var a = t.getPreloadProps(n), i = a.queries, o = a.entryPoints, s = a.extraProps, c = {}, l = {};
  if (i != null) {
    var u = Object.keys(i);
    u.forEach(function(v) {
      var g = i[v], p = g.environmentProviderOptions, h = g.options, A = g.parameters, C = g.variables, b = e.getEnvironment(p);
      c[v] = X3(b, A, C, {
        fetchPolicy: h == null ? void 0 : h.fetchPolicy,
        networkCacheConfig: h == null ? void 0 : h.networkCacheConfig,
        __nameForWarning: "loadEntryPoint"
      }, p);
    });
  }
  if (o != null) {
    var f = Object.keys(o);
    f.forEach(function(v) {
      var g = o[v];
      if (g != null) {
        var p = g.entryPoint, h = g.entryPointParams;
        l[v] = js(e, p, h);
      }
    });
  }
  var d = !1;
  return {
    dispose: function() {
      d || (c != null && Object.values(c).forEach(function(g) {
        var p = g.dispose;
        p();
      }), l != null && Object.values(l).forEach(function(g) {
        var p = g.dispose;
        p();
      }), d = !0);
    },
    entryPoints: l,
    extraProps: s ?? null,
    getComponent: function() {
      var g = t.root.getModuleIfRequired();
      if (g == null) {
        var p;
        throw r = (p = r) !== null && p !== void 0 ? p : t.root.load(), r;
      }
      var h = g.default != null ? g.default : g;
      return h;
    },
    get isDisposed() {
      return d;
    },
    queries: c,
    rootModuleID: t.root.getModuleId()
  };
}
var Xs = js, Y3 = Ms, Ys = m, W3 = Ys.useMemo;
function Q3(e) {
  var t = e.children, n = e.environment, r = e.getEnvironmentForActor, a = W3(function() {
    return {
      environment: n,
      getEnvironmentForActor: r
    };
  }, [n, r]);
  return /* @__PURE__ */ Ys.createElement(Y3.Provider, {
    value: a
  }, t);
}
var Z3 = Q3, Ws = { exports: {} }, Qs = { exports: {} }, Zs = { exports: {} };
(function(e) {
  function t(n, r) {
    (r == null || r > n.length) && (r = n.length);
    for (var a = 0, i = Array(r); a < r; a++) i[a] = n[a];
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Zs);
var Ks = Zs.exports;
(function(e) {
  var t = Ks;
  function n(r, a) {
    if (r) {
      if (typeof r == "string") return t(r, a);
      var i = {}.toString.call(r).slice(8, -1);
      return i === "Object" && r.constructor && (i = r.constructor.name), i === "Map" || i === "Set" ? Array.from(r) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? t(r, a) : void 0;
    }
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Qs);
var qs = Qs.exports;
(function(e) {
  var t = qs;
  function n(r, a) {
    var i = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (!i) {
      if (Array.isArray(r) || (i = t(r)) || a && r && typeof r.length == "number") {
        i && (r = i);
        var o = 0, s = function() {
        };
        return {
          s,
          n: function() {
            return o >= r.length ? {
              done: !0
            } : {
              done: !1,
              value: r[o++]
            };
          },
          e: function(d) {
            throw d;
          },
          f: s
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var c, l = !0, u = !1;
    return {
      s: function() {
        i = i.call(r);
      },
      n: function() {
        var d = i.next();
        return l = d.done, d;
      },
      e: function(d) {
        u = !0, c = d;
      },
      f: function() {
        try {
          l || i.return == null || i.return();
        } finally {
          if (u) throw c;
        }
      }
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Ws);
var Js = Ws.exports, $s = m, K3 = $s.useEffect, q3 = $s.useRef;
function J3() {
  var e = q3(!0);
  return K3(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
var on = J3, $3 = Ee.default, Fi = $3(Js), e5 = Xs, t5 = dt, n5 = t5.useTrackLoadQueryInRender, r5 = on, or = m, Gi = or.useCallback, wr = or.useEffect, zi = or.useRef, Vi = or.useState, a5 = {
  kind: "NullEntryPointReference"
};
function i5(e, t, n) {
  var r, a, i, o;
  n5();
  var s = (r = n == null || (a = n.TEST_ONLY__initialEntryPointData) === null || a === void 0 ? void 0 : a.entryPointReference) !== null && r !== void 0 ? r : a5, c = (i = n == null || (o = n.TEST_ONLY__initialEntryPointData) === null || o === void 0 ? void 0 : o.entryPointParams) !== null && i !== void 0 ? i : null, l = r5(), u = zi(/* @__PURE__ */ new Set([s])), f = Vi(s), d = f[0], v = f[1], g = Vi(c), p = g[0], h = g[1], A = Gi(function() {
    if (l.current) {
      var I = {
        kind: "NullEntryPointReference"
      };
      u.current.add(I), v(I);
    }
  }, [v, l]), C = Gi(function(I) {
    if (l.current) {
      var w = e5(e, t, I);
      u.current.add(w), v(w), h(I);
    }
  }, [e, t, v, l]), b = zi(!1);
  return wr(function() {
    return function() {
      b.current = !0;
    };
  }, []), wr(function() {
    if (b.current === !0) {
      b.current = !1, d.kind !== "NullEntryPointReference" && p != null && C(p);
      return;
    }
    var I = u.current;
    if (l.current) {
      var w = (0, Fi.default)(I), R;
      try {
        for (w.s(); !(R = w.n()).done; ) {
          var T = R.value;
          if (T === d)
            break;
          I.delete(T), T.kind !== "NullEntryPointReference" && T.dispose();
        }
      } catch (S) {
        w.e(S);
      } finally {
        w.f();
      }
    }
  }, [d, p, C, l]), wr(function() {
    return function() {
      var w = (0, Fi.default)(u.current), R;
      try {
        for (w.s(); !(R = w.n()).done; ) {
          var T = R.value;
          T.kind !== "NullEntryPointReference" && T.dispose();
        }
      } catch (S) {
        w.e(S);
      } finally {
        w.f();
      }
    };
  }, []), [d.kind === "NullEntryPointReference" ? null : d, C, A];
}
var o5 = i5, ec = null;
function s5(e) {
  ec = e;
}
function c5() {
  return ec;
}
var sr = {
  inject: s5,
  get: c5
}, l5 = m, u5 = l5.useMemo;
function d5(e) {
  return u5(function() {
    return {
      current: e
    };
  }, []);
}
var tc = d5, nc = { exports: {} }, rc = { exports: {} };
(function(e) {
  var t = Ks;
  function n(r) {
    if (Array.isArray(r)) return t(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(rc);
var p5 = rc.exports, ac = { exports: {} };
(function(e) {
  function t(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ac);
var f5 = ac.exports, ic = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ic);
var m5 = ic.exports;
(function(e) {
  var t = p5, n = f5, r = qs, a = m5;
  function i(o) {
    return t(o) || n(o) || r(o) || a();
  }
  e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
})(nc);
var g5 = nc.exports, v5 = Ve, h5 = /* @__PURE__ */ function() {
  function e(n) {
    this._capacity = n, this._capacity > 0 || v5(!1), this._map = /* @__PURE__ */ new Map();
  }
  var t = e.prototype;
  return t.set = function(r, a) {
    if (this._map.delete(r), this._map.set(r, a), this._map.size > this._capacity) {
      var i = this._map.keys().next();
      i.done || this._map.delete(i.value);
    }
  }, t.get = function(r) {
    var a = this._map.get(r);
    return a != null && (this._map.delete(r), this._map.set(r, a)), a;
  }, t.has = function(r) {
    return this._map.has(r);
  }, t.delete = function(r) {
    this._map.delete(r);
  }, t.size = function() {
    return this._map.size;
  }, t.capacity = function() {
    return this._capacity - this._map.size;
  }, t.clear = function() {
    this._map.clear();
  }, e;
}();
function E5(e) {
  return new h5(e);
}
var oc = {
  create: E5
}, A5 = Ee.default, Rr = A5(ir), C5 = 5 * 60 * 1e3, b5 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    (0, Rr.default)(this, "_retainCount", 0), (0, Rr.default)(this, "_retainDisposable", null), (0, Rr.default)(this, "_releaseTemporaryRetain", null), this._retain = function(a) {
      return r._retainCount++, r._retainCount === 1 && (r._retainDisposable = n(a)), {
        dispose: function() {
          r._retainCount = Math.max(0, r._retainCount - 1), r._retainCount === 0 && r._retainDisposable != null && (r._retainDisposable.dispose(), r._retainDisposable = null);
        }
      };
    };
  }
  var t = e.prototype;
  return t.temporaryRetain = function(r) {
    var a = this, i;
    if (r.isServer())
      return {
        dispose: function() {
        }
      };
    var o = this._retain(r), s = null, c = function() {
      clearTimeout(s), s = null, a._releaseTemporaryRetain = null, o.dispose();
    };
    return s = setTimeout(c, C5), (i = this._releaseTemporaryRetain) === null || i === void 0 || i.call(this), this._releaseTemporaryRetain = c, {
      dispose: function() {
        var u;
        (u = a._releaseTemporaryRetain) === null || u === void 0 || u.call(a);
      }
    };
  }, t.permanentRetain = function(r) {
    var a = this._retain(r);
    return this.releaseTemporaryRetain(), a;
  }, t.releaseTemporaryRetain = function() {
    var r;
    (r = this._releaseTemporaryRetain) === null || r === void 0 || r.call(this), this._releaseTemporaryRetain = null;
  }, t.getRetainCount = function() {
    return this._retainCount;
  }, e;
}(), sc = b5, cc = Ee.default, An = cc(ut), lc = cc(ir), y5 = oc, I5 = sc, w5 = Ve, R5 = oe, T5 = R5.isPromise, S5 = 1e3, uc = "store-or-network", dc = "store-and-network", _5 = typeof WeakMap == "function";
function Un(e) {
  return e.request.node.params.metadata.live !== void 0;
}
function aa(e, t, n, r, a) {
  var i = n ?? (Un(t) ? dc : uc), o = r ?? e.UNSTABLE_getDefaultRenderPolicy(), s = "".concat(i, "-").concat(o, "-").concat(t.request.identifier);
  return a != null ? "".concat(s, "-").concat(a) : s;
}
function ji(e, t) {
  var n = {
    __id: e.fragment.dataID,
    __fragments: (0, lc.default)({}, e.fragment.node.name, e.request.variables),
    __fragmentOwner: e.request
  };
  return {
    cacheIdentifier: t,
    fragmentNode: e.request.node.fragment,
    fragmentRef: n,
    operation: e
  };
}
var P5 = 2e5;
function Tr(e, t, n, r, a, i) {
  var o = Un(t), s = r, c = a, l = new I5(function(f) {
    var d = f.retain(t);
    return {
      dispose: function() {
        o && c != null && c.unsubscribe(), d.dispose(), i(u);
      }
    };
  }), u = {
    cacheIdentifier: e,
    id: P5++,
    processedPayloadsCount: 0,
    operationAvailability: n,
    getValue: function() {
      return s;
    },
    setValue: function(d) {
      s = d;
    },
    setNetworkSubscription: function(d) {
      o && c != null && c.unsubscribe(), c = d;
    },
    temporaryRetain: function(d) {
      return l.temporaryRetain(d);
    },
    permanentRetain: function(d) {
      return l.permanentRetain(d);
    },
    releaseTemporaryRetain: function() {
      l.releaseTemporaryRetain();
    }
  };
  return u;
}
var L5 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    (0, lc.default)(this, "_clearCacheEntry", function(a) {
      r._cache.delete(a.cacheIdentifier);
    }), this._environment = n, this._cache = y5.create(S5);
  }
  var t = e.prototype;
  return t.prepare = function(r, a, i, o, s, c, l) {
    var u = aa(this._environment, r, i, o, c);
    return this.prepareWithIdentifier(u, r, a, i, o, s, l);
  }, t.prepareWithIdentifier = function(r, a, i, o, s, c, l) {
    var u = this._environment, f = o ?? (Un(a) ? dc : uc), d = s ?? u.UNSTABLE_getDefaultRenderPolicy(), v = this._cache.get(r), g = null, p = v != null;
    v == null && (v = this._fetchAndSaveQuery(r, a, i, f, d, l, (0, An.default)((0, An.default)({}, c), {}, {
      unsubscribe: function(C) {
        g != null && g.dispose();
        var b = c == null ? void 0 : c.unsubscribe;
        b && b(C);
      }
    }))), g = v.temporaryRetain(u);
    var h = v.getValue();
    if (T5(h))
      throw u.__log({
        name: "suspense.query",
        fetchPolicy: f,
        isPromiseCached: p,
        operation: a,
        queryAvailability: v.operationAvailability,
        renderPolicy: d
      }), h;
    if (h instanceof Error)
      throw h;
    return h;
  }, t.retain = function(r, a) {
    var i = this._environment, o = r.cacheIdentifier, s = r.operation, c = this._getOrCreateCacheEntry(o, s, null, r, null), l = c.permanentRetain(i);
    return i.__log({
      name: "queryresource.retain",
      profilerContext: a,
      resourceID: c.id
    }), {
      dispose: function() {
        l.dispose();
      }
    };
  }, t.releaseTemporaryRetain = function(r) {
    var a = this._cache.get(r.cacheIdentifier);
    a != null && a.releaseTemporaryRetain();
  }, t.TESTS_ONLY__getCacheEntry = function(r, a, i, o) {
    var s = this._environment, c = aa(s, r, a, i, o);
    return this._cache.get(c);
  }, t._getOrCreateCacheEntry = function(r, a, i, o, s) {
    var c = this._cache.get(r);
    return c == null && (c = Tr(r, a, i, o, s, this._clearCacheEntry), this._cache.set(r, c)), c;
  }, t._fetchAndSaveQuery = function(r, a, i, o, s, c, l) {
    var u = this, f = this._environment, d = f.check(a), v = d.status, g = v === "available", p = g || s === "partial" && v !== "stale", h, A, C = function() {
    };
    switch (o) {
      case "store-only": {
        h = !1, A = !0;
        break;
      }
      case "store-or-network": {
        h = !g, A = p;
        break;
      }
      case "store-and-network": {
        h = !0, A = p;
        break;
      }
      case "network-only":
      default: {
        h = !0, A = !1;
        break;
      }
    }
    if (A) {
      var b = ji(a, r), I = Tr(r, a, d, b, null, this._clearCacheEntry);
      this._cache.set(r, I);
    }
    if (h) {
      var w = ji(a, r), R;
      i.subscribe({
        start: function(L) {
          R = L;
          var x = u._cache.get(r);
          x && x.setNetworkSubscription(R);
          var k = l == null ? void 0 : l.start;
          if (k) {
            var O = (0, An.default)((0, An.default)({}, L), {}, {
              unsubscribe: function() {
                Un(a) && L.unsubscribe();
              }
            });
            k(O);
          }
        },
        next: function() {
          var L = u._getOrCreateCacheEntry(r, a, d, w, R);
          L.processedPayloadsCount += 1, L.setValue(w), C();
          var x = l == null ? void 0 : l.next;
          if (x != null) {
            var k = f.lookup(a.fragment);
            x(k);
          }
        },
        error: function(L) {
          var x = u._getOrCreateCacheEntry(r, a, d, L, R);
          x.processedPayloadsCount === 0 && x.setValue(L), C(), R = null, x.setNetworkSubscription(null);
          var k = l == null ? void 0 : l.error;
          k && k(L);
        },
        complete: function() {
          C(), R = null;
          var L = u._cache.get(r);
          L && L.setNetworkSubscription(null);
          var x = l == null ? void 0 : l.complete;
          x && x();
        },
        unsubscribe: l == null ? void 0 : l.unsubscribe
      });
      var T = this._cache.get(r);
      if (!T) {
        var S = new Promise(function(N) {
          C = N;
        });
        S.displayName = "Relay(" + a.fragment.node.name + ")", T = Tr(r, a, d, S, R, this._clearCacheEntry), this._cache.set(r, T);
      }
    } else {
      var P = l == null ? void 0 : l.complete;
      P && P();
    }
    var _ = this._cache.get(r);
    return _ == null && w5(!1), f.__log({
      name: "queryresource.fetch",
      resourceID: _.id,
      operation: a,
      profilerContext: c,
      fetchPolicy: o,
      renderPolicy: s,
      queryAvailability: d,
      shouldFetch: h
    }), _;
  }, e;
}();
function pc(e) {
  return new L5(e);
}
var Xi = _5 ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map();
function N5(e) {
  var t = Xi.get(e);
  if (t)
    return t;
  var n = pc(e);
  return Xi.set(e, n), n;
}
var Ma = {
  createQueryResource: pc,
  getQueryResourceForEnvironment: N5,
  getQueryCacheIdentifier: aa
}, Ba = Ee.default, Cn = Ba(ut), Yi = Ba(ir), bn = Ba(g5), x5 = oc, O5 = Ma, Wi = O5.getQueryResourceForEnvironment, k5 = sc, mt = Ve, He = oe, fc = He.__internal, M5 = fc.fetchQuery, B5 = fc.getPromiseForActiveRequest, Oe = He.RelayFeatureFlags, U5 = He.createOperationDescriptor, D5 = He.getFragmentIdentifier, H5 = He.getPendingOperationsForFragment, F5 = He.getSelector, G5 = He.getVariablesFromFragment, Qi = He.handlePotentialSnapshotErrors, Sr = He.isPromise, Zi = He.recycleNodesInto, z5 = typeof WeakMap == "function", V5 = 1e6, Ki = Object.freeze([]);
function qi(e) {
  return Array.isArray(e) ? e.some(function(t) {
    return t.isMissingData;
  }) : e.isMissingData;
}
function j5(e) {
  var t, n;
  return Array.isArray(e) ? e.some(function(r) {
    var a, i;
    return ((a = (i = r.missingClientEdges) === null || i === void 0 ? void 0 : i.length) !== null && a !== void 0 ? a : 0) > 0;
  }) : ((t = (n = e.missingClientEdges) === null || n === void 0 ? void 0 : n.length) !== null && t !== void 0 ? t : 0) > 0;
}
function Ji(e) {
  return Array.isArray(e) ? e.map(function(t) {
    return t.missingLiveResolverFields;
  }).filter(Boolean).flat() : e.missingLiveResolverFields;
}
function X5(e, t) {
  Array.isArray(e) ? e.forEach(t) : t(e);
}
function et(e, t, n) {
  return Array.isArray(t) ? {
    cacheKey: e,
    snapshot: t,
    data: t.map(function(r) {
      return r.data;
    }),
    isMissingData: qi(t),
    storeEpoch: n
  } : {
    cacheKey: e,
    snapshot: t,
    data: t.data,
    isMissingData: qi(t),
    storeEpoch: n
  };
}
var Y5 = /* @__PURE__ */ function() {
  function e(n) {
    (0, Yi.default)(this, "_cache", /* @__PURE__ */ new Map()), (0, Yi.default)(this, "_retainCounts", /* @__PURE__ */ new Map()), this._environment = n;
  }
  var t = e.prototype;
  return t.get = function(r) {
    var a, i;
    return (a = (i = this._cache.get(r)) === null || i === void 0 ? void 0 : i[0]) !== null && a !== void 0 ? a : void 0;
  }, t.recordQueryResults = function(r, a) {
    var i = this, o = this._cache.get(r);
    if (o) {
      var c = o[0], l = o[1];
      a.forEach(function(u) {
        c.push(u);
      }), l.temporaryRetain(this._environment);
    } else {
      var s = new k5(function() {
        return i._retain(r);
      });
      this._cache.set(r, [a, s]), s.temporaryRetain(this._environment);
    }
  }, t._retain = function(r) {
    var a = this, i, o = ((i = this._retainCounts.get(r)) !== null && i !== void 0 ? i : 0) + 1;
    return this._retainCounts.set(r, o), {
      dispose: function() {
        var c, l = ((c = a._retainCounts.get(r)) !== null && c !== void 0 ? c : 0) - 1;
        l > 0 ? a._retainCounts.set(r, l) : (a._retainCounts.delete(r), a._cache.delete(r));
      }
    };
  }, e;
}(), W5 = /* @__PURE__ */ function() {
  function e(n) {
    this._environment = n, this._cache = x5.create(V5), Oe.ENABLE_CLIENT_EDGES && (this._clientEdgeQueryResultsCache = new Y5(n));
  }
  var t = e.prototype;
  return t.read = function(r, a, i, o) {
    return this.readWithIdentifier(r, a, D5(r, a), i, o);
  }, t.readWithIdentifier = function(r, a, i, o, s) {
    var c = this, l, u, f, d, v = this._environment;
    if (a == null)
      return {
        cacheKey: i,
        data: null,
        isMissingData: !1,
        snapshot: null,
        storeEpoch: 0
      };
    var g = v.getStore().getEpoch();
    if ((r == null || (l = r.metadata) === null || l === void 0 ? void 0 : l.plural) === !0 && (Array.isArray(a) || mt(!1), a.length === 0))
      return {
        cacheKey: i,
        data: Ki,
        isMissingData: !1,
        snapshot: Ki,
        storeEpoch: g
      };
    var p = this._cache.get(i);
    if (p != null) {
      var h;
      if (p.kind === "pending" && Sr(p.promise))
        throw v.__log({
          name: "suspense.fragment",
          data: p.result.data,
          fragment: r,
          isRelayHooks: !0,
          isMissingData: p.result.isMissingData,
          isPromiseCached: !0,
          pendingOperations: p.pendingOperations
        }), p.promise;
      if (p.kind === "done" && p.result.snapshot && !((h = Ji(p.result.snapshot)) !== null && h !== void 0 && h.length))
        return this._throwOrLogErrorsInSnapshot(p.result.snapshot), p.result.isMissingData && v.__log({
          name: "fragmentresource.missing_data",
          data: p.result.data,
          fragment: r,
          isRelayHooks: !0,
          cached: !0
        }), p.result;
    }
    var A = F5(r, a);
    A == null && mt(!1);
    var C = null, b = null;
    if (Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && p != null && p.kind === "missing" ? (C = p.result, b = p.snapshot) : (b = A.kind === "PluralReaderSelector" ? A.selectors.map(function(O) {
      return v.lookup(O);
    }) : v.lookup(A), C = et(i, b, g)), !C.isMissingData)
      return this._throwOrLogErrorsInSnapshot(b), this._cache.set(i, {
        kind: "done",
        result: C
      }), C;
    var I = null;
    if (Oe.ENABLE_CLIENT_EDGES && ((u = r.metadata) === null || u === void 0 ? void 0 : u.hasClientEdges) === !0 && j5(b)) {
      I = [];
      var w = Wi(this._environment), R = [];
      X5(b, function(O) {
        var M;
        (M = O.missingClientEdges) === null || M === void 0 || M.forEach(function(D) {
          var F, V = D.request, ee = D.clientEdgeDestinationID, X = c._performClientEdgeQuery(w, r, a, V, ee), Y = X.queryResult, J = X.requestDescriptor;
          R.push(Y), (F = I) === null || F === void 0 || F.push(J);
        });
      }), this._clientEdgeQueryResultsCache == null && mt(!1), this._clientEdgeQueryResultsCache.recordQueryResults(i, R);
    }
    var T = [];
    Oe.ENABLE_CLIENT_EDGES && I && (T = I.map(function(O) {
      return B5(c._environment, O);
    }).filter(Boolean));
    var S = A.kind === "PluralReaderSelector" ? A.selectors[0].owner : A.owner, P = this._getAndSavePromiseForFragmentRequestInFlight(i, r, S, C), _ = P == null ? void 0 : P.promise, N = (f = (d = Ji(b)) === null || d === void 0 ? void 0 : d.map(function(O) {
      var M = O.liveStateID, D = v.getStore();
      return D.getLiveResolverPromise(M);
    })) !== null && f !== void 0 ? f : [];
    if (T.length || N.length || Sr(_)) {
      var L, x;
      v.__log({
        name: "suspense.fragment",
        data: C.data,
        fragment: r,
        isRelayHooks: !0,
        isPromiseCached: !1,
        isMissingData: C.isMissingData,
        pendingOperations: [].concat((0, bn.default)((L = P == null ? void 0 : P.pendingOperations) !== null && L !== void 0 ? L : []), (0, bn.default)((x = I) !== null && x !== void 0 ? x : []))
      });
      var k = [];
      if (T.length > 0 && (k = k.concat(T)), N.length > 0 && (k = k.concat(N)), k.length > 0)
        throw _ && k.push(_), Promise.all(k);
      if (_)
        throw _;
    }
    return Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && C.isMissingData && this._cache.set(i, {
      kind: "done",
      result: C
    }), this._throwOrLogErrorsInSnapshot(b), v.__log({
      name: "fragmentresource.missing_data",
      data: C.data,
      fragment: r,
      isRelayHooks: !0,
      cached: !1
    }), et(i, b, g);
  }, t._performClientEdgeQuery = function(r, a, i, o, s) {
    var c = G5(a, i), l = (0, Cn.default)((0, Cn.default)({}, c), {}, {
      id: s
    }), u = U5(o, l, {}), f = M5(this._environment, u), d = r.prepare(u, f);
    return {
      requestDescriptor: u.request,
      queryResult: d
    };
  }, t._throwOrLogErrorsInSnapshot = function(r) {
    var a = this;
    Array.isArray(r) ? r.forEach(function(i) {
      Qi(a._environment, i.missingRequiredFields, i.relayResolverErrors, i.errorResponseFields);
    }) : Qi(this._environment, r.missingRequiredFields, r.relayResolverErrors, r.errorResponseFields);
  }, t.readSpec = function(r, a, i) {
    var o = {};
    for (var s in r)
      o[s] = this.read(r[s], a[s], i, s);
    return o;
  }, t.subscribe = function(r, a) {
    var i = this, o = this._environment, s = r.cacheKey, c = r.snapshot;
    if (!c)
      return {
        dispose: function() {
        }
      };
    var l = this.checkMissedUpdates(r), u = l[0], f = l[1];
    u && a();
    var d = [];
    if (Array.isArray(c) ? (Array.isArray(f) || mt(!1), f.forEach(function(A, C) {
      d.push(o.subscribe(A, function(b) {
        var I = o.getStore().getEpoch();
        i._updatePluralSnapshot(s, f, b, C, I), a();
      }));
    })) : (f != null && !Array.isArray(f) || mt(!1), d.push(o.subscribe(f, function(A) {
      var C = o.getStore().getEpoch(), b = et(s, A, C);
      Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && b.isMissingData ? i._cache.set(s, {
        kind: "missing",
        result: b,
        snapshot: A
      }) : i._cache.set(s, {
        kind: "done",
        result: et(s, A, C)
      }), a();
    }))), Oe.ENABLE_CLIENT_EDGES) {
      var v, g, p = (v = (g = this._clientEdgeQueryResultsCache) === null || g === void 0 ? void 0 : g.get(s)) !== null && v !== void 0 ? v : void 0;
      if (p != null && p.length) {
        var h = Wi(this._environment);
        p.forEach(function(A) {
          d.push(h.retain(A));
        });
      }
    }
    return {
      dispose: function() {
        d.forEach(function(C) {
          return C.dispose();
        }), i._cache.delete(s);
      }
    };
  }, t.subscribeSpec = function(r, a) {
    var i = this, o = Object.keys(r).map(function(s) {
      return i.subscribe(r[s], a);
    });
    return {
      dispose: function() {
        o.forEach(function(c) {
          c.dispose();
        });
      }
    };
  }, t.checkMissedUpdates = function(r) {
    var a = this._environment, i = r.snapshot;
    if (!i)
      return [!1, null];
    var o = null;
    if (o = a.getStore().getEpoch(), r.storeEpoch === o)
      return [!1, r.snapshot];
    var s = r.cacheKey;
    if (Array.isArray(i)) {
      var c = !1, l = [];
      if (i.forEach(function(A, C) {
        var b = a.lookup(A.selector), I = A.data, w = b.data, R = Zi(I, w);
        R !== I && (b = (0, Cn.default)((0, Cn.default)({}, b), {}, {
          data: R
        }), c = !0), l[C] = b;
      }), c) {
        var u = et(s, l, o);
        Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && u.isMissingData ? this._cache.set(s, {
          kind: "missing",
          result: u,
          snapshot: l
        }) : this._cache.set(s, {
          kind: "done",
          result: u
        });
      }
      return [c, l];
    }
    var f = a.lookup(i.selector), d = i.data, v = f.data, g = Zi(d, v), p = {
      data: g,
      isMissingData: f.isMissingData,
      missingClientEdges: f.missingClientEdges,
      missingLiveResolverFields: f.missingLiveResolverFields,
      seenRecords: f.seenRecords,
      selector: f.selector,
      missingRequiredFields: f.missingRequiredFields,
      relayResolverErrors: f.relayResolverErrors,
      errorResponseFields: f.errorResponseFields
    };
    if (g !== d) {
      var h = et(s, p, o);
      Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && h.isMissingData ? this._cache.set(s, {
        kind: "missing",
        result: h,
        snapshot: p
      }) : this._cache.set(s, {
        kind: "done",
        result: h
      });
    }
    return [g !== d, p];
  }, t.checkMissedUpdatesSpec = function(r) {
    var a = this;
    return Object.keys(r).some(function(i) {
      return a.checkMissedUpdates(r[i])[0];
    });
  }, t._getAndSavePromiseForFragmentRequestInFlight = function(r, a, i, o) {
    var s = this, c = H5(this._environment, a, i);
    if (c == null)
      return null;
    var l = c.promise, u = c.pendingOperations, f = l.then(function() {
      s._cache.delete(r);
    }).catch(function(d) {
      s._cache.delete(r);
    });
    return f.displayName = l.displayName, this._cache.set(r, {
      kind: "pending",
      pendingOperations: u,
      promise: f,
      result: o
    }), {
      promise: f,
      pendingOperations: u
    };
  }, t._updatePluralSnapshot = function(r, a, i, o, s) {
    var c, l = this._cache.get(r);
    if (Sr(l)) {
      $i(i.selector.node.name);
      return;
    }
    var u = l == null || (c = l.result) === null || c === void 0 ? void 0 : c.snapshot;
    if (u && !Array.isArray(u)) {
      $i(i.selector.node.name);
      return;
    }
    var f = u ? (0, bn.default)(u) : (0, bn.default)(a);
    f[o] = i;
    var d = et(r, f, s);
    Oe.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && d.isMissingData ? this._cache.set(r, {
      kind: "missing",
      result: d,
      snapshot: f
    }) : this._cache.set(r, {
      kind: "done",
      result: d
    });
  }, e;
}();
function $i(e) {
  mt(!1);
}
function mc(e) {
  return new W5(e);
}
var eo = z5 ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map();
function Q5(e) {
  var t = eo.get(e);
  if (t)
    return t;
  var n = mc(e);
  return eo.set(e, n), n;
}
var gc = {
  createFragmentResource: mc,
  getFragmentResourceForEnvironment: Q5
}, Z5 = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_CHARTBEAT_DOMAIN: "dev.scmp.com", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.7.0 npm/? node/v20.16.0 linux x64", NODE_VERSION: "20.16.0", SENTRY_RELEASE: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", SHLVL: "2", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", NEXT_PUBLIC_OPTIMIZELY_AB_TEST_HARD_LINK: "28040870026", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "12c8422095530a40971c660bb6945ad1a6c83e66", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-5677-8eqcx6-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.5.3_@swc-node+register@1.9.1_@swc+core@1.5.25_@swc+helpers@0.5.11__@swc+types@0.1.7_typ_jhntxmzgrkyrhwuaxypkcyvv2e/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-5677-8eqcx6", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "17710558103988413064", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" }, K5 = Ae, to = tc, q5 = gc, J5 = q5.getFragmentResourceForEnvironment, vc = m, $5 = vc.useEffect, e6 = vc.useState, hc = oe, t6 = hc.RelayFeatureFlags, n6 = hc.getFragmentIdentifier;
function r6(e, t, n) {
  var r = K5(), a = J5(r), i = to(!1), o = e6(0), s = o[1], c = n6(e, t), l = a.readWithIdentifier(e, t, c, n), u = to(!0);
  function f() {
    u.current = !0;
    var g = a.checkMissedUpdates(l)[0];
    g && v();
  }
  function d() {
    u.current = !1;
  }
  function v() {
    i.current === !1 || u.current === !1 || s(function(g) {
      return g + 1;
    });
  }
  return $5(function() {
    i.current = !0;
    var g = a.subscribe(l, v);
    return function() {
      i.current = !1, g.dispose();
    };
  }, [r, c]), (t6.LOG_MISSING_RECORDS_IN_PROD || Z5.NODE_ENV !== "production") && t != null && (l.data === void 0 || Array.isArray(l.data) && l.data.length > 0 && l.data.every(function(g) {
    return g === void 0;
  })), {
    data: l.data,
    disableStoreUpdates: d,
    enableStoreUpdates: f
  };
}
var Ua = r6, a6 = sr, i6 = Ua, o6 = dt, s6 = o6.useTrackLoadQueryInRender, c6 = m;
c6.useDebugValue;
var l6 = oe, u6 = l6.getFragment;
function d6(e, t) {
  s6();
  var n = u6(e), r = i6(n, t, "useFragment()"), a = r.data;
  return a;
}
function p6(e, t) {
  var n = a6.get();
  return n ? n.useFragment(e, t) : d6(e, t);
}
var f6 = p6, no = tc, Ec = m, _r = Ec.useCallback, m6 = Ec.useEffect;
function g6() {
  var e = no(null), t = no(!1), n = _r(function() {
    e.current != null && (e.current.unsubscribe(), e.current = null), t.current = !1;
  }, []), r = _r(function(i) {
    e.current = i, t.current = !0;
  }, []), a = _r(function() {
    e.current = null, t.current = !1;
  }, []);
  return m6(function() {
    return n;
  }, [n]), {
    isFetchingRef: t,
    startFetch: r,
    disposeFetch: n,
    completeFetch: a
  };
}
var Ac = g6, v6 = sr, h6 = Ua, E6 = rr, Cc = Ma, A6 = Cc.getQueryCacheIdentifier, C6 = Cc.getQueryResourceForEnvironment, b6 = Ac, y6 = Ae, cr = m, I6 = cr.useContext, Pr = cr.useEffect, w6 = cr.useState, R6 = cr.useRef;
function T6(e) {
  var t = e.query, n = e.componentDisplayName, r = e.fetchObservable, a = e.fetchPolicy, i = e.fetchKey, o = e.renderPolicy, s = y6(), c = I6(E6), l = C6(s), u = w6(0), f = u[0], d = u[1], v = b6(), g = v.startFetch, p = v.completeFetch, h = "".concat(f, "-").concat(i ?? ""), A = A6(s, t, a, o, h), C = c.wrapPrepareQueryResource(function() {
    return l.prepareWithIdentifier(A, t, r, a, o, {
      start: g,
      complete: p,
      error: p
    }, c);
  }), b = R6(!1);
  Pr(function() {
    return function() {
      b.current = !0;
    };
  }, []), Pr(function() {
    if (b.current === !0) {
      b.current = !1, d(function(S) {
        return S + 1;
      });
      return;
    }
    var T = l.retain(C, c);
    return function() {
      T.dispose();
    };
  }, [s, A]), Pr(function() {
    l.releaseTemporaryRetain(C);
  });
  var I = C.fragmentNode, w = C.fragmentRef, R = S6(I, w, n);
  return R;
}
function S6(e, t, n) {
  var r = v6.get();
  if (r && r.useFragment__internal)
    return r.useFragment__internal(e, t, n);
  var a = h6(e, t, n), i = a.data;
  return i;
}
var bc = T6, Lr = [], Nr = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */
function _6(e, t) {
  var n = Lr.length ? Lr.pop() : [], r = Nr.length ? Nr.pop() : [], a = ia(e, t, n, r);
  return n.length = 0, r.length = 0, Lr.push(n), Nr.push(r), a;
}
function ia(e, t, n, r) {
  if (e === t)
    return e !== 0 || 1 / e == 1 / t;
  if (e == null || t == null || typeof e != "object" || typeof t != "object")
    return !1;
  var a = Object.prototype.toString, i = a.call(e);
  if (i != a.call(t))
    return !1;
  switch (i) {
    case "[object String]":
      return e == String(t);
    case "[object Number]":
      return isNaN(e) || isNaN(t) ? !1 : e == Number(t);
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object RegExp]":
      return e.source == t.source && e.global == t.global && e.multiline == t.multiline && e.ignoreCase == t.ignoreCase;
  }
  for (var o = n.length; o--; )
    if (n[o] == e)
      return r[o] == t;
  n.push(e), r.push(t);
  var s = 0;
  if (i === "[object Array]") {
    if (s = e.length, s !== t.length)
      return !1;
    for (; s--; )
      if (!ia(e[s], t[s], n, r))
        return !1;
  } else {
    if (e.constructor !== t.constructor)
      return !1;
    if (e.hasOwnProperty("valueOf") && t.hasOwnProperty("valueOf"))
      return e.valueOf() == t.valueOf();
    var c = Object.keys(e);
    if (c.length != Object.keys(t).length)
      return !1;
    for (var l = 0; l < c.length; l++)
      if (!ia(e[c[l]], t[c[l]], n, r))
        return !1;
  }
  return n.pop(), r.pop(), !0;
}
var P6 = _6, L6 = P6, N6 = m, x6 = N6.useState;
function O6(e) {
  var t = x6(e), n = t[0], r = t[1];
  return L6(e, n) ? n : (r(e), e);
}
var k6 = O6, ro = k6, M6 = m, yc = oe, B6 = yc.createOperationDescriptor, U6 = yc.getRequest, D6 = M6.useMemo;
function H6(e, t, n) {
  var r = ro(t), a = ro(n || {});
  return D6(function() {
    return B6(U6(e), r, a);
  }, [e, r, a]);
}
var Ic = H6, F6 = dt, G6 = F6.useTrackLoadQueryInRender, z6 = bc, V6 = Ic, j6 = Ae, X6 = oe, Y6 = X6.__internal.fetchQuery;
function W6(e, t, n) {
  G6();
  var r = j6(), a = V6(e, t, n && n.networkCacheConfig ? n.networkCacheConfig : {
    force: !0
  }), i = z6({
    componentDisplayName: "useLazyLoadQuery()",
    fetchKey: n == null ? void 0 : n.fetchKey,
    fetchObservable: Y6(r, a),
    fetchPolicy: n == null ? void 0 : n.fetchPolicy,
    query: a,
    renderPolicy: n == null ? void 0 : n.UNSTABLE_renderPolicy
  });
  return i;
}
var Q6 = W6, Z6 = Ee.default, ao = Z6(ut), K6 = on, q6 = Ae, lr = m, J6 = oe, $6 = J6.commitMutation, e9 = lr.useState, t9 = lr.useEffect, xr = lr.useRef, io = lr.useCallback;
function n9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6, n = q6(), r = K6(), a = xr(n), i = xr(e), o = xr(/* @__PURE__ */ new Set()), s = e9(!1), c = s[0], l = s[1], u = io(function(d) {
    a.current === n && i.current === e && (o.current.delete(d), r.current && l(o.current.size > 0));
  }, [n, r, e]);
  t9(function() {
    (a.current !== n || i.current !== e) && (o.current = /* @__PURE__ */ new Set(), r.current && l(!1), a.current = n, i.current = e);
  }, [n, r, e]);
  var f = io(function(d) {
    r.current && l(!0);
    var v = t(n, (0, ao.default)((0, ao.default)({}, d), {}, {
      mutation: e,
      onCompleted: function(p, h) {
        var A;
        u(v), (A = d.onCompleted) === null || A === void 0 || A.call(d, p, h);
      },
      onError: function(p) {
        var h;
        u(v), (h = d.onError) === null || h === void 0 || h.call(d, p);
      },
      onUnsubscribe: function() {
        var p;
        u(v), (p = d.onUnsubscribe) === null || p === void 0 || p.call(d);
      },
      onNext: function() {
        var p;
        (p = d.onNext) === null || p === void 0 || p.call(d);
      }
    }));
    return o.current.add(v), v;
  }, [u, t, n, r, e]);
  return [f, c];
}
var r9 = n9, a9 = Ee.default, oo = a9(Js), wc = dt, i9 = wc.loadQuery, o9 = wc.useTrackLoadQueryInRender, s9 = on, c9 = Ae, ur = m, so = ur.useCallback, Or = ur.useEffect, co = ur.useRef, lo = ur.useState, l9 = oe, u9 = l9.getRequest, kr = {
  kind: "NullQueryReference"
};
function uo(e) {
  if (e.kind === "PreloadableConcreteRequest")
    return e.params.metadata.live !== void 0;
  var t = u9(e);
  return t.params.metadata.live !== void 0;
}
function d9(e, t) {
  var n = t ?? kr, r = c9();
  o9();
  var a = s9(), i = co(/* @__PURE__ */ new Set([n])), o = lo(function() {
    return n;
  }), s = o[0], c = o[1], l = lo(function() {
    return n;
  }), u = l[0], f = l[1];
  n !== u && (i.current.add(n), f(n), c(n));
  var d = so(function() {
    a.current && (i.current.add(kr), c(kr));
  }, [a]), v = so(function(p, h) {
    var A = h != null && h.hasOwnProperty("__environment") ? {
      fetchPolicy: h.fetchPolicy,
      networkCacheConfig: h.networkCacheConfig,
      __nameForWarning: h.__nameForWarning
    } : h;
    if (a.current) {
      var C, b = i9((C = h == null ? void 0 : h.__environment) !== null && C !== void 0 ? C : r, e, p, A);
      i.current.add(b), c(b);
    }
  }, [r, e, c, a]), g = co(!1);
  return Or(function() {
    return function() {
      g.current = !0;
    };
  }, []), Or(function() {
    if (g.current === !0) {
      g.current = !1, s.kind !== "NullQueryReference" && v(s.variables, {
        fetchPolicy: s.fetchPolicy,
        networkCacheConfig: s.networkCacheConfig
      });
      return;
    }
    var p = i.current;
    if (a.current) {
      var h = (0, oo.default)(p), A;
      try {
        for (h.s(); !(A = h.n()).done; ) {
          var C = A.value;
          if (C === s)
            break;
          p.delete(C), C.kind !== "NullQueryReference" && (uo(e) ? C.dispose && C.dispose() : C.releaseQuery && C.releaseQuery());
        }
      } catch (b) {
        h.e(b);
      } finally {
        h.f();
      }
    }
  }, [s, a, v, e]), Or(function() {
    return function() {
      var h = (0, oo.default)(i.current), A;
      try {
        for (h.s(); !(A = h.n()).done; ) {
          var C = A.value;
          C.kind !== "NullQueryReference" && (uo(e) ? C.dispose && C.dispose() : C.releaseQuery && C.releaseQuery());
        }
      } catch (b) {
        h.e(b);
      } finally {
        h.f();
      }
    };
  }, [e]), [s.kind === "NullQueryReference" ? null : s, v, d];
}
var Rc = d9, p9 = Ee.default, Xt = p9(ut), f9 = rr, m9 = Ma, g9 = m9.getQueryResourceForEnvironment, v9 = on, h9 = Rc, E9 = Ae, A9 = gc, C9 = A9.getFragmentResourceForEnvironment, b9 = Ua, y9 = Ve, Da = m, I9 = Da.useCallback, w9 = Da.useContext, R9 = Da.useReducer, Pt = oe, T9 = Pt.__internal.fetchQuery, S9 = Pt.createOperationDescriptor, _9 = Pt.getFragmentIdentifier, po = Pt.getRefetchMetadata, P9 = Pt.getSelector, L9 = Pt.getValueAtPath;
function N9(e, t) {
  switch (t.type) {
    case "refetch": {
      var n;
      return (0, Xt.default)((0, Xt.default)({}, e), {}, {
        fetchPolicy: t.fetchPolicy,
        mirroredEnvironment: (n = t.refetchEnvironment) !== null && n !== void 0 ? n : e.mirroredEnvironment,
        onComplete: t.onComplete,
        refetchEnvironment: t.refetchEnvironment,
        refetchQuery: t.refetchQuery,
        renderPolicy: t.renderPolicy
      });
    }
    case "reset":
      return {
        fetchPolicy: void 0,
        mirroredEnvironment: t.environment,
        mirroredFragmentIdentifier: t.fragmentIdentifier,
        onComplete: void 0,
        refetchQuery: null,
        renderPolicy: void 0
      };
    default:
      throw t.type, new Error("useRefetchableFragmentNode: Unexpected action type");
  }
}
function x9(e, t, n) {
  var r = E9(), a = po(e, n), i = a.refetchableRequest, o = a.fragmentRefPathInResponse, s = _9(e, t), c = R9(N9, {
    fetchPolicy: void 0,
    mirroredEnvironment: r,
    mirroredFragmentIdentifier: s,
    onComplete: void 0,
    refetchEnvironment: null,
    refetchQuery: null,
    renderPolicy: void 0
  }), l = c[0], u = c[1], f = l.fetchPolicy, d = l.mirroredEnvironment, v = l.mirroredFragmentIdentifier, g = l.onComplete, p = l.refetchEnvironment, h = l.refetchQuery, A = l.renderPolicy, C = p ?? r, b = g9(C), I = C9(C), w = w9(f9), R = C !== d || s !== v, T = h9(i), S = T[0], P = T[1], _ = T[2], N = t, L = po(e, n), x = L.identifierInfo;
  if (R)
    u({
      type: "reset",
      environment: C,
      fragmentIdentifier: s
    }), _();
  else if (h != null && S != null) {
    var k = function(Q) {
      g && g(Q ?? null);
    }, O = S.source != null ? S.source : T9(C, h), M = w.wrapPrepareQueryResource(function() {
      return b.prepare(h, O, f, A, {
        error: k,
        complete: function() {
          k();
        }
      }, S.fetchKey, w);
    }), D = I.read(M.fragmentNode, M.fragmentRef, n).data;
    D == null && y9(!1);
    var F = L9(D, o);
    N = F;
  }
  var V = b9(e, N, n), ee = V.data, X = V.disableStoreUpdates, Y = V.enableStoreUpdates, J = O9(n, u, _, ee, s, e, o, x, P, t, i);
  return {
    fragmentData: ee,
    fragmentRef: N,
    refetch: J,
    disableStoreUpdates: X,
    enableStoreUpdates: Y
  };
}
function O9(e, t, n, r, a, i, o, s, c, l, u) {
  var f = v9(), d = (s == null ? void 0 : s.identifierField) != null && r != null && typeof r == "object" ? r[s.identifierField] : null;
  return I9(function(v, g) {
    if (f.current !== !0)
      return {
        dispose: function() {
        }
      };
    var p = g == null ? void 0 : g.__environment, h = g == null ? void 0 : g.fetchPolicy, A = g == null ? void 0 : g.UNSTABLE_renderPolicy, C = g == null ? void 0 : g.onComplete, b = P9(i, l), I, w;
    if (b == null)
      I = {}, w = {};
    else if (b.kind === "PluralReaderSelector") {
      var R, T, S, P;
      I = (R = (T = b.selectors[0]) === null || T === void 0 ? void 0 : T.owner.variables) !== null && R !== void 0 ? R : {}, w = (S = (P = b.selectors[0]) === null || P === void 0 ? void 0 : P.variables) !== null && S !== void 0 ? S : {};
    } else
      I = b.owner.variables, w = b.variables;
    var _ = (0, Xt.default)((0, Xt.default)((0, Xt.default)({}, I), w), v);
    s != null && !v.hasOwnProperty(s.identifierQueryVariableName) && (_[s.identifierQueryVariableName] = d);
    var N = S9(u, _, {
      force: !0
    });
    return c(N.request.variables, {
      fetchPolicy: h,
      __environment: p,
      __nameForWarning: "refetch"
    }), t({
      type: "refetch",
      fetchPolicy: h,
      onComplete: C,
      refetchEnvironment: p,
      refetchQuery: N,
      renderPolicy: A
    }), {
      dispose: n
    };
  }, [a, t, n, d, c]);
}
var Tc = x9, k9 = Ae, M9 = Ve, Ha = m, Sc = oe, B9 = Sc.__internal.getObservableForActiveRequest, U9 = Sc.getSelector, D9 = Ha.useEffect, H9 = Ha.useState, F9 = Ha.useMemo;
function G9(e, t) {
  var n = k9(), r = F9(function() {
    var s = U9(e, t);
    return s == null ? null : (s.kind !== "SingularReaderSelector" && M9(!1), B9(n, s.owner));
  }, [n, e, t]), a = H9(r != null), i = a[0], o = a[1];
  return D9(function() {
    var s;
    if (o(r != null), r != null) {
      var c = function() {
        o(!1);
      };
      s = r.subscribe({
        complete: c,
        error: c
      });
    }
    return function() {
      s && s.unsubscribe();
    };
  }, [r]), i;
}
var z9 = G9, V9 = Ee.default, Dt = V9(ut), j9 = Ac, X9 = on, Y9 = z9, W9 = Ae, zt = Ve, Fa = m, Q9 = Fa.useCallback, Z9 = Fa.useEffect, fo = Fa.useState, pt = oe, K9 = pt.__internal.fetchQuery, q9 = pt.ConnectionInterface, J9 = pt.createOperationDescriptor, $9 = pt.getPaginationVariables, e8 = pt.getRefetchMetadata, t8 = pt.getSelector, n8 = pt.getValueAtPath;
function r8(e) {
  var t = e.direction, n = e.fragmentNode, r = e.fragmentRef, a = e.fragmentIdentifier, i = e.fragmentData, o = e.connectionPathInFragmentData, s = e.paginationRequest, c = e.paginationMetadata, l = e.componentDisplayName, u = e.observer, f = e.onReset, d = W9(), v = j9(), g = v.isFetchingRef, p = v.startFetch, h = v.disposeFetch, A = v.completeFetch, C = e8(n, l), b = C.identifierInfo, I = (b == null ? void 0 : b.identifierField) != null && i != null && typeof i == "object" ? i[b.identifierField] : null, w = X9(), R = fo(d), T = R[0], S = R[1], P = fo(a), _ = P[0], N = P[1], L = Y9(n, r), x = d !== T || a !== _;
  x && (h(), f(), S(d), N(a));
  var k = a8(t, n, i, o), O = k.cursor, M = k.hasMore;
  Z9(function() {
    return function() {
      h();
    };
  }, [h]);
  var D = Q9(function(F, V) {
    var ee = V == null ? void 0 : V.onComplete;
    if (w.current !== !0)
      return {
        dispose: function() {
        }
      };
    var X = t8(n, r);
    if (g.current === !0 || i == null || L)
      return ee && ee(null), {
        dispose: function() {
        }
      };
    X != null && X.kind !== "PluralReaderSelector" || zt(!1);
    var Y = X.owner.variables, J = X.variables, W = V == null ? void 0 : V.UNSTABLE_extraVariables, Q = (0, Dt.default)((0, Dt.default)({}, Y), J), re = $9(t, F, O, Q, (0, Dt.default)({}, W), c);
    b != null && (re[b.identifierQueryVariableName] = I);
    var Le = J9(s, re, {
      force: !0
    });
    return K9(d, Le).subscribe((0, Dt.default)((0, Dt.default)({}, u), {}, {
      start: function(Z) {
        p(Z), u.start && u.start(Z);
      },
      complete: function() {
        A(), u.complete && u.complete(), ee && ee(null);
      },
      error: function(Z) {
        A(), u.error && u.error(Z), ee && ee(Z);
      }
    })), {
      dispose: h
    };
  }, [d, I, t, O, p, h, A, g, L, i, n.name, r, l]);
  return [D, M, h];
}
function a8(e, t, n, r) {
  var a, i, o = q9.get(), s = o.EDGES, c = o.PAGE_INFO, l = o.HAS_NEXT_PAGE, u = o.HAS_PREV_PAGE, f = o.END_CURSOR, d = o.START_CURSOR, v = n8(n, r);
  if (v == null)
    return {
      cursor: null,
      hasMore: !1
    };
  typeof v != "object" && zt(!1);
  var g = v[s], p = v[c];
  if (g == null || p == null)
    return {
      cursor: null,
      hasMore: !1
    };
  Array.isArray(g) || zt(!1), typeof p != "object" && zt(!1);
  var h = e === "forward" ? (a = p[f]) !== null && a !== void 0 ? a : null : (i = p[d]) !== null && i !== void 0 ? i : null;
  h === null || typeof h == "string" || zt(!1);
  var A;
  return e === "forward" ? A = h != null && p[l] === !0 : A = h != null && p[u] === !0, {
    cursor: h,
    hasMore: A
  };
}
var i8 = r8, o8 = Ee.default, Dn = o8(ut), s8 = sr, c8 = Tc, l8 = i8, Ga = m, u8 = Ga.useCallback;
Ga.useDebugValue;
var d8 = Ga.useState, za = oe, p8 = za.getFragment, f8 = za.getFragmentIdentifier, m8 = za.getPaginationMetadata;
function g8(e, t) {
  var n = p8(e), r = "usePaginationFragment()", a = m8(n, r), i = a.connectionPathInFragmentData, o = a.paginationRequest, s = a.paginationMetadata, c = c8(n, t, r), l = c.fragmentData, u = c.fragmentRef, f = c.refetch, d = f8(n, u), v = mo({
    componentDisplayName: r,
    connectionPathInFragmentData: i,
    direction: "backward",
    fragmentData: l,
    fragmentIdentifier: d,
    fragmentNode: n,
    fragmentRef: u,
    paginationMetadata: s,
    paginationRequest: o
  }), g = v[0], p = v[1], h = v[2], A = v[3], C = mo({
    componentDisplayName: r,
    connectionPathInFragmentData: i,
    direction: "forward",
    fragmentData: l,
    fragmentIdentifier: d,
    fragmentNode: n,
    fragmentRef: u,
    paginationMetadata: s,
    paginationRequest: o
  }), b = C[0], I = C[1], w = C[2], R = C[3], T = u8(function(S, P) {
    return R(), A(), f(S, (0, Dn.default)((0, Dn.default)({}, P), {}, {
      __environment: void 0
    }));
  }, [R, A, f]);
  return {
    data: l,
    loadNext: b,
    loadPrevious: g,
    hasNext: I,
    hasPrevious: p,
    isLoadingNext: w,
    isLoadingPrevious: h,
    refetch: T
  };
}
function mo(e) {
  var t = d8(!1), n = t[0], r = t[1], a = {
    start: function() {
      return r(!0);
    },
    complete: function() {
      return r(!1);
    },
    error: function() {
      return r(!1);
    }
  }, i = function() {
    return r(!1);
  }, o = l8((0, Dn.default)((0, Dn.default)({}, e), {}, {
    observer: a,
    onReset: i
  })), s = o[0], c = o[1], l = o[2];
  return [s, c, n, l];
}
function v8(e, t) {
  var n = s8.get();
  return n ? n.usePaginationFragment(e, t) : g8(e, t);
}
var h8 = v8, E8 = dt, A8 = E8.useTrackLoadQueryInRender, C8 = bc, b8 = Ic, y8 = Ae, I8 = Ve, w8 = m;
w8.useDebugValue;
var R8 = oe, _c = R8.__internal, T8 = _c.fetchQueryDeduped, S8 = _c.fetchQuery;
function _8(e, t, n) {
  A8();
  var r = y8(), a = t.fetchKey, i = t.fetchPolicy, o = t.source, s = t.variables, c = t.networkCacheConfig, l = b8(e, s, c), u;
  if (t.kind === "PreloadedQuery_DEPRECATED")
    l.request.node.params.name !== t.name && I8(!1), u = {
      componentDisplayName: "usePreloadedQuery()",
      fetchKey: a,
      fetchObservable: T8(r, l.request.identifier, function() {
        return r === t.environment && o != null ? r.executeWithSource({
          operation: l,
          source: o
        }) : r.execute({
          operation: l
        });
      }),
      fetchPolicy: i,
      query: l,
      renderPolicy: n == null ? void 0 : n.UNSTABLE_renderPolicy
    };
  else {
    var f = S8(r, l), d;
    o != null && r === t.environment ? d = o.ifEmpty(f) : (t.environment, d = f), u = {
      componentDisplayName: "usePreloadedQuery()",
      fetchObservable: d,
      fetchKey: a,
      fetchPolicy: i,
      query: l,
      renderPolicy: n == null ? void 0 : n.UNSTABLE_renderPolicy
    };
  }
  var v = C8(u);
  return v;
}
var P8 = _8, L8 = sr, N8 = Tc, x8 = m;
x8.useDebugValue;
var O8 = oe, k8 = O8.getFragment;
function M8(e, t) {
  var n = k8(e), r = N8(n, t, "useRefetchableFragment()"), a = r.fragmentData, i = r.refetch;
  return [a, i];
}
function B8(e, t) {
  var n = L8.get();
  return n ? n.useRefetchableFragment(e, t) : M8(e, t);
}
var U8 = B8, D8 = Ae, Pc = m, H8 = Pc.useEffect, F8 = Pc.useRef;
function G8(e, t) {
  var n = D8(), r = F8(null), a = Array.from(e).sort().join("");
  return H8(function() {
    var i = n.getStore(), o = i.lookupInvalidationState(e), s = i.subscribeToInvalidationState(o, t);
    return r.current = s, function() {
      return s.dispose();
    };
  }, [a, t, n]), {
    dispose: function() {
      r.current != null && r.current.dispose();
    }
  };
}
var z8 = G8, V8 = Ae, j8 = m, X8 = j8.useEffect, Y8 = oe, W8 = Y8.requestSubscription;
function Q8(e, t) {
  var n = t ?? W8, r = V8();
  X8(function() {
    var a = n(r, e), i = a.dispose;
    return i;
  }, [r, e, n]);
}
var Z8 = Q8, K8 = M3, q8 = Xs, J8 = dt, $8 = J8.loadQuery, ep = rr, tp = Z3, np = o5, rp = f6, ap = Q6, ip = r9, op = h8, sp = P8, cp = Rc, lp = U8, up = Ae, dp = z8, pp = Z8, Qe = oe, fp = {
  ConnectionHandler: Qe.ConnectionHandler,
  applyOptimisticMutation: Qe.applyOptimisticMutation,
  commitLocalUpdate: Qe.commitLocalUpdate,
  commitMutation: Qe.commitMutation,
  graphql: Qe.graphql,
  readInlineData: Qe.readInlineData,
  requestSubscription: Qe.requestSubscription,
  EntryPointContainer: K8,
  RelayEnvironmentProvider: tp,
  ProfilerContext: ep,
  fetchQuery: Qe.fetchQuery,
  loadQuery: $8,
  loadEntryPoint: q8,
  useFragment: rp,
  useLazyLoadQuery: ap,
  useEntryPointLoader: np,
  useQueryLoader: cp,
  useMutation: ip,
  usePaginationFragment: op,
  usePreloadedQuery: sp,
  useRefetchableFragment: lp,
  useRelayEnvironment: up,
  useSubscribeToInvalidationState: dp,
  useSubscription: pp
}, Lc = fp;
const Nc = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "footerNewsletterId"
  }], t = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "scmp_pwa_widget"
    }
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  }, a = [{
    fields: [{
      kind: "Variable",
      name: "entityId",
      variableName: "footerNewsletterId"
    }],
    kind: "ObjectValue",
    name: "filter"
  }], i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "name",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alternativeName",
    storageKey: null
  }, s = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "text",
    storageKey: null
  }], c = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "summary",
    plural: !1,
    selections: s,
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "homepageDescription",
    plural: !1,
    selections: s,
    storageKey: null
  }, u = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "footerDisplayQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          n,
          r
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
      }, {
        alias: null,
        args: a,
        concreteType: "Newsletter",
        kind: "LinkedField",
        name: "newsletter",
        plural: !1,
        selections: [
          n,
          i,
          o,
          c,
          l
          /*: any*/
        ],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "footerDisplayQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          n,
          r,
          u
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
      }, {
        alias: null,
        args: a,
        concreteType: "Newsletter",
        kind: "LinkedField",
        name: "newsletter",
        plural: !1,
        selections: [
          n,
          i,
          o,
          c,
          l,
          u
          /*: any*/
        ],
        storageKey: null
      }]
    },
    params: {
      cacheID: "aeccf4f9e4f975b246fac8ec525ecc1f",
      id: null,
      metadata: {},
      name: "footerDisplayQuery",
      operationKind: "query",
      text: `query footerDisplayQuery(
  $footerNewsletterId: String
) {
  appConfig(filter: {entityId: "scmp_pwa_widget"}) {
    entityId
    json
    id
  }
  newsletter(filter: {entityId: $footerNewsletterId}) {
    entityId
    name
    alternativeName
    summary {
      text
    }
    homepageDescription {
      text
    }
    id
  }
}
`
    }
  };
}();
Nc.hash = "88d7d054c9fb5b7bbe088e9d86c9ec22";
function oa() {
  return oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oa.apply(null, arguments);
}
const xc = ({
  queryReference: e,
  ...t
}) => {
  var n, r, a, i, o, s;
  const {
    config: c
  } = B(), l = Lc.usePreloadedQuery(Oc, e), u = (n = l.appConfig) === null || n === void 0 ? void 0 : n.json, f = l.newsletter;
  return /* @__PURE__ */ m.createElement(ks, oa({}, t, {
    newsletterItems: [{
      alternativeName: f.alternativeName,
      entityId: f.entityId,
      homepageDescription: {
        text: (r = (a = f.homepageDescription) === null || a === void 0 ? void 0 : a.text) !== null && r !== void 0 ? r : ""
      },
      name: f.name,
      summary: {
        text: (i = (o = f.summary) === null || o === void 0 ? void 0 : o.text) !== null && i !== void 0 ? i : ""
      }
    }],
    printEditionFooterConfig: u == null || (s = u[c.environment]) === null || s === void 0 ? void 0 : s.print_edition_footer,
    "data-qa": "footer-display"
  }));
};
xc.displayName = "FooterDisplay";
const Oc = Nc;
function sa() {
  return sa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sa.apply(null, arguments);
}
const mp = ({
  loadingComponent: e,
  ...t
}) => {
  const {
    config: n
  } = B(), [r, a, i] = Lc.useQueryLoader(Oc);
  return ne(() => (a({
    footerNewsletterId: n.newsletter.globalImpact
  }), i), [a, i, n.newsletter.globalImpact]), /* @__PURE__ */ m.createElement(b1, {
    fallback: e ?? "loading...",
    "data-qa": "footer"
  }, r && /* @__PURE__ */ m.createElement(xc, sa({}, t, {
    queryReference: r
  })));
};
mp.displayName = "Footer";
const gp = /* @__PURE__ */ y("div", {
  target: "e1que4v90"
})({
  name: "u25i9k",
  styles: "display:flex;flex-flow:column;justify-content:flex-start;align-items:center;inline-size:600px;min-block-size:252px;margin:auto;padding-block:40px;padding-inline:0;border-radius:8px;background-color:#ffffff;outline:none"
}), kc = ({
  children: e,
  isShow: t,
  onClose: n
}) => /* @__PURE__ */ m.createElement($u, {
  open: t,
  onClose: n,
  "data-qa": "popup"
}, /* @__PURE__ */ m.createElement(gp, null, e));
kc.displayName = "Popup";
const vp = /* @__PURE__ */ y(Au, {
  target: "e1qc5gx50"
})(Cu, "{margin-block-start:0;}", bu, "{font-size:21px;line-height:27px;}", yu, "{font-size:16px;}", Iu, "{font-size:14px;}"), hp = ({
  isShow: e,
  onClose: t
}) => /* @__PURE__ */ m.createElement(kc, {
  isShow: e,
  onClose: t,
  "data-qa": "sign-up-popup"
}, /* @__PURE__ */ m.createElement(ju, {
  theme: {
    signUpSuccess: {
      hasCheckEmail: !0
    }
  }
}, /* @__PURE__ */ m.createElement(vp, null)));
hp.displayName = "SignUpPopup";
const Mc = () => {
  const {
    set: e,
    value: t
  } = ye("isFirstTimeVisitNotification", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, Ep = /* @__PURE__ */ y(Xu, {
  target: "egbuww0"
})(".", Yu.dot, "{z-index:0;inline-size:4px;block-size:4px;min-inline-size:4px;border-radius:50%;background:#eb4254;transform:none;transition:none;translate:2px 0;}"), Bc = ({
  children: e
}) => {
  const {
    isFirstTime: t
  } = Mc();
  return /* @__PURE__ */ m.createElement(Ep, {
    invisible: !t,
    variant: "dot",
    "data-qa": "dashboard-badge"
  }, e);
}, Ap = (e) => {
  const {
    handleTrackGA4: t
  } = B(), n = Dc(e);
  ne(() => !n || !t ? void 0 : c2(n, (a) => {
    (async () => {
      try {
        const o = a.data;
        if (!o || document.hidden) return;
        const {
          hashValue: s
        } = Tu(o.click_action);
        if (t({
          action: "sys",
          category: "push",
          customized_parameters: {
            article_id: o.nid,
            push_time: o.push_time,
            section: o.topic
          },
          subcategory: "received"
        }), window.Notification) {
          const l = new Notification(o.title, {
            body: o.body,
            data: o,
            icon: o.icon,
            tag: o.nid
          });
          o.click_action && l.addEventListener("click", () => {
            t({
              action: "click",
              category: "push",
              customized_parameters: {
                article_id: o.nid,
                push_time: o.push_time,
                section: o.topic
              },
              subcategory: "received"
            });
            const u = new URL(o.click_action);
            u.searchParams.append("utm_source", "firebase_pwa"), u.searchParams.append("utm_medium", "push_notification"), u.searchParams.append("utm_campaign", "article"), u.searchParams.append("utm_content", `${o.nid}${s}`), window.open(u.href);
          });
          return;
        }
        const c = await navigator.serviceWorker.getRegistration();
        c && await c.showNotification(o.title, {
          body: o.body,
          data: o,
          icon: o.icon,
          tag: o.nid
        });
      } catch (o) {
        console.error(new Error("Failed to handle firebase message", {
          cause: o
        }));
      }
    })();
  }), [t, n]);
}, Uc = () => {
  const [e, t] = ct(async () => {
    const n = window !== void 0 && window.Notification !== void 0, r = await l2();
    return !p2 && n && r;
  });
  return De(t.execute), {
    isNotificationSupported: e
  };
}, Dc = (e) => {
  const {
    isNotificationSupported: t
  } = Uc();
  return we(() => {
    if (t.result === !0 && e)
      return u2(e);
  }, [e, t.result]);
}, Hc = (e) => {
  const t = Dc(e), [n, r] = ct(async () => {
    if (!t) return;
    const i = await navigator.serviceWorker.ready;
    return d2(t, {
      serviceWorkerRegistration: i
    });
  });
  return ne(() => {
    t && r.execute();
  }, [r, t]), {
    refreshRegistrationToken: te(() => (r.reset(), r.execute()), [r]),
    registrationToken: n
  };
};
var go = e2;
function Cp(e, t, n) {
  t == "__proto__" && go ? go(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Fc = Cp;
function bp(e) {
  return function(t, n, r) {
    for (var a = -1, i = Object(t), o = r(t), s = o.length; s--; ) {
      var c = o[e ? s : ++a];
      if (n(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var yp = bp, Ip = yp, wp = Ip(), Rp = wp;
function Tp(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Sp = Tp, _p = Wn, Pp = en, Lp = "[object Arguments]";
function Np(e) {
  return Pp(e) && _p(e) == Lp;
}
var xp = Np, vo = xp, Op = en, Gc = Object.prototype, kp = Gc.hasOwnProperty, Mp = Gc.propertyIsEnumerable, Bp = vo(/* @__PURE__ */ function() {
  return arguments;
}()) ? vo : function(e) {
  return Op(e) && kp.call(e, "callee") && !Mp.call(e, "callee");
}, dr = Bp, Up = Array.isArray, Pe = Up, Hn = { exports: {} };
function Dp() {
  return !1;
}
var Hp = Dp;
Hn.exports;
(function(e, t) {
  var n = Tt, r = Hp, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  e.exports = l;
})(Hn, Hn.exports);
var Va = Hn.exports, Fp = 9007199254740991, Gp = /^(?:0|[1-9]\d*)$/;
function zp(e, t) {
  var n = typeof e;
  return t = t ?? Fp, !!t && (n == "number" || n != "symbol" && Gp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var zc = zp, Vp = Wn, jp = x1, Xp = en, Yp = "[object Arguments]", Wp = "[object Array]", Qp = "[object Boolean]", Zp = "[object Date]", Kp = "[object Error]", qp = "[object Function]", Jp = "[object Map]", $p = "[object Number]", e7 = "[object Object]", t7 = "[object RegExp]", n7 = "[object Set]", r7 = "[object String]", a7 = "[object WeakMap]", i7 = "[object ArrayBuffer]", o7 = "[object DataView]", s7 = "[object Float32Array]", c7 = "[object Float64Array]", l7 = "[object Int8Array]", u7 = "[object Int16Array]", d7 = "[object Int32Array]", p7 = "[object Uint8Array]", f7 = "[object Uint8ClampedArray]", m7 = "[object Uint16Array]", g7 = "[object Uint32Array]", $ = {};
$[s7] = $[c7] = $[l7] = $[u7] = $[d7] = $[p7] = $[f7] = $[m7] = $[g7] = !0;
$[Yp] = $[Wp] = $[i7] = $[Qp] = $[o7] = $[Zp] = $[Kp] = $[qp] = $[Jp] = $[$p] = $[e7] = $[t7] = $[n7] = $[r7] = $[a7] = !1;
function v7(e) {
  return Xp(e) && jp(e.length) && !!$[Vp(e)];
}
var h7 = v7, Fn = { exports: {} };
Fn.exports;
(function(e, t) {
  var n = t2, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, o = i && n.process, s = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Fn, Fn.exports);
var E7 = Fn.exports, A7 = h7, C7 = O1, ho = E7, Eo = ho && ho.isTypedArray, b7 = Eo ? C7(Eo) : A7, ja = b7, y7 = Sp, I7 = dr, w7 = Pe, R7 = Va, T7 = zc, S7 = ja, _7 = Object.prototype, P7 = _7.hasOwnProperty;
function L7(e, t) {
  var n = w7(e), r = !n && I7(e), a = !n && !r && R7(e), i = !n && !r && !a && S7(e), o = n || r || a || i, s = o ? y7(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || P7.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    T7(l, c))) && s.push(l);
  return s;
}
var N7 = L7, x7 = Object.prototype;
function O7(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || x7;
  return e === n;
}
var Vc = O7;
function k7(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var M7 = k7, B7 = M7, U7 = B7(Object.keys, Object), D7 = U7, H7 = Vc, F7 = D7, G7 = Object.prototype, z7 = G7.hasOwnProperty;
function V7(e) {
  if (!H7(e))
    return F7(e);
  var t = [];
  for (var n in Object(e))
    z7.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var jc = V7, j7 = N7, X7 = jc, Y7 = wa;
function W7(e) {
  return Y7(e) ? j7(e) : X7(e);
}
var Xa = W7, Q7 = Rp, Z7 = Xa;
function K7(e, t) {
  return e && Q7(e, t, Z7);
}
var Xc = K7, q7 = Ra;
function J7() {
  this.__data__ = new q7(), this.size = 0;
}
var $7 = J7;
function ef(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var tf = ef;
function nf(e) {
  return this.__data__.get(e);
}
var rf = nf;
function af(e) {
  return this.__data__.has(e);
}
var of = af, sf = Ra, cf = k1, lf = M1, uf = 200;
function df(e, t) {
  var n = this.__data__;
  if (n instanceof sf) {
    var r = n.__data__;
    if (!cf || r.length < uf - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new lf(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var pf = df, ff = Ra, mf = $7, gf = tf, vf = rf, hf = of, Ef = pf;
function Lt(e) {
  var t = this.__data__ = new ff(e);
  this.size = t.size;
}
Lt.prototype.clear = mf;
Lt.prototype.delete = gf;
Lt.prototype.get = vf;
Lt.prototype.has = hf;
Lt.prototype.set = Ef;
var Yc = Lt;
function Af(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var Cf = Af, bf = Ta, yf = Cf, If = Sa, wf = 1, Rf = 2;
function Tf(e, t, n, r, a, i) {
  var o = n & wf, s = e.length, c = t.length;
  if (s != c && !(o && c > s))
    return !1;
  var l = i.get(e), u = i.get(t);
  if (l && u)
    return l == t && u == e;
  var f = -1, d = !0, v = n & Rf ? new bf() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < s; ) {
    var g = e[f], p = t[f];
    if (r)
      var h = o ? r(p, g, f, t, e, i) : r(g, p, f, e, t, i);
    if (h !== void 0) {
      if (h)
        continue;
      d = !1;
      break;
    }
    if (v) {
      if (!yf(t, function(A, C) {
        if (!If(v, C) && (g === A || a(g, A, n, r, i)))
          return v.push(C);
      })) {
        d = !1;
        break;
      }
    } else if (!(g === p || a(g, p, n, r, i))) {
      d = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), d;
}
var Wc = Tf, Sf = Tt, _f = Sf.Uint8Array, Pf = _f;
function Lf(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
var Nf = Lf;
function xf(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Ya = xf, Ao = _a, Co = Pf, Of = n2, kf = Wc, Mf = Nf, Bf = Ya, Uf = 1, Df = 2, Hf = "[object Boolean]", Ff = "[object Date]", Gf = "[object Error]", zf = "[object Map]", Vf = "[object Number]", jf = "[object RegExp]", Xf = "[object Set]", Yf = "[object String]", Wf = "[object Symbol]", Qf = "[object ArrayBuffer]", Zf = "[object DataView]", bo = Ao ? Ao.prototype : void 0, Mr = bo ? bo.valueOf : void 0;
function Kf(e, t, n, r, a, i, o) {
  switch (n) {
    case Zf:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Qf:
      return !(e.byteLength != t.byteLength || !i(new Co(e), new Co(t)));
    case Hf:
    case Ff:
    case Vf:
      return Of(+e, +t);
    case Gf:
      return e.name == t.name && e.message == t.message;
    case jf:
    case Yf:
      return e == t + "";
    case zf:
      var s = Mf;
    case Xf:
      var c = r & Uf;
      if (s || (s = Bf), e.size != t.size && !c)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      r |= Df, o.set(e, t);
      var u = kf(s(e), s(t), r, a, i, o);
      return o.delete(e), u;
    case Wf:
      if (Mr)
        return Mr.call(e) == Mr.call(t);
  }
  return !1;
}
var qf = Kf;
function Jf(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var Qc = Jf, $f = Qc, em = Pe;
function tm(e, t, n) {
  var r = t(e);
  return em(e) ? r : $f(r, n(e));
}
var nm = tm;
function rm(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, i = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (i[a++] = o);
  }
  return i;
}
var am = rm;
function im() {
  return [];
}
var om = im, sm = am, cm = om, lm = Object.prototype, um = lm.propertyIsEnumerable, yo = Object.getOwnPropertySymbols, dm = yo ? function(e) {
  return e == null ? [] : (e = Object(e), sm(yo(e), function(t) {
    return um.call(e, t);
  }));
} : cm, pm = dm, fm = nm, mm = pm, gm = Xa;
function vm(e) {
  return fm(e, gm, mm);
}
var hm = vm, Io = hm, Em = 1, Am = Object.prototype, Cm = Am.hasOwnProperty;
function bm(e, t, n, r, a, i) {
  var o = n & Em, s = Io(e), c = s.length, l = Io(t), u = l.length;
  if (c != u && !o)
    return !1;
  for (var f = c; f--; ) {
    var d = s[f];
    if (!(o ? d in t : Cm.call(t, d)))
      return !1;
  }
  var v = i.get(e), g = i.get(t);
  if (v && g)
    return v == t && g == e;
  var p = !0;
  i.set(e, t), i.set(t, e);
  for (var h = o; ++f < c; ) {
    d = s[f];
    var A = e[d], C = t[d];
    if (r)
      var b = o ? r(C, A, d, t, e, i) : r(A, C, d, e, t, i);
    if (!(b === void 0 ? A === C || a(A, C, n, r, i) : b)) {
      p = !1;
      break;
    }
    h || (h = d == "constructor");
  }
  if (p && !h) {
    var I = e.constructor, w = t.constructor;
    I != w && "constructor" in e && "constructor" in t && !(typeof I == "function" && I instanceof I && typeof w == "function" && w instanceof w) && (p = !1);
  }
  return i.delete(e), i.delete(t), p;
}
var ym = bm, Im = Qn, wm = Tt, Rm = Im(wm, "DataView"), Tm = Rm, Sm = Qn, _m = Tt, Pm = Sm(_m, "Promise"), Lm = Pm, Nm = Qn, xm = Tt, Om = Nm(xm, "Set"), Zc = Om, km = Qn, Mm = Tt, Bm = km(Mm, "WeakMap"), Um = Bm, ca = Tm, la = k1, ua = Lm, da = Zc, pa = Um, Kc = Wn, Nt = r2, wo = "[object Map]", Dm = "[object Object]", Ro = "[object Promise]", To = "[object Set]", So = "[object WeakMap]", _o = "[object DataView]", Hm = Nt(ca), Fm = Nt(la), Gm = Nt(ua), zm = Nt(da), Vm = Nt(pa), at = Kc;
(ca && at(new ca(new ArrayBuffer(1))) != _o || la && at(new la()) != wo || ua && at(ua.resolve()) != Ro || da && at(new da()) != To || pa && at(new pa()) != So) && (at = function(e) {
  var t = Kc(e), n = t == Dm ? e.constructor : void 0, r = n ? Nt(n) : "";
  if (r)
    switch (r) {
      case Hm:
        return _o;
      case Fm:
        return wo;
      case Gm:
        return Ro;
      case zm:
        return To;
      case Vm:
        return So;
    }
  return t;
});
var qc = at, Br = Yc, jm = Wc, Xm = qf, Ym = ym, Po = qc, Lo = Pe, No = Va, Wm = ja, Qm = 1, xo = "[object Arguments]", Oo = "[object Array]", yn = "[object Object]", Zm = Object.prototype, ko = Zm.hasOwnProperty;
function Km(e, t, n, r, a, i) {
  var o = Lo(e), s = Lo(t), c = o ? Oo : Po(e), l = s ? Oo : Po(t);
  c = c == xo ? yn : c, l = l == xo ? yn : l;
  var u = c == yn, f = l == yn, d = c == l;
  if (d && No(e)) {
    if (!No(t))
      return !1;
    o = !0, u = !1;
  }
  if (d && !u)
    return i || (i = new Br()), o || Wm(e) ? jm(e, t, n, r, a, i) : Xm(e, t, c, n, r, a, i);
  if (!(n & Qm)) {
    var v = u && ko.call(e, "__wrapped__"), g = f && ko.call(t, "__wrapped__");
    if (v || g) {
      var p = v ? e.value() : e, h = g ? t.value() : t;
      return i || (i = new Br()), a(p, h, n, r, i);
    }
  }
  return d ? (i || (i = new Br()), Ym(e, t, n, r, a, i)) : !1;
}
var qm = Km, Jm = qm, Mo = en;
function Jc(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !Mo(e) && !Mo(t) ? e !== e && t !== t : Jm(e, t, n, r, Jc, a);
}
var $c = Jc, $m = Yc, eg = $c, tg = 1, ng = 2;
function rg(e, t, n, r) {
  var a = n.length, i = a, o = !r;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = n[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = n[a];
    var c = s[0], l = e[c], u = s[1];
    if (o && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var f = new $m();
      if (r)
        var d = r(l, u, c, e, t, f);
      if (!(d === void 0 ? eg(u, l, tg | ng, r, f) : d))
        return !1;
    }
  }
  return !0;
}
var ag = rg, ig = a2;
function og(e) {
  return e === e && !ig(e);
}
var el = og, sg = el, cg = Xa;
function lg(e) {
  for (var t = cg(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, sg(a)];
  }
  return t;
}
var ug = lg;
function dg(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var tl = dg, pg = ag, fg = ug, mg = tl;
function gg(e) {
  var t = fg(e);
  return t.length == 1 && t[0][2] ? mg(t[0][0], t[0][1]) : function(n) {
    return n === e || pg(n, e, t);
  };
}
var vg = gg, hg = Wn, Eg = en, Ag = "[object Symbol]";
function Cg(e) {
  return typeof e == "symbol" || Eg(e) && hg(e) == Ag;
}
var Wa = Cg, bg = Pe, yg = Wa, Ig = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, wg = /^\w*$/;
function Rg(e, t) {
  if (bg(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || yg(e) ? !0 : wg.test(e) || !Ig.test(e) || t != null && e in Object(t);
}
var Qa = Rg, nl = M1, Tg = "Expected a function";
function Za(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Tg);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o) || i, o;
  };
  return n.cache = new (Za.Cache || nl)(), n;
}
Za.Cache = nl;
var Sg = Za, _g = Sg, Pg = 500;
function Lg(e) {
  var t = _g(e, function(r) {
    return n.size === Pg && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Ng = Lg, xg = Ng, Og = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, kg = /\\(\\)?/g, Mg = xg(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Og, function(n, r, a, i) {
    t.push(a ? i.replace(kg, "$1") : r || n);
  }), t;
}), Bg = Mg, Bo = _a, Ug = B1, Dg = Pe, Hg = Wa, Fg = 1 / 0, Uo = Bo ? Bo.prototype : void 0, Do = Uo ? Uo.toString : void 0;
function rl(e) {
  if (typeof e == "string")
    return e;
  if (Dg(e))
    return Ug(e, rl) + "";
  if (Hg(e))
    return Do ? Do.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Fg ? "-0" : t;
}
var Gg = rl, zg = Gg;
function Vg(e) {
  return e == null ? "" : zg(e);
}
var jg = Vg, Xg = Pe, Yg = Qa, Wg = Bg, Qg = jg;
function Zg(e, t) {
  return Xg(e) ? e : Yg(e, t) ? [e] : Wg(Qg(e));
}
var al = Zg, Kg = Wa, qg = 1 / 0;
function Jg(e) {
  if (typeof e == "string" || Kg(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -qg ? "-0" : t;
}
var pr = Jg, $g = al, ev = pr;
function tv(e, t) {
  t = $g(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[ev(t[n++])];
  return n && n == r ? e : void 0;
}
var il = tv, nv = il;
function rv(e, t, n) {
  var r = e == null ? void 0 : nv(e, t);
  return r === void 0 ? n : r;
}
var av = rv;
function iv(e, t) {
  return e != null && t in Object(e);
}
var ov = iv, sv = al, cv = dr, lv = Pe, uv = zc, dv = x1, pv = pr;
function fv(e, t, n) {
  t = sv(t, e);
  for (var r = -1, a = t.length, i = !1; ++r < a; ) {
    var o = pv(t[r]);
    if (!(i = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return i || ++r != a ? i : (a = e == null ? 0 : e.length, !!a && dv(a) && uv(o, a) && (lv(e) || cv(e)));
}
var mv = fv, gv = ov, vv = mv;
function hv(e, t) {
  return e != null && vv(e, t, gv);
}
var Ev = hv, Av = $c, Cv = av, bv = Ev, yv = Qa, Iv = el, wv = tl, Rv = pr, Tv = 1, Sv = 2;
function _v(e, t) {
  return yv(e) && Iv(t) ? wv(Rv(e), t) : function(n) {
    var r = Cv(n, e);
    return r === void 0 && r === t ? bv(n, e) : Av(t, r, Tv | Sv);
  };
}
var Pv = _v;
function Lv(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Nv = Lv, xv = il;
function Ov(e) {
  return function(t) {
    return xv(t, e);
  };
}
var kv = Ov, Mv = Nv, Bv = kv, Uv = Qa, Dv = pr;
function Hv(e) {
  return Uv(e) ? Mv(Dv(e)) : Bv(e);
}
var Fv = Hv, Gv = vg, zv = Pv, Vv = i2, jv = Pe, Xv = Fv;
function Yv(e) {
  return typeof e == "function" ? e : e == null ? Vv : typeof e == "object" ? jv(e) ? zv(e[0], e[1]) : Gv(e) : Xv(e);
}
var Ka = Yv, Wv = Fc, Qv = Xc, Zv = Ka;
function Kv(e, t) {
  var n = {};
  return t = Zv(t), Qv(e, function(r, a, i) {
    Wv(n, a, t(r, a, i));
  }), n;
}
var qv = Kv;
const Jv = /* @__PURE__ */ tn(qv);
async function ol(e, t) {
  await e.post("/subscribeTopic", t);
}
async function sl(e, t) {
  await e.post("/unsubscribeTopic", t);
}
const $v = () => {
  const {
    setSubscriptionList: e,
    subscriptionList: t
  } = cl(), [n, r] = ve(
    // Disable sort keys rule to maintain order for display
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    Jv(
      {
        breaking_news: "Breaking",
        scmp_exclusive: "SCMP Exclusive",
        hong_kong: "Hong Kong",
        china: "China"
      },
      /* eslint-enable sort-keys-fix/sort-keys-fix */
      (c, l) => {
        var u;
        return {
          isLoading: !1,
          isSubscribed: (u = t == null ? void 0 : t.includes(l)) !== null && u !== void 0 ? u : !1,
          name: c
        };
      }
    )
  ), {
    notification: a
  } = B(), {
    axiosInstance: i
  } = ll(), {
    registrationToken: o
  } = Hc(a.firebaseApp);
  return {
    handleSubscriptionChange: te(async (c, l) => {
      r((d) => d[c] ? {
        ...d,
        [c]: {
          ...d[c],
          isLoading: !0,
          isSubscribed: l
        }
      } : d);
      try {
        var u, f;
        await (l ? ol(i, {
          token: (u = o.result) !== null && u !== void 0 ? u : "",
          topic: c
        }) : sl(i, {
          token: (f = o.result) !== null && f !== void 0 ? f : "",
          topic: c
        })), e((d) => {
          var v;
          return l ? [...d ?? [], c] : (v = d == null ? void 0 : d.filter((g) => g !== c)) !== null && v !== void 0 ? v : [];
        });
      } finally {
        r((d) => d[c] ? {
          ...d,
          [c]: {
            ...d[c],
            isLoading: !1
          }
        } : d);
      }
    }, [i, e, o]),
    subscriptions: n
  };
}, eh = () => {
  const {
    notification: e
  } = B(), {
    subscriptionList: t
  } = cl(), {
    registrationToken: n
  } = Hc(e.firebaseApp), {
    axiosInstance: r
  } = ll(), {
    remove: a,
    set: i,
    value: o
  } = ye("firebaseToken", {
    parse: (u) => u,
    stringify: (u) => u
  }), [s, c] = ve(o), l = Ia(s);
  ne(() => {
    if (n.result === l.current) return;
    n.result ? (i(n.result), c(n.result)) : (c(void 0), a()), (async () => {
      if (!(!t || t.length === 0))
        try {
          await Promise.all(t.map(async (f) => {
            l.current && await sl(r, {
              token: l.current,
              topic: f
            }), n.result && await ol(r, {
              token: n.result,
              topic: f
            });
          }));
        } catch (f) {
          console.error(new Error("Failed to refresh push notification subscription", {
            cause: f
          }));
        }
    })();
  }, [r, n.result, a, i, t, l]);
}, cl = () => {
  const {
    set: e,
    value: t
  } = ye("subscriptedList");
  return {
    setSubscriptionList: e,
    subscriptionList: t
  };
}, ll = () => {
  const {
    config: e
  } = B();
  return {
    axiosInstance: we(() => Vn.create({
      baseURL: e.notification.host
    }), [e])
  };
}, ul = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "entityUuids"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "scmpPlusPaywallTypeIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "paywallTypeIds",
      variableName: "scmpPlusPaywallTypeIds"
    }],
    kind: "ObjectValue",
    name: "exclude"
  }, {
    fields: [{
      kind: "Variable",
      name: "entityUuids",
      variableName: "entityUuids"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityUuid",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, a = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "__typename",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "urlAlias",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "headline",
    storageKey: null
  }, s = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "socialHeadline",
    storageKey: null
  }, c = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryPanelArticle",
              selections: [a, n, r, i, o, s, {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n
                  /*: any*/
                ],
                storageKey: null
              }],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuBookmarkButtonArticle",
              selections: [
                i,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuSocialButtonArticle",
              selections: [
                n,
                r,
                i,
                o,
                s
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "hooksRemoveReadingHistoryArticle",
              selections: [
                n,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              a,
              i,
              o,
              s,
              {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n,
                  c
                  /*: any*/
                ],
                storageKey: null
              },
              c
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "09c86431a1ac0204ba9edf1bd9f7cdda",
      id: null,
      metadata: {},
      name: "hooksUseReadingHistoryWithArticleQuery",
      operationKind: "query",
      text: `query hooksUseReadingHistoryWithArticleQuery(
  $entityUuids: [String]!
  $first: Int!
  $scmpPlusPaywallTypeIds: [String]
) {
  articles(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, filter: {entityUuids: $entityUuids}, first: $first) {
    edges {
      node {
        entityUuid
        entityId
        ...readingHistoryPanelArticle
        ...readingHistoryActionMenuBookmarkButtonArticle
        ...readingHistoryActionMenuSocialButtonArticle
        ...hooksRemoveReadingHistoryArticle
        id
      }
    }
  }
}

fragment hooksRemoveReadingHistoryArticle on Article {
  entityUuid
  entityId
}

fragment readingHistoryActionMenuBookmarkButtonArticle on Article {
  urlAlias
  entityId
}

fragment readingHistoryActionMenuSocialButtonArticle on Article {
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
}

fragment readingHistoryPanelArticle on Article {
  __typename
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
  application {
    entityUuid
    id
  }
}
`
    }
  };
}();
ul.hash = "cbde35cb215893f736ea456fd1a2e149";
const dl = {
  kind: "InlineDataFragment",
  name: "hooksRemoveReadingHistoryArticle"
};
dl.hash = "9cf9cb93788ef385dc0937902f020c9b";
var th = Ta, nh = U1, rh = D1, ah = B1, ih = O1, oh = Sa, sh = 200;
function ch(e, t, n, r) {
  var a = -1, i = nh, o = !0, s = e.length, c = [], l = t.length;
  if (!s)
    return c;
  n && (t = ah(t, ih(n))), r ? (i = rh, o = !1) : t.length >= sh && (i = oh, o = !1, t = new th(t));
  e:
    for (; ++a < s; ) {
      var u = e[a], f = n == null ? u : n(u);
      if (u = r || u !== 0 ? u : 0, o && f === f) {
        for (var d = l; d--; )
          if (t[d] === f)
            continue e;
        c.push(u);
      } else i(t, f, r) || c.push(u);
    }
  return c;
}
var lh = ch, Ho = _a, uh = dr, dh = Pe, Fo = Ho ? Ho.isConcatSpreadable : void 0;
function ph(e) {
  return dh(e) || uh(e) || !!(Fo && e && e[Fo]);
}
var fh = ph, mh = Qc, gh = fh;
function pl(e, t, n, r, a) {
  var i = -1, o = e.length;
  for (n || (n = gh), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && n(s) ? t > 1 ? pl(s, t - 1, n, r, a) : mh(a, s) : r || (a[a.length] = s);
  }
  return a;
}
var vh = pl, hh = lh, Eh = vh, Ah = o2, Go = s2, Ch = Ah(function(e, t) {
  return Go(e) ? hh(e, Eh(t, 1, Go, !0)) : [];
}), bh = Ch;
const yh = /* @__PURE__ */ tn(bh);
function Ih() {
}
var wh = Ih, Ur = Zc, Rh = wh, Th = Ya, Sh = 1 / 0, _h = Ur && 1 / Th(new Ur([, -0]))[1] == Sh ? function(e) {
  return new Ur(e);
} : Rh, Ph = _h, Lh = Ta, Nh = U1, xh = D1, Oh = Sa, kh = Ph, Mh = Ya, Bh = 200;
function Uh(e, t, n) {
  var r = -1, a = Nh, i = e.length, o = !0, s = [], c = s;
  if (n)
    o = !1, a = xh;
  else if (i >= Bh) {
    var l = t ? null : kh(e);
    if (l)
      return Mh(l);
    o = !1, a = Oh, c = new Lh();
  } else
    c = t ? [] : s;
  e:
    for (; ++r < i; ) {
      var u = e[r], f = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, o && f === f) {
        for (var d = c.length; d--; )
          if (c[d] === f)
            continue e;
        t && c.push(f), s.push(u);
      } else a(c, f, n) || (c !== s && c.push(f), s.push(u));
    }
  return s;
}
var Dh = Uh, Hh = Ka, Fh = Dh;
function Gh(e, t) {
  return e && e.length ? Fh(e, Hh(t)) : [];
}
var zh = Gh;
const Vh = /* @__PURE__ */ tn(zh), zo = async (e, t, n, r = 0) => (await e.get(`items/${t}`, {
  params: {
    limit: n,
    offset: r,
    tz: qa()
  },
  withCredentials: !0
})).data.data || [], jh = (e, t, n) => e.post("/create", n.map(({
  createdAt: r,
  entityUuid: a,
  expiresAt: i
}) => ({
  createdAt: r,
  entitySubType: "article",
  entityType: "node",
  entityUuid: a,
  expiresAt: i,
  itemType: "log",
  userUuid: t
})), {
  withCredentials: !0
}), Xh = (e, t, n) => e.post("/items/delete", {
  entityUuids: [t]
}, {
  params: {
    day: fl(n),
    tz: qa()
  },
  withCredentials: !0
}), Yh = (e, t, n) => e.delete(`/items/${n}`, {
  params: {
    day: fl(t),
    tz: qa()
  },
  withCredentials: !0
}), qa = () => Intl.DateTimeFormat().resolvedOptions().timeZone, fl = (e) => Z1(new Date(e), "yyyy-MM-dd"), Dr = {
  lastSyncedDate: "userArticleReadingHistoryLastUpdate",
  pending: "userNewArticleReadingHistory",
  synced: "userArticleReadingHistory"
}, Vo = 50, gt = (e) => Z1(e, "dd MMM yyyy"), Wh = () => {
  const {
    currentArticleUuid: e,
    user: t
  } = B(), {
    createReadingHistory: n,
    fetchReadingHistory: r,
    lastSyncedDate: a,
    resetLocalReadingHistory: i,
    syncReadingHistory: o
  } = Ja();
  De(async () => {
    await r();
  }), ne(() => {
    t || i();
  }, [i, t]), ne(() => {
    e && n(e);
  }, [n, e]), Bu(() => {
    X1(/* @__PURE__ */ new Date(), new Date(a ?? 0)) < 1 || o();
  }, [o, e, a]);
}, ml = () => {
  const {
    user: e
  } = B(), {
    pendingReadingHistory: t,
    syncedReadingHistory: n
  } = gl();
  return {
    readingHistory: we(() => e ? [...t ?? [], ...n ?? []].sort((i, o) => o.createdAt - i.createdAt) : [], [t, n, e])
  };
}, Ja = () => {
  const {
    config: e,
    handleTrackGA4: t,
    user: n
  } = B(), r = we(() => Vn.create({
    baseURL: e.readingHistory.host,
    headers: {
      apikey: e.readingHistory.apiKey
    }
  }), [e]), {
    lastSyncedDate: a,
    pendingReadingHistory: i,
    setLastSyncedDate: o,
    setPendingReadingHistory: s,
    setSyncedReadingHistory: c
  } = gl(), l = te(async () => {
    if (!n || a) return;
    const p = await zo(r, n.uuid, Vo);
    c(p.map((h) => ({
      createdAt: new Date(h.createdAt).getTime(),
      entityUuid: h.entityUuid
    }))), o(Date.now());
  }, [r, a, o, c, n]), u = te(async () => {
    if (!n || !i || i.length === 0) return;
    const p = i.map((h) => ({
      createdAt: new Date(h.createdAt),
      entityUuid: h.entityUuid,
      expiresAt: new Date(h.createdAt)
    }));
    await jh(r, n.uuid, p);
    try {
      const h = await zo(r, n.uuid, Vo);
      c(h.map((A) => ({
        createdAt: new Date(A.createdAt).getTime(),
        entityUuid: A.entityUuid
      }))), o(Date.now());
    } catch {
      c((h) => [...i ?? [], ...h ?? []]);
    } finally {
      s([]);
    }
  }, [r, i, o, s, c, n]), f = te((p) => {
    if (!n) return;
    const h = {
      createdAt: Date.now(),
      entityUuid: p
    };
    s((A) => Vh([h, ...A ?? []], (b) => `${b.entityUuid}-${gt(b.createdAt)}`)), c((A) => [...A ?? []].filter((C) => !(C.entityUuid === h.entityUuid && gt(C.createdAt) === gt(h.createdAt))));
  }, [s, c, n]), d = te(async (p) => {
    if (!n) return;
    const h = (A) => [...A ?? []].filter((C) => gt(C.createdAt) !== p);
    s(h), c(h), await Yh(r, p, n.uuid), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "clear"
      },
      subcategory: ""
    });
  }, [r, t, s, c, n]), v = te(async (p, h) => {
    if (!n) return;
    const {
      entityId: A,
      entityUuid: C
    } = Nn(dl, p), b = (I) => [...I ?? []].filter((w) => !(w.entityUuid === C && w.createdAt === h));
    s(b), c(b), await Xh(r, C, gt(h)), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "remove",
        article_id: A ?? ""
      },
      subcategory: ""
    });
  }, [r, t, s, c, n]), g = te(() => {
    s([]), c([]), o(0);
  }, [o, s, c]);
  return {
    clearReadingHistory: d,
    createReadingHistory: f,
    fetchReadingHistory: l,
    lastSyncedDate: a,
    removeReadingHistory: v,
    resetLocalReadingHistory: g,
    syncReadingHistory: u
  };
}, gl = () => {
  const {
    set: e,
    value: t
  } = ye(Dr.pending), {
    set: n,
    value: r
  } = ye(Dr.synced), {
    set: a,
    value: i
  } = ye(Dr.lastSyncedDate);
  return {
    lastSyncedDate: i,
    pendingReadingHistory: t,
    setLastSyncedDate: a,
    setPendingReadingHistory: e,
    setSyncedReadingHistory: n,
    syncedReadingHistory: r
  };
}, Qh = () => {
  const e = H1(), {
    readingHistory: t
  } = ml(), n = Uu(), [r, a] = ct(async () => {
    const i = yh(t.map((s) => s.entityUuid), [...n.keys()]);
    if (i.length > 0) {
      const s = await F1(e, ul, {
        entityUuids: [...i],
        first: i.length,
        scmpPlusPaywallTypeIds: [Ru.article.paywallTypeId]
      }).toPromise();
      s == null || s.articles.edges.forEach(({
        node: c
      }) => {
        n.set(c.entityUuid, c);
      });
    }
    return t.map((s) => {
      const c = n.get(s.entityUuid);
      if (c)
        return {
          ...s,
          article: c
        };
    }).filter(xu);
  }, []);
  return ne(() => {
    a.execute();
  }, [a, t]), {
    state: r
  };
}, vl = () => {
  const {
    set: e,
    value: t
  } = ye("isFirstTimeVisitSCMPNotificationWidgetVersionTwo", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, Zh = (e) => /* @__PURE__ */ E.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z", fill: "#001246" })), Kh = (e) => /* @__PURE__ */ E.createElement("svg", { width: 32, height: 25, viewBox: "0 0 32 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 25H32V0H0V25Z", fill: "#FEFEFE" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.76069 22.2007H14.6138V2.79626H2.76019L2.76069 22.2007Z", fill: "#FFCA05" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3866 22.2007H29.2397V2.79626H17.3866V22.2007Z", fill: "#001246" })), qh = (e) => {
  const [t, n] = ct(async () => {
    const a = await Promise.allSettled(e.map((i) => i()));
    for (const i of a)
      if (!(i.status === "rejected" || i.value === null))
        return i.value;
  });
  return P1(() => {
    n.execute();
  }, [e]), {
    message: t.status === "success" ? t.result : void 0
  };
}, Jh = (e) => /* @__PURE__ */ E.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.422 18.945C11.797 19.544 10.99 19.844 10 19.844C9.01 19.844 8.203 19.545 7.578 18.945C7.057 18.451 6.731 17.877 6.601 17.227H2.031C1.51 17.227 1.042 17.044 0.625 16.68C0.208 16.315 0 15.859 0 15.313V15.039L0.234 14.883C1.56648 13.8685 2.62675 12.5395 3.32 11.015C4.023 9.505 4.375 7.852 4.375 6.055C4.375 4.805 4.792 3.763 5.625 2.93C6.276 2.409 7.044 2.031 7.93 1.797C7.982 1.276 8.204 0.846 8.594 0.508C8.984 0.17 9.453 0 10 0C10.546 0 11.016 0.169 11.406 0.507C11.7897 0.83189 12.0286 1.29594 12.07 1.797C13.008 2.031 13.776 2.409 14.375 2.93C15.208 3.763 15.625 4.805 15.625 6.055C15.625 7.852 15.977 9.492 16.68 10.977C17.3654 12.5169 18.4265 13.86 19.766 14.883L20 15.039V15.313C20 15.807 19.792 16.263 19.375 16.68C18.958 17.044 18.49 17.227 17.968 17.227H13.398C13.268 17.878 12.942 18.451 12.422 18.945ZM8.32 18.086C8.763 18.503 9.336 18.711 10.04 18.711H10.039C10.69 18.711 11.25 18.515 11.719 18.125C12.135 17.682 12.344 17.188 12.344 16.641V16.094H17.969C18.177 16.094 18.398 16.003 18.633 15.82C18.685 15.794 18.75 15.703 18.828 15.547C17.448 14.401 16.406 13.034 15.703 11.445C14.921 9.805 14.531 8.008 14.531 6.055C14.531 5.117 14.232 4.35 13.633 3.75C13.112 3.307 12.383 2.982 11.445 2.774L10.977 2.695V1.914C10.977 1.706 10.879 1.518 10.684 1.348C10.488 1.179 10.26 1.094 10 1.094C9.74 1.094 9.512 1.178 9.316 1.348C9.121 1.517 9.023 1.705 9.023 1.915V2.695L8.555 2.813C7.643 2.969 6.914 3.281 6.367 3.75C5.769 4.349 5.469 5.117 5.469 6.055C5.469 8.008 5.078 9.805 4.297 11.445C3.594 13.034 2.552 14.401 1.172 15.547C1.2082 15.6555 1.27613 15.7506 1.367 15.82C1.54099 15.9991 1.78132 16.0983 2.031 16.094H7.695V16.641C7.695 17.188 7.904 17.669 8.32 18.086Z", fill: "currentColor" })), $h = (e) => /* @__PURE__ */ E.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4182 5.81174V10.2989L15.9414 12.4784L15.4259 13.3763L15.2971 13.2903L11.3874 10.8545V5.81174H12.4182ZM22 9.99961C22 12.7636 21.0257 15.1213 19.0787 17.0726C17.1301 19.0247 14.7816 20 12.0316 20C9.79707 20 7.79114 19.3311 6.01621 17.9916L5.88657 17.9065L6.53164 17.0515L6.6605 17.1797C8.20757 18.3761 9.99743 18.9747 12.0316 18.9747C14.4949 18.9747 16.5998 18.0987 18.348 16.3459C20.0954 14.5938 20.9691 12.4784 20.9691 9.99961C20.9691 7.52159 20.0954 5.40538 18.348 3.65334C16.5998 1.9013 14.4949 1.02528 12.0316 1.02528C9.56764 1.02528 7.46193 1.9013 5.71529 3.65334C3.96707 5.40538 3.09414 7.52159 3.09414 9.99961C3.09414 10.3989 3.15071 10.9694 3.26621 11.7095L5.11343 9.57215L5.88657 10.2559L2.92207 13.6326L0 10.2559L0.773929 9.57215L2.14893 11.1538C2.09079 10.6412 2.0625 10.2559 2.0625 9.99961C2.0625 7.23635 3.03679 4.87946 4.98457 2.92736C6.93236 0.976048 9.28164 0 12.0316 0C14.7816 0 17.1301 0.976048 19.0787 2.92736C21.0257 4.87946 22 7.23635 22 9.99961Z", fill: "#001246" }));
var $a = {}, Hr = {};
function fr({
  props: e,
  name: t
}) {
  return J4({
    props: e,
    name: t,
    defaultTheme: w1,
    themeId: R1
  });
}
var sn = {}, Fr = { exports: {} }, jo;
function eE() {
  return jo || (jo = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var i in a) ({}).hasOwnProperty.call(a, i) && (n[i] = a[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Fr)), Fr.exports;
}
var Gr = { exports: {} }, Xo;
function tE() {
  return Xo || (Xo = 1, function(e) {
    function t(n, r) {
      if (n == null) return {};
      var a = {};
      for (var i in n) if ({}.hasOwnProperty.call(n, i)) {
        if (r.indexOf(i) >= 0) continue;
        a[i] = n[i];
      }
      return a;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Gr)), Gr.exports;
}
const nE = /* @__PURE__ */ lt(H4), rE = /* @__PURE__ */ lt(F4), aE = /* @__PURE__ */ lt(G4), iE = /* @__PURE__ */ lt(K4), oE = /* @__PURE__ */ lt(z4), sE = /* @__PURE__ */ lt(Y4);
var xt = Ee;
Object.defineProperty(sn, "__esModule", {
  value: !0
});
var cE = sn.default = bE;
sn.shouldForwardProp = _n;
sn.systemDefaultTheme = void 0;
var Ce = xt(eE()), fa = xt(tE()), Yo = gE(nE), lE = rE;
xt(aE);
xt(iE);
var uE = xt(oE), dE = xt(sE);
const pE = ["ownerState"], fE = ["variants"], mE = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function hl(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (hl = function(r) {
    return r ? n : t;
  })(e);
}
function gE(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = hl(t);
  if (n && n.has(e)) return n.get(e);
  var r = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e) if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
    var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
    o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
  }
  return r.default = e, n && n.set(e, r), r;
}
function vE(e) {
  return Object.keys(e).length === 0;
}
function hE(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function _n(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const EE = sn.systemDefaultTheme = (0, uE.default)(), AE = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function In({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return vE(t) ? e : t[n] || t;
}
function CE(e) {
  return e ? (t, n) => n[e] : null;
}
function Pn(e, t) {
  let {
    ownerState: n
  } = t, r = (0, fa.default)(t, pE);
  const a = typeof e == "function" ? e((0, Ce.default)({
    ownerState: n
  }, r)) : e;
  if (Array.isArray(a))
    return a.flatMap((i) => Pn(i, (0, Ce.default)({
      ownerState: n
    }, r)));
  if (a && typeof a == "object" && Array.isArray(a.variants)) {
    const {
      variants: i = []
    } = a;
    let s = (0, fa.default)(a, fE);
    return i.forEach((c) => {
      let l = !0;
      typeof c.props == "function" ? l = c.props((0, Ce.default)({
        ownerState: n
      }, r, n)) : Object.keys(c.props).forEach((u) => {
        (n == null ? void 0 : n[u]) !== c.props[u] && r[u] !== c.props[u] && (l = !1);
      }), l && (Array.isArray(s) || (s = [s]), s.push(typeof c.style == "function" ? c.style((0, Ce.default)({
        ownerState: n
      }, r, n)) : c.style));
    }), s;
  }
  return a;
}
function bE(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = EE,
    rootShouldForwardProp: r = _n,
    slotShouldForwardProp: a = _n
  } = e, i = (o) => (0, dE.default)((0, Ce.default)({}, o, {
    theme: In((0, Ce.default)({}, o, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return i.__mui_systemSx = !0, (o, s = {}) => {
    (0, Yo.internal_processStyles)(o, (w) => w.filter((R) => !(R != null && R.__mui_systemSx)));
    const {
      name: c,
      slot: l,
      skipVariantsResolver: u,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: d = CE(AE(l))
    } = s, v = (0, fa.default)(s, mE), g = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), p = f || !1;
    let h, A = _n;
    l === "Root" || l === "root" ? A = r : l ? A = a : hE(o) && (A = void 0);
    const C = (0, Yo.default)(o, (0, Ce.default)({
      shouldForwardProp: A,
      label: h
    }, v)), b = (w) => typeof w == "function" && w.__emotion_real !== w || (0, lE.isPlainObject)(w) ? (R) => Pn(w, (0, Ce.default)({}, R, {
      theme: In({
        theme: R.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : w, I = (w, ...R) => {
      let T = b(w);
      const S = R ? R.map(b) : [];
      c && d && S.push((N) => {
        const L = In((0, Ce.default)({}, N, {
          defaultTheme: n,
          themeId: t
        }));
        if (!L.components || !L.components[c] || !L.components[c].styleOverrides)
          return null;
        const x = L.components[c].styleOverrides, k = {};
        return Object.entries(x).forEach(([O, M]) => {
          k[O] = Pn(M, (0, Ce.default)({}, N, {
            theme: L
          }));
        }), d(N, k);
      }), c && !g && S.push((N) => {
        var L;
        const x = In((0, Ce.default)({}, N, {
          defaultTheme: n,
          themeId: t
        })), k = x == null || (L = x.components) == null || (L = L[c]) == null ? void 0 : L.variants;
        return Pn({
          variants: k
        }, (0, Ce.default)({}, N, {
          theme: x
        }));
      }), p || S.push(i);
      const P = S.length - R.length;
      if (Array.isArray(w) && P > 0) {
        const N = new Array(P).fill("");
        T = [...w, ...N], T.raw = [...w.raw, ...N];
      }
      const _ = C(T, ...S);
      return o.muiName && (_.muiName = o.muiName), _;
    };
    return C.withConfig && (I.withConfig = C.withConfig), I;
  };
}
function yE(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const IE = (e) => yE(e) && e !== "classes", cn = cE({
  themeId: R1,
  defaultTheme: w1,
  rootShouldForwardProp: IE
});
function wE(e) {
  return $n("MuiSvgIcon", e);
}
er("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const RE = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], TE = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, a = {
    root: ["root", t !== "inherit" && `color${Ze(t)}`, `fontSize${Ze(n)}`]
  };
  return an(a, wE, r);
}, SE = cn("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ze(n.color)}`], t[`fontSize${Ze(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, a, i, o, s, c, l, u, f, d, v, g;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (a = e.transitions) == null || (a = a.duration) == null ? void 0 : a.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (o = i.pxToRem) == null ? void 0 : o.call(i, 20)) || "1.25rem",
      medium: ((s = e.typography) == null || (c = s.pxToRem) == null ? void 0 : c.call(s, 24)) || "1.5rem",
      large: ((l = e.typography) == null || (u = l.pxToRem) == null ? void 0 : u.call(l, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (d = (e.vars || e).palette) == null || (d = d[t.color]) == null ? void 0 : d.main) != null ? f : {
      action: (v = (e.vars || e).palette) == null || (v = v.action) == null ? void 0 : v.active,
      disabled: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.disabled,
      inherit: void 0
    }[t.color]
  };
}), ma = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = fr({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: o = "inherit",
    component: s = "svg",
    fontSize: c = "medium",
    htmlColor: l,
    inheritViewBox: u = !1,
    titleAccess: f,
    viewBox: d = "0 0 24 24"
  } = r, v = ze(r, RE), g = /* @__PURE__ */ E.isValidElement(a) && a.type === "svg", p = H({}, r, {
    color: o,
    component: s,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: d,
    hasSvgAsChild: g
  }), h = {};
  u || (h.viewBox = d);
  const A = TE(p);
  return /* @__PURE__ */ K.jsxs(SE, H({
    as: s,
    className: de(A.root, i),
    focusable: "false",
    color: l,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n
  }, h, v, g && a.props, {
    ownerState: p,
    children: [g ? a.props.children : a, f ? /* @__PURE__ */ K.jsx("title", {
      children: f
    }) : null]
  }));
});
ma.muiName = "SvgIcon";
function _E(e, t) {
  function n(r, a) {
    return /* @__PURE__ */ K.jsx(ma, H({
      "data-testid": `${t}Icon`,
      ref: a
    }, r, {
      children: e
    }));
  }
  return n.muiName = ma.muiName, /* @__PURE__ */ E.memo(/* @__PURE__ */ E.forwardRef(n));
}
const PE = {
  configure: (e) => {
    cs.configure(e);
  }
}, LE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Ze,
  createChainedFunction: $4,
  createSvgIcon: _E,
  debounce: ed,
  deprecatedPropType: td,
  isMuiElement: nd,
  ownerDocument: Bn,
  ownerWindow: rd,
  requirePropFactory: ad,
  setRef: Vr,
  unstable_ClassNameGenerator: PE,
  unstable_useEnhancedEffect: Ct,
  unstable_useId: od,
  unsupportedProp: sd,
  useControlled: ms,
  useEventCallback: Gt,
  useForkRef: Ke,
  useIsFocusVisible: Oa
}, Symbol.toStringTag, { value: "Module" })), NE = /* @__PURE__ */ lt(LE);
var Wo;
function El() {
  return Wo || (Wo = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = NE;
  }(Hr)), Hr;
}
var xE = Ee;
Object.defineProperty($a, "__esModule", {
  value: !0
});
var Al = $a.default = void 0, OE = xE(El()), kE = K;
Al = $a.default = (0, OE.default)(/* @__PURE__ */ (0, kE.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const ME = () => {
  const [e, t] = ve(!1), n = te(() => {
    t(!0);
  }, []);
  return b2(n, {
    unsupportedBehavior: y2.Immediate
  }), e;
}, BE = (e) => /* @__PURE__ */ E.createElement("svg", { width: 7, height: 12, viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.28961 5.98773L7 11.404L6.36867 12L0 5.98773L6.36867 0L7 0.596502L1.28961 5.98773Z", fill: "#4585FF" })), UE = (e) => /* @__PURE__ */ E.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12C5.40643 12 4.92214 11.819 4.54714 11.4566C4.23429 11.1573 4.03929 10.8113 3.96129 10.4174H1.21886C0.906429 10.4174 0.624857 10.3072 0.375 10.0865C0.125143 9.86624 0 9.59024 0 9.25981V9.09438L0.141 8.99978C0.953143 8.37002 1.57029 7.59081 1.99243 6.66129C2.41414 5.74818 2.625 4.74825 2.625 3.66151C2.625 2.90562 2.87486 2.27586 3.375 1.77179C3.76586 1.45691 4.227 1.22842 4.758 1.08675C4.78929 0.771867 4.92214 0.512274 5.15657 0.307105C5.391 0.1028 5.67214 0 6 0C6.32829 0 6.60943 0.1028 6.84386 0.307105C7.07829 0.512274 7.21114 0.771867 7.24243 1.08675C7.80471 1.22842 8.26586 1.45691 8.625 1.77179C9.12514 2.27586 9.375 2.90562 9.375 3.66151C9.375 4.74825 9.58629 5.73998 10.008 6.63797C10.4297 7.58261 11.0473 8.37002 11.8594 8.99978L12 9.09438V9.25981C12 9.55914 11.8749 9.83471 11.625 10.0865C11.3751 10.3072 11.094 10.4174 10.7816 10.4174H8.03914C7.96114 10.8113 7.76571 11.1573 7.45329 11.4566C7.07829 11.819 6.594 12 6 12Z", fill: "white" })), DE = /* @__PURE__ */ y("div", {
  target: "ehama8b6"
})("font-family:", q, ";>*+*{margin-block-start:20px;}"), HE = /* @__PURE__ */ y("div", {
  target: "ehama8b5"
})({
  name: "y4ohyb",
  styles: "margin-block-end:16px;color:#000000;font-weight:700;font-size:16px;line-height:19px"
}), Cl = /* @__PURE__ */ y("div", {
  target: "ehama8b4"
})("display:none;color:#000000;font-size:16px;font-family:", Rt, ";line-height:19px;"), Ht = /* @__PURE__ */ y(Cl, {
  target: "ehama8b3"
})((e) => e.theme.breakpoints.only("mobile"), "{display:block;}"), FE = /* @__PURE__ */ y(Cl, {
  target: "ehama8b2"
})({
  name: "3qua7i",
  styles: "font-size:14px;line-height:16px"
}), zr = /* @__PURE__ */ y(FE, {
  target: "ehama8b1"
})((e) => e.theme.breakpoints.up("tablet"), "{@supports not (-moz-appearance: none){display:block;}}"), GE = "data:image/png;base64,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", zE = "data:image/png;base64,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", bl = () => {
  const e = () => /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Ht, null, /* @__PURE__ */ m.createElement("img", {
    alt: "",
    src: zE,
    width: "100%"
  })), /* @__PURE__ */ m.createElement(Ht, null, "1. Tap the 3 dot icon in your browser"), /* @__PURE__ */ m.createElement(Ht, null, '2. Tap "Settings"'), /* @__PURE__ */ m.createElement(Ht, null, '3. Tap "Notifications"'), /* @__PURE__ */ m.createElement(Ht, null, "4. Find www.scmp.com and tap to enable")), t = () => /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(zr, null, "1. Click the lock icon in your Chrome browser URL field"), /* @__PURE__ */ m.createElement(zr, null, '2. Find "Notifications" and click "Allow"'), /* @__PURE__ */ m.createElement(zr, null, /* @__PURE__ */ m.createElement("img", {
    alt: "",
    src: GE,
    width: "100%"
  })));
  return /* @__PURE__ */ m.createElement(DE, {
    "data-qa": "notification-instruction"
  }, /* @__PURE__ */ m.createElement(HE, null, "Enabling alerts in your browser"), e(), t());
};
bl.displayName = "NotificationInstruction";
const yl = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: 30,
    kind: "LocalArgument",
    name: "limit"
  }], t = [{
    kind: "Literal",
    name: "exclude",
    value: {
      alertTopicNames: ["Style"]
    }
  }, {
    kind: "Variable",
    name: "first",
    variableName: "limit"
  }, {
    kind: "Literal",
    name: "orderBy",
    value: {
      direction: "DESC",
      field: "CREATED_DATE"
    }
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityUuid",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "createdDate",
    storageKey: null
  }, a = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alertTopicDisplay",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "pushBody",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "url",
    storageKey: null
  }, s = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "__typename",
    storageKey: null
  }, c = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "notificationListQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "PushNotificationConnection",
        kind: "LinkedField",
        name: "pushNotifications",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "PushNotificationEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "PushNotification",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, a, i, o, {
              alias: null,
              args: null,
              concreteType: null,
              kind: "LinkedField",
              name: "content",
              plural: !1,
              selections: [s, {
                kind: "InlineFragment",
                selections: [n, c, {
                  alias: null,
                  args: null,
                  concreteType: "Application",
                  kind: "LinkedField",
                  name: "application",
                  plural: !1,
                  selections: [
                    n
                    /*: any*/
                  ],
                  storageKey: null
                }],
                type: "BaseWithApplicationAndUrlAlias",
                abstractKey: "__isBaseWithApplicationAndUrlAlias"
              }],
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "notificationListQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "PushNotificationConnection",
        kind: "LinkedField",
        name: "pushNotifications",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "PushNotificationEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "PushNotification",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              a,
              i,
              o,
              {
                alias: null,
                args: null,
                concreteType: null,
                kind: "LinkedField",
                name: "content",
                plural: !1,
                selections: [s, {
                  kind: "InlineFragment",
                  selections: [n, c, {
                    alias: null,
                    args: null,
                    concreteType: "Application",
                    kind: "LinkedField",
                    name: "application",
                    plural: !1,
                    selections: [
                      n,
                      l
                      /*: any*/
                    ],
                    storageKey: null
                  }],
                  type: "BaseWithApplicationAndUrlAlias",
                  abstractKey: "__isBaseWithApplicationAndUrlAlias"
                }, {
                  kind: "InlineFragment",
                  selections: [
                    l
                    /*: any*/
                  ],
                  type: "Node",
                  abstractKey: "__isNode"
                }],
                storageKey: null
              },
              l
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "fe55c5db781f6aa1177d1625a2e48248",
      id: null,
      metadata: {},
      name: "notificationListQuery",
      operationKind: "query",
      text: `query notificationListQuery(
  $limit: Int = 30
) {
  pushNotifications(first: $limit, exclude: {alertTopicNames: ["Style"]}, orderBy: {field: CREATED_DATE, direction: DESC}) {
    edges {
      node {
        entityUuid
        createdDate
        alertTopicDisplay
        pushBody
        url
        content {
          __typename
          ... on BaseWithApplicationAndUrlAlias {
            __isBaseWithApplicationAndUrlAlias: __typename
            entityUuid
            entityId
            application {
              entityUuid
              id
            }
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        id
      }
    }
  }
}
`
    }
  };
}();
yl.hash = "2b252c37e35edefce75cd6931c12490f";
const VE = () => {
  const {
    user: e
  } = B(), {
    set: t,
    value: n
  } = ye("localLatestPushNotificationHistory", {}), r = te((i) => {
    const o = /* @__PURE__ */ new Date();
    t((s) => {
      const c = s ?? {};
      return c[i] = {
        createdAt: o.getTime(),
        entityUuid: i,
        expiresAt: (/* @__PURE__ */ new Date()).setDate(o.getDate() + 7),
        userUuid: e == null ? void 0 : e.uuid
      }, c;
    });
  }, [t, e == null ? void 0 : e.uuid]), a = we(() => {
    if (!n) return /* @__PURE__ */ new Set();
    const i = Date.now();
    return new Set(Object.values(n).filter((o) => o.userUuid === (e == null ? void 0 : e.uuid) && o.expiresAt > i).map((o) => o.entityUuid));
  }, [e == null ? void 0 : e.uuid, n]);
  return {
    addNotificationHistory: r,
    notificationHistory: a
  };
}, jE = (e) => /* @__PURE__ */ E.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M15 29.805C16.485 29.805 17.6955 29.355 18.633 28.4565C19.413 27.7155 19.902 26.856 20.097 25.8795H26.952C27.735 25.8795 28.437 25.605 29.0625 25.059C29.688 24.4335 30 23.7495 30 23.0085V22.5975L29.649 22.3635C27.6397 20.829 26.048 18.8144 25.02 16.5045C23.9655 14.2771 23.4375 11.8171 23.4375 9.12156C23.4375 7.24656 22.812 5.68356 21.5625 4.43406C20.664 3.65256 19.512 3.08556 18.105 2.73456C18.0428 1.98297 17.6845 1.2869 17.109 0.799562C16.524 0.292562 15.819 0.0390625 15 0.0390625C14.1795 0.0390625 13.476 0.294062 12.891 0.801062C12.306 1.30806 11.973 1.95306 11.895 2.73456C10.566 3.08556 9.41399 3.65256 8.43749 4.43406C7.18799 5.68356 6.56249 7.24656 6.56249 9.12156C6.56249 11.8171 6.0345 14.2966 4.98 16.5616C3.94012 18.8483 2.34971 20.8418 0.351 22.3635L0 22.5975L0 23.0085C0 23.8275 0.312 24.5115 0.937499 25.059C1.563 25.605 2.265 25.8795 3.0465 25.8795H9.90149C10.0965 26.8545 10.5855 27.7155 11.367 28.4565C12.3045 29.3565 13.515 29.805 15 29.805Z", fill: "#E9EEF2" })), XE = /* @__PURE__ */ y("div", {
  target: "e1duflwq6"
})({
  name: "1bny462",
  styles: "display:flex;flex-direction:column;gap:28px"
}), YE = /* @__PURE__ */ y("div", {
  target: "e1duflwq5"
})("color:#001246;font-size:12px;font-family:", Rt, ";line-height:14px;"), Il = /* @__PURE__ */ y("div", {
  target: "e1duflwq4"
})("color:#666666;font-size:14px;font-family:", q, ";line-height:18px;"), WE = /* @__PURE__ */ y("div", {
  target: "e1duflwq3"
})("color:#a1a1a1;font-size:12px;font-family:", q, ";line-height:14px;"), QE = /* @__PURE__ */ y("a", {
  target: "e1duflwq2"
})("display:flex;flex-direction:column;gap:4px;text-decoration:none;cursor:pointer;:hover ", Il, "{color:#4585ff;}"), ZE = /* @__PURE__ */ y("div", {
  target: "e1duflwq1"
})("margin-block-start:18px;color:#666666;font-size:16px;font-family:", q, ";line-height:19px;"), KE = /* @__PURE__ */ y("div", {
  target: "e1duflwq0"
})({
  name: "pnui3n",
  styles: "display:flex;flex-direction:column;justify-content:center;align-items:center;align-self:center;inline-size:114px;block-size:114px;margin-block-start:60px;margin-inline:auto;color:#e9eef2;font-size:30px;border:4px solid #e9eef2;border-radius:100%;opacity:0.8"
}), wl = ({
  queryReference: e
}) => {
  const {
    currentPageType: t,
    handleRoutePush: n,
    handleTrackGA4: r
  } = B(), a = f2(Rl, e), {
    addNotificationHistory: i,
    notificationHistory: o
  } = VE(), {
    readingHistory: s
  } = ml(), c = async ({
    augmentedUrl: d,
    node: v
  }) => {
    var g, p, h, A, C, b;
    i(v.entityUuid), v.url && (r({
      action: "click",
      category: "noticenter",
      customized_parameters: {
        article_id: (g = (p = v.content) === null || p === void 0 ? void 0 : p.entityId) !== null && g !== void 0 ? g : "",
        highlight: "non-highlight"
      },
      subcategory: "article"
    }), await n(d, {
      applicationId: (h = v.content) === null || h === void 0 || (h = h.application) === null || h === void 0 ? void 0 : h.entityUuid,
      entityId: (A = v.content) === null || A === void 0 ? void 0 : A.entityId,
      entityUuid: (C = v.content) === null || C === void 0 ? void 0 : C.entityUuid,
      type: T1((b = v.content) === null || b === void 0 ? void 0 : b.__typename)
    }));
  }, l = we(() => new Set(s.map((d) => d.entityUuid)), [s]), u = we(() => a.pushNotifications.edges.filter(({
    node: d
  }) => !(o.has(d.entityUuid) || l.has(d.entityUuid))).map((d) => ({
    ...d,
    augmentedUrl: (() => {
      if (!d.node.url) return "";
      try {
        const g = new URL(d.node.url);
        return g.searchParams.set("module", "notification_centre"), g.searchParams.set("pgtype", t), g.protocol = location.protocol, g.host = location.host, g.toString();
      } catch {
        return d.node.url;
      }
    })()
  })), [t, a.pushNotifications.edges, o, l]), f = (d) => {
    if (!d) return "";
    const v = Date.now(), g = G2(v, d);
    return X1(v, d) === 0 ? "1 minute ago" : g === 0 ? `${bi(v, d, {
      unit: "minute"
    })} ago` : g <= 6 ? `${bi(v, d, {
      unit: "hour"
    })} ago` : Ou(d);
  };
  return /* @__PURE__ */ m.createElement(XE, {
    "data-qa": "notification-list"
  }, u.length > 0 ? u.map((d) => {
    var v;
    return /* @__PURE__ */ m.createElement(QE, {
      href: d.augmentedUrl,
      key: d.node.entityUuid,
      onClick: (g) => {
        g.preventDefault(), c(d);
      }
    }, /* @__PURE__ */ m.createElement(YE, null, d.node.alertTopicDisplay), /* @__PURE__ */ m.createElement(Il, null, d.node.pushBody), /* @__PURE__ */ m.createElement(WE, null, f((v = d.node) === null || v === void 0 ? void 0 : v.createdDate)));
  }) : /* @__PURE__ */ m.createElement("div", null, /* @__PURE__ */ m.createElement(ZE, null, "You are up-to-date with all our latest notifications."), /* @__PURE__ */ m.createElement(KE, null, /* @__PURE__ */ m.createElement(jE, null))));
};
wl.displayName = "NotificationList";
const Rl = yl;
function qE(e) {
  const {
    checked: t,
    defaultChecked: n,
    disabled: r,
    onBlur: a,
    onChange: i,
    onFocus: o,
    onFocusVisible: s,
    readOnly: c,
    required: l
  } = e, [u, f] = ms({
    controlled: t,
    default: !!n,
    name: "Switch",
    state: "checked"
  }), d = (S) => (P) => {
    var _;
    P.nativeEvent.defaultPrevented || (f(P.target.checked), i == null || i(P), (_ = S.onChange) == null || _.call(S, P));
  }, {
    isFocusVisibleRef: v,
    onBlur: g,
    onFocus: p,
    ref: h
  } = Oa(), [A, C] = E.useState(!1);
  r && A && C(!1), E.useEffect(() => {
    v.current = A;
  }, [A, v]);
  const b = E.useRef(null), I = (S) => (P) => {
    var _;
    b.current || (b.current = P.currentTarget), p(P), v.current === !0 && (C(!0), s == null || s(P)), o == null || o(P), (_ = S.onFocus) == null || _.call(S, P);
  }, w = (S) => (P) => {
    var _;
    g(P), v.current === !1 && C(!1), a == null || a(P), (_ = S.onBlur) == null || _.call(S, P);
  }, R = Ke(h, b);
  return {
    checked: u,
    disabled: !!r,
    focusVisible: A,
    getInputProps: (S = {}) => H({
      checked: t,
      defaultChecked: n,
      disabled: r,
      readOnly: c,
      ref: R,
      required: l,
      type: "checkbox",
      role: "switch",
      "aria-checked": t
    }, S, {
      onChange: d(S),
      onFocus: I(S),
      onBlur: w(S)
    }),
    inputRef: R,
    readOnly: !!c
  };
}
function JE(e) {
  return typeof e == "string";
}
function $E(e, t, n) {
  return e === void 0 || JE(e) ? t : H({}, t, {
    ownerState: H({}, t.ownerState, n)
  });
}
const eA = {
  disableDefaultClasses: !1
}, tA = /* @__PURE__ */ E.createContext(eA);
function Tl(e) {
  const {
    disableDefaultClasses: t
  } = E.useContext(tA);
  return (n) => t ? "" : e(n);
}
function nA(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function rA(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Qo(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function aA(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const v = de(n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), g = H({}, n == null ? void 0 : n.style, a == null ? void 0 : a.style, r == null ? void 0 : r.style), p = H({}, n, a, r);
    return v.length > 0 && (p.className = v), Object.keys(g).length > 0 && (p.style = g), {
      props: p,
      internalRef: void 0
    };
  }
  const o = nA(H({}, a, r)), s = Qo(r), c = Qo(a), l = t(o), u = de(l == null ? void 0 : l.className, n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), f = H({}, l == null ? void 0 : l.style, n == null ? void 0 : n.style, a == null ? void 0 : a.style, r == null ? void 0 : r.style), d = H({}, l, n, c, s);
  return u.length > 0 && (d.className = u), Object.keys(f).length > 0 && (d.style = f), {
    props: d,
    internalRef: l.ref
  };
}
const iA = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Vt(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: a,
    skipResolvingSlotProps: i = !1
  } = e, o = ze(e, iA), s = i ? {} : rA(r, a), {
    props: c,
    internalRef: l
  } = aA(H({}, o, {
    externalSlotProps: s
  })), u = Ke(l, s == null ? void 0 : s.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return $E(n, H({}, c, {
    ref: u
  }), a);
}
const Sl = "base";
function oA(e) {
  return `${Sl}--${e}`;
}
function sA(e, t) {
  return `${Sl}-${e}-${t}`;
}
function ei(e, t) {
  const n = us[t];
  return n ? oA(n) : sA(e, t);
}
function _l(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = ei(e, r);
  }), n;
}
const Pl = "Switch";
function cA(e) {
  return ei(Pl, e);
}
const Fe = _l(Pl, ["root", "input", "track", "thumb", "checked", "disabled", "focusVisible", "readOnly"]), lA = ["checked", "defaultChecked", "disabled", "onBlur", "onChange", "onFocus", "onFocusVisible", "readOnly", "required", "slotProps", "slots"], uA = (e) => {
  const {
    checked: t,
    disabled: n,
    focusVisible: r,
    readOnly: a
  } = e;
  return an({
    root: ["root", t && "checked", n && "disabled", r && "focusVisible", a && "readOnly"],
    thumb: ["thumb"],
    input: ["input"],
    track: ["track"]
  }, Tl(cA));
}, dA = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var r, a, i, o;
  const {
    slotProps: s = {},
    slots: c = {}
  } = t, l = ze(t, lA), {
    getInputProps: u,
    checked: f,
    disabled: d,
    focusVisible: v,
    readOnly: g
  } = qE(t), p = H({}, t, {
    checked: f,
    disabled: d,
    focusVisible: v,
    readOnly: g
  }), h = uA(p), A = (r = c.root) != null ? r : "span", C = Vt({
    elementType: A,
    externalSlotProps: s.root,
    externalForwardedProps: l,
    additionalProps: {
      ref: n
    },
    ownerState: p,
    className: h.root
  }), b = (a = c.thumb) != null ? a : "span", I = Vt({
    elementType: b,
    externalSlotProps: s.thumb,
    ownerState: p,
    className: h.thumb
  }), w = (i = c.input) != null ? i : "input", R = Vt({
    elementType: w,
    getSlotProps: u,
    externalSlotProps: s.input,
    ownerState: p,
    className: h.input
  }), T = c.track === null ? () => null : (o = c.track) != null ? o : "span", S = Vt({
    elementType: T,
    externalSlotProps: s.track,
    ownerState: p,
    className: h.track
  });
  return /* @__PURE__ */ K.jsxs(A, H({}, C, {
    children: [/* @__PURE__ */ K.jsx(T, H({}, S)), /* @__PURE__ */ K.jsx(b, H({}, I)), /* @__PURE__ */ K.jsx(w, H({}, R))]
  }));
}), pA = /* @__PURE__ */ y("span", {
  target: "e167yolf1"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
}), Zo = /* @__PURE__ */ y(dA, {
  target: "e167yolf0"
})("position:relative;display:inline-block;&.", Fe.root, "{inline-size:37px;block-size:24px;}& .", Fe.input, "{position:absolute;inset-block-start:0;inset-inline-start:0;z-index:1;inline-size:100%;block-size:100%;margin:0;cursor:pointer;opacity:0;}& .", Fe.track, "{position:absolute;display:block;inline-size:100%;block-size:100%;border-radius:12px;background-color:#cccccc;}& .", Fe.thumb, "{position:absolute;inset-block-start:2px;inset-inline-start:2px;display:block;inline-size:20px;block-size:20px;border-radius:10px;background-color:#ffffff;transition:all 0.2s ease;}&.", Fe.checked, "{.", Fe.track, "{background-color:#4585ff;}.", Fe.thumb, "{inset-block-start:2px;inset-inline-start:15px;}}&.", Fe.disabled, "{opacity:0.4;.", Fe.input, "{cursor:not-allowed;}}"), Ll = ({
  label: e,
  ...t
}) => e ? /* @__PURE__ */ m.createElement(pA, null, /* @__PURE__ */ m.createElement(Zo, t), e) : /* @__PURE__ */ m.createElement(Zo, t);
Ll.displayName = "Switch";
const fA = (e) => /* @__PURE__ */ E.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 180 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("circle", { cx: 90, cy: 90, r: 88, stroke: "#DAE3E9", strokeWidth: 4 }), /* @__PURE__ */ E.createElement("circle", { opacity: 0.8, cx: 90, cy: 90, r: 55.012, fill: "white", stroke: "#DAE3E9", strokeWidth: 4 }), /* @__PURE__ */ E.createElement("circle", { opacity: 0.6, cx: 90, cy: 90, r: 25, fill: "white", stroke: "#DAE3E9", strokeWidth: 4 }), /* @__PURE__ */ E.createElement("path", { d: "M88.7029 104.748C90.1822 104.878 91.4273 104.535 92.4396 103.722C93.2812 103.051 93.8432 102.238 94.1226 101.282L100.952 101.879C101.732 101.948 102.455 101.735 103.125 101.246C103.803 100.677 104.174 100.023 104.238 99.2851L104.274 98.8756L103.945 98.6119C102.077 96.9081 100.667 94.7624 99.844 92.3718C98.9876 90.0609 98.676 87.5642 98.911 84.879C99.0744 83.0111 98.5875 81.3995 97.4516 80.0459C96.6247 79.1891 95.5265 78.5238 94.1554 78.0515C94.159 77.2974 93.8627 76.5727 93.3318 76.0371C92.7933 75.481 92.113 75.167 91.2972 75.0957C90.4798 75.0242 89.7567 75.2169 89.1298 75.671C88.5028 76.125 88.1149 76.7386 87.969 77.5103C86.6145 77.7441 85.4175 78.2086 84.3766 78.902C83.0229 80.0378 82.2636 81.5404 82.1002 83.4082C81.8653 86.0935 81.1232 88.5175 79.8753 90.682C78.64 92.8694 76.8819 94.7166 74.7582 96.0585L74.3881 96.261L74.3523 96.6704C74.2809 97.4863 74.5321 98.1949 75.1075 98.7948C75.6831 99.3932 76.3585 99.7279 77.137 99.796L83.9659 100.393C84.0752 101.382 84.4873 102.282 85.2012 103.088C86.0567 104.067 87.2235 104.619 88.7029 104.748Z", fill: "#7E8599" })), mA = /* @__PURE__ */ y("div", {
  target: "e1mwq9098"
})("display:flex;flex-flow:column;justify-content:flex-start;align-items:stretch;color:#666666;font-size:14px;font-family:", q, ";line-height:16px;"), gA = /* @__PURE__ */ y("div", {
  target: "e1mwq9097"
})({
  name: "1wruhbv",
  styles: "display:flex;flex-flow:column;justify-content:flex-start;align-items:stretch;>*+*{margin-block-start:16px;}"
}), vA = /* @__PURE__ */ y("div", {
  target: "e1mwq9096"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
}), hA = /* @__PURE__ */ y("div", {
  target: "e1mwq9095"
})({
  name: "1s5w14c",
  styles: "margin-inline-end:auto;color:#001246;font-weight:700;font-size:14px;line-height:16px"
}), Ko = /* @__PURE__ */ y("hr", {
  target: "e1mwq9094"
})({
  name: "1fk5uf4",
  styles: "inline-size:100%;margin-block:16px;margin-inline:0;border:none;border-block-end:1px solid #d8d8d8"
}), qo = /* @__PURE__ */ y("div", {
  target: "e1mwq9093"
})({
  name: "s5grb8",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;margin-inline-end:10px;animation:fadeInOut 2s linear infinite;@keyframes fadeInOut{0%,100%{opacity:0;}50%{opacity:1;}}"
}), EA = /* @__PURE__ */ y("div", {
  target: "e1mwq9092"
})({
  name: "647xa2",
  styles: "color:rgb(102, 102, 102);font-size:14px;line-height:16px;>a{color:#4585ff;text-decoration:none;}"
}), AA = /* @__PURE__ */ y("div", {
  target: "e1mwq9091"
})("color:#666666;font-weight:400;font-size:14px;font-family:", q, ";line-height:18px;"), CA = /* @__PURE__ */ y(fA, {
  target: "e1mwq9090"
})({
  name: "ka7xg9",
  styles: "margin:28px"
}), bA = "data:image/gif;base64,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", Nl = ({
  isNotificationSupported: e,
  onPermissionDenied: t
}) => {
  const {
    handleTrackGA4: n
  } = B();
  De(() => {
    n({
      action: "imp",
      category: "noticenter",
      customized_parameters: void 0,
      subcategory: "alert"
    });
  });
  const r = Et(ht.breakpoints.only("mobile"), !1), a = () => {
    const g = new URL("https://scmp.onelink.me/3586748601");
    return g.searchParams.set("af_dp", "scmp://"), g.searchParams.set("af_web_dp", "https://www.scmp.com/mobile"), g.searchParams.set("c", "notification_settings"), g.searchParams.set("pid", r ? "scmp_mdot" : "scmp"), /* @__PURE__ */ m.createElement(EA, {
      "data-qa": "render-download-link"
    }, /* @__PURE__ */ m.createElement("a", {
      href: g.toString(),
      rel: "noreferrer",
      target: "_blank"
    }, "Download"), " the SCMP app to access more alert options");
  }, {
    handleSubscriptionChange: i,
    subscriptions: o
  } = $v(), {
    isAvailable: s,
    isDenied: c,
    isGranted: l,
    isPrompt: u,
    requestPermission: f
  } = I2(), d = te(async (g, p) => {
    s && (u ? await f() : c ? t == null || t() : l && (await i(g, p), n({
      action: "sys",
      category: "noticenter",
      customized_parameters: {
        enable: p ? "enable" : "disable",
        location: "alerts settings",
        section_name: g
      },
      subcategory: "alert"
    })));
  }, [i, n, s, c, l, u, t, f]), v = () => /* @__PURE__ */ m.createElement(gA, {
    "data-qa": "render-subscription-list"
  }, Object.entries(o).map(([g, p]) => /* @__PURE__ */ m.createElement(vA, {
    key: g
  }, /* @__PURE__ */ m.createElement(hA, null, p.name), p.isLoading ? /* @__PURE__ */ m.createElement(qo, null, /* @__PURE__ */ m.createElement("img", {
    alt: "",
    height: 24,
    src: bA,
    width: 24
  })) : null, /* @__PURE__ */ m.createElement(Ll, {
    checked: p.isSubscribed,
    disabled: p.isLoading,
    onChange: (h) => {
      d(g, h.target.checked);
    }
  }))));
  switch (e.status) {
    case "not-executed":
    case "loading":
      return /* @__PURE__ */ m.createElement(qo, null, /* @__PURE__ */ m.createElement("img", {
        height: "122",
        src: "https://assets.i-scmp.com/static/img/gifs/wheel_on_white.gif",
        width: "122"
      }));
    case "error":
    case "success":
      return e.result ? /* @__PURE__ */ m.createElement(mA, null, "Switch on notifications to keep informed on the latest news and breaking stories.", /* @__PURE__ */ m.createElement(Ko, null), v(), /* @__PURE__ */ m.createElement(Ko, null), a()) : /* @__PURE__ */ m.createElement(AA, null, "It looks like your browser doesn't support push notifications. Please try again with another browser.", /* @__PURE__ */ m.createElement(CA, null));
  }
};
Nl.displayName = "NotificationSetting";
function yA(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: a,
    rippleY: i,
    rippleSize: o,
    in: s,
    onExited: c,
    timeout: l
  } = e, [u, f] = E.useState(!1), d = de(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), v = {
    width: o,
    height: o,
    top: -(o / 2) + i,
    left: -(o / 2) + a
  }, g = de(n.child, u && n.childLeaving, r && n.childPulsate);
  return !s && !u && f(!0), E.useEffect(() => {
    if (!s && c != null) {
      const p = setTimeout(c, l);
      return () => {
        clearTimeout(p);
      };
    }
  }, [c, s, l]), /* @__PURE__ */ K.jsx("span", {
    className: d,
    style: v,
    children: /* @__PURE__ */ K.jsx("span", {
      className: g
    })
  });
}
const be = er("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), IA = ["center", "classes", "className"];
let mr = (e) => e, Jo, $o, e1, t1;
const ga = 550, wA = 80, RA = Xn(Jo || (Jo = mr`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), TA = Xn($o || ($o = mr`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), SA = Xn(e1 || (e1 = mr`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), _A = cn("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), PA = cn(yA, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(t1 || (t1 = mr`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), be.rippleVisible, RA, ga, ({
  theme: e
}) => e.transitions.easing.easeInOut, be.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, be.child, be.childLeaving, TA, ga, ({
  theme: e
}) => e.transitions.easing.easeInOut, be.childPulsate, SA, ({
  theme: e
}) => e.transitions.easing.easeInOut), LA = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = fr({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: a = !1,
    classes: i = {},
    className: o
  } = r, s = ze(r, IA), [c, l] = E.useState([]), u = E.useRef(0), f = E.useRef(null);
  E.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const d = E.useRef(!1), v = pd(), g = E.useRef(null), p = E.useRef(null), h = E.useCallback((I) => {
    const {
      pulsate: w,
      rippleX: R,
      rippleY: T,
      rippleSize: S,
      cb: P
    } = I;
    l((_) => [..._, /* @__PURE__ */ K.jsx(PA, {
      classes: {
        ripple: de(i.ripple, be.ripple),
        rippleVisible: de(i.rippleVisible, be.rippleVisible),
        ripplePulsate: de(i.ripplePulsate, be.ripplePulsate),
        child: de(i.child, be.child),
        childLeaving: de(i.childLeaving, be.childLeaving),
        childPulsate: de(i.childPulsate, be.childPulsate)
      },
      timeout: ga,
      pulsate: w,
      rippleX: R,
      rippleY: T,
      rippleSize: S
    }, u.current)]), u.current += 1, f.current = P;
  }, [i]), A = E.useCallback((I = {}, w = {}, R = () => {
  }) => {
    const {
      pulsate: T = !1,
      center: S = a || w.pulsate,
      fakeElement: P = !1
      // For test purposes
    } = w;
    if ((I == null ? void 0 : I.type) === "mousedown" && d.current) {
      d.current = !1;
      return;
    }
    (I == null ? void 0 : I.type) === "touchstart" && (d.current = !0);
    const _ = P ? null : p.current, N = _ ? _.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let L, x, k;
    if (S || I === void 0 || I.clientX === 0 && I.clientY === 0 || !I.clientX && !I.touches)
      L = Math.round(N.width / 2), x = Math.round(N.height / 2);
    else {
      const {
        clientX: O,
        clientY: M
      } = I.touches && I.touches.length > 0 ? I.touches[0] : I;
      L = Math.round(O - N.left), x = Math.round(M - N.top);
    }
    if (S)
      k = Math.sqrt((2 * N.width ** 2 + N.height ** 2) / 3), k % 2 === 0 && (k += 1);
    else {
      const O = Math.max(Math.abs((_ ? _.clientWidth : 0) - L), L) * 2 + 2, M = Math.max(Math.abs((_ ? _.clientHeight : 0) - x), x) * 2 + 2;
      k = Math.sqrt(O ** 2 + M ** 2);
    }
    I != null && I.touches ? g.current === null && (g.current = () => {
      h({
        pulsate: T,
        rippleX: L,
        rippleY: x,
        rippleSize: k,
        cb: R
      });
    }, v.start(wA, () => {
      g.current && (g.current(), g.current = null);
    })) : h({
      pulsate: T,
      rippleX: L,
      rippleY: x,
      rippleSize: k,
      cb: R
    });
  }, [a, h, v]), C = E.useCallback(() => {
    A({}, {
      pulsate: !0
    });
  }, [A]), b = E.useCallback((I, w) => {
    if (v.clear(), (I == null ? void 0 : I.type) === "touchend" && g.current) {
      g.current(), g.current = null, v.start(0, () => {
        b(I, w);
      });
      return;
    }
    g.current = null, l((R) => R.length > 0 ? R.slice(1) : R), f.current = w;
  }, [v]);
  return E.useImperativeHandle(n, () => ({
    pulsate: C,
    start: A,
    stop: b
  }), [C, A, b]), /* @__PURE__ */ K.jsx(_A, H({
    className: de(be.root, i.root, o),
    ref: p
  }, s, {
    children: /* @__PURE__ */ K.jsx(w2, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
function NA(e) {
  return $n("MuiButtonBase", e);
}
const xA = er("MuiButtonBase", ["root", "disabled", "focusVisible"]), OA = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], kA = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: a
  } = e, o = an({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, NA, a);
  return n && r && (o.root += ` ${r}`), o;
}, MA = cn("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${xA.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), BA = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = fr({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: a,
    centerRipple: i = !1,
    children: o,
    className: s,
    component: c = "button",
    disabled: l = !1,
    disableRipple: u = !1,
    disableTouchRipple: f = !1,
    focusRipple: d = !1,
    LinkComponent: v = "a",
    onBlur: g,
    onClick: p,
    onContextMenu: h,
    onDragLeave: A,
    onFocus: C,
    onFocusVisible: b,
    onKeyDown: I,
    onKeyUp: w,
    onMouseDown: R,
    onMouseLeave: T,
    onMouseUp: S,
    onTouchEnd: P,
    onTouchMove: _,
    onTouchStart: N,
    tabIndex: L = 0,
    TouchRippleProps: x,
    touchRippleRef: k,
    type: O
  } = r, M = ze(r, OA), D = E.useRef(null), F = E.useRef(null), V = Ke(F, k), {
    isFocusVisibleRef: ee,
    onFocus: X,
    onBlur: Y,
    ref: J
  } = Oa(), [W, Q] = E.useState(!1);
  l && W && Q(!1), E.useImperativeHandle(a, () => ({
    focusVisible: () => {
      Q(!0), D.current.focus();
    }
  }), []);
  const [re, Le] = E.useState(!1);
  E.useEffect(() => {
    Le(!0);
  }, []);
  const ce = re && !u && !l;
  E.useEffect(() => {
    W && d && !u && re && F.current.pulsate();
  }, [u, d, W, re]);
  function Z(U, ui, su = f) {
    return Gt((di) => (ui && ui(di), !su && F.current && F.current[U](di), !0));
  }
  const Ne = Z("start", R), Ot = Z("stop", h), vr = Z("stop", A), dn = Z("stop", S), hr = Z("stop", (U) => {
    W && U.preventDefault(), T && T(U);
  }), Er = Z("start", N), pn = Z("stop", P), fn = Z("stop", _), Ar = Z("stop", (U) => {
    Y(U), ee.current === !1 && Q(!1), g && g(U);
  }, !1), Cr = Gt((U) => {
    D.current || (D.current = U.currentTarget), X(U), ee.current === !0 && (Q(!0), b && b(U)), C && C(U);
  }), Se = () => {
    const U = D.current;
    return c && c !== "button" && !(U.tagName === "A" && U.href);
  }, je = E.useRef(!1), mn = Gt((U) => {
    d && !je.current && W && F.current && U.key === " " && (je.current = !0, F.current.stop(U, () => {
      F.current.start(U);
    })), U.target === U.currentTarget && Se() && U.key === " " && U.preventDefault(), I && I(U), U.target === U.currentTarget && Se() && U.key === "Enter" && !l && (U.preventDefault(), p && p(U));
  }), gn = Gt((U) => {
    d && U.key === " " && F.current && W && !U.defaultPrevented && (je.current = !1, F.current.stop(U, () => {
      F.current.pulsate(U);
    })), w && w(U), p && U.target === U.currentTarget && Se() && U.key === " " && !U.defaultPrevented && p(U);
  });
  let Xe = c;
  Xe === "button" && (M.href || M.to) && (Xe = v);
  const Ye = {};
  Xe === "button" ? (Ye.type = O === void 0 ? "button" : O, Ye.disabled = l) : (!M.href && !M.to && (Ye.role = "button"), l && (Ye["aria-disabled"] = l));
  const vn = Ke(n, J, D), kt = H({}, r, {
    centerRipple: i,
    component: c,
    disabled: l,
    disableRipple: u,
    disableTouchRipple: f,
    focusRipple: d,
    tabIndex: L,
    focusVisible: W
  }), hn = kA(kt);
  return /* @__PURE__ */ K.jsxs(MA, H({
    as: Xe,
    className: de(hn.root, s),
    ownerState: kt,
    onBlur: Ar,
    onClick: p,
    onContextMenu: Ot,
    onFocus: Cr,
    onKeyDown: mn,
    onKeyUp: gn,
    onMouseDown: Ne,
    onMouseLeave: hr,
    onMouseUp: dn,
    onDragLeave: vr,
    onTouchEnd: pn,
    onTouchMove: fn,
    onTouchStart: Er,
    ref: vn,
    tabIndex: l ? -1 : L,
    type: O
  }, Ye, M, {
    children: [o, ce ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ K.jsx(LA, H({
        ref: V,
        center: i
      }, x))
    ) : null]
  }));
});
function UA(e) {
  return $n("MuiTab", e);
}
const tt = er("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), DA = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], HA = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: r,
    wrapped: a,
    icon: i,
    label: o,
    selected: s,
    disabled: c
  } = e, l = {
    root: ["root", i && o && "labelIcon", `textColor${Ze(n)}`, r && "fullWidth", a && "wrapped", s && "selected", c && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return an(l, UA, t);
}, FA = cn(BA, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${Ze(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped];
  }
})(({
  theme: e,
  ownerState: t
}) => H({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${tt.iconWrapper}`]: H({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${tt.selected}`]: {
    opacity: 1
  },
  [`&.${tt.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${tt.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${tt.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${tt.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${tt.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), GA = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = fr({
    props: t,
    name: "MuiTab"
  }), {
    className: a,
    disabled: i = !1,
    disableFocusRipple: o = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: s,
    icon: c,
    iconPosition: l = "top",
    // eslint-disable-next-line react/prop-types
    indicator: u,
    label: f,
    onChange: d,
    onClick: v,
    onFocus: g,
    // eslint-disable-next-line react/prop-types
    selected: p,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: h,
    // eslint-disable-next-line react/prop-types
    textColor: A = "inherit",
    value: C,
    wrapped: b = !1
  } = r, I = ze(r, DA), w = H({}, r, {
    disabled: i,
    disableFocusRipple: o,
    selected: p,
    icon: !!c,
    iconPosition: l,
    label: !!f,
    fullWidth: s,
    textColor: A,
    wrapped: b
  }), R = HA(w), T = c && f && /* @__PURE__ */ E.isValidElement(c) ? /* @__PURE__ */ E.cloneElement(c, {
    className: de(R.iconWrapper, c.props.className)
  }) : c, S = (_) => {
    !p && d && d(_, C), v && v(_);
  }, P = (_) => {
    h && !p && d && d(_, C), g && g(_);
  };
  return /* @__PURE__ */ K.jsxs(FA, H({
    focusRipple: !o,
    className: de(R.root, a),
    ref: n,
    role: "tab",
    "aria-selected": p,
    disabled: i,
    onClick: S,
    onFocus: P,
    ownerState: w,
    tabIndex: p ? 0 : -1
  }, I, {
    children: [l === "top" || l === "start" ? /* @__PURE__ */ K.jsxs(E.Fragment, {
      children: [T, f]
    }) : /* @__PURE__ */ K.jsxs(E.Fragment, {
      children: [f, T]
    }), u]
  }));
}), zA = /* @__PURE__ */ y("div", {
  target: "e1h768hc11"
})({
  name: "1ehb0iy",
  styles: "display:flex;flex-flow:column nowrap;border:1px solid #a1a1a1;border-radius:4px;background:#f2f2f2;overflow:hidden"
}), VA = /* @__PURE__ */ y("div", {
  target: "e1h768hc10"
})({
  name: "6cm4s2",
  styles: "display:flex;flex-flow:column nowrap;gap:20px;padding:20px"
}), jA = /* @__PURE__ */ y("div", {
  target: "e1h768hc9"
})({
  name: "ege6rc",
  styles: 'display:grid;grid:"greeting link" min-content "message message" min-content/1fr max-content;grid-gap:12px;align-items:baseline;min-inline-size:90px'
}), XA = /* @__PURE__ */ y("span", {
  target: "e1h768hc8"
})("grid-area:greeting;color:#000000;font-weight:400;font-size:16px;font-family:", Rt, ";line-height:21px;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:16px;line-height:19px;}"), YA = /* @__PURE__ */ y("span", {
  target: "e1h768hc7"
})({
  name: "1666q6m",
  styles: "font-weight:700;word-break:break-all"
}), n1 = /* @__PURE__ */ y("a", {
  target: "e1h768hc6"
})("grid-area:link;justify-self:flex-end;color:#4585ff;font-weight:400;font-size:16px;font-family:", q, ";line-height:19px;white-space:nowrap;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:16px;}"), WA = /* @__PURE__ */ y("div", {
  target: "e1h768hc5"
})({
  name: "1k47rlg",
  styles: "grid-area:message"
}), QA = /* @__PURE__ */ y("div", {
  target: "e1h768hc4"
})({
  name: "1tc6xju",
  styles: "flex:1;overflow:auto"
}), ZA = /* @__PURE__ */ y(g2, {
  target: "e1h768hc3"
})({
  name: "cm8g6c",
  styles: "& .MuiTabs-indicator{background:transparent;}"
}), r1 = /* @__PURE__ */ y(GA, {
  target: "e1h768hc2"
})({
  name: "sx84vj",
  styles: "background:transparent;&.Mui-selected{color:unset;background:#ffffff;}"
}), a1 = /* @__PURE__ */ y(v2, {
  target: "e1h768hc1"
})({
  name: "3fbphs",
  styles: "block-size:100%;padding:0"
}), KA = /* @__PURE__ */ y("div", {
  target: "e1h768hc0"
})({
  name: "w65oug",
  styles: "display:flex;justify-content:center;align-items:center;min-block-size:56px;background:#ededed"
}), xl = {
  name: "1qpdkzg",
  styles: "scrollbar-width:thin;scrollbar-gutter:stable;&::-webkit-scrollbar{inline-size:6px;background-color:#f5f5f5;}&::-webkit-scrollbar-track{background-color:#f5f5f5;}&::-webkit-scrollbar-thumb{border-radius:20px;background-color:#cccccc;}&::-webkit-scrollbar-thumb:hover{background:#bbbbbb;}"
}, ti = /* @__PURE__ */ y("div", {
  target: "e18mxoo510"
})("padding:20px;overflow-y:auto;", xl, ";"), qA = /* @__PURE__ */ y(ti, {
  target: "e18mxoo59"
})({
  name: "1vvqhg6",
  styles: "block-size:100%;background:#ffffff"
}), JA = /* @__PURE__ */ y(ti, {
  target: "e18mxoo58"
})({
  name: "1vvqhg6",
  styles: "block-size:100%;background:#ffffff"
}), $A = /* @__PURE__ */ y(ti, {
  target: "e18mxoo57"
})({
  name: "1307fi",
  styles: "display:flex;flex-flow:column nowrap;block-size:100%;background:#e9e9e9"
}), i1 = /* @__PURE__ */ y("header", {
  target: "e18mxoo56"
})("position:relative;display:flex;justify-content:space-between;align-items:center;margin-block-end:20px;font-family:", q, ";"), eC = /* @__PURE__ */ y("span", {
  target: "e18mxoo55"
})({
  name: "1wmje8x",
  styles: "color:#001246;font-weight:700;font-size:16px;line-height:19px"
}), tC = /* @__PURE__ */ y("button", {
  target: "e18mxoo54"
})({
  name: "zox03d",
  styles: "display:flex;gap:4px;align-items:center;padding-block:2px;padding-inline:4px;color:#ffffff;font-size:14px;line-height:16px;text-transform:uppercase;border:none;border-radius:2px;background:rgb(69, 133, 255);cursor:pointer"
}), nC = /* @__PURE__ */ y("span", {
  target: "e18mxoo53"
})("margin:auto;color:#001246;font-size:14px;font-family:", q, ";line-height:16px;text-align:center;"), rC = /* @__PURE__ */ y("button", {
  target: "e18mxoo52"
})({
  name: "1wa3riq",
  styles: "position:absolute;inset-inline-start:0;padding:0;color:#4585ff;border:none;background:transparent;cursor:pointer"
}), aC = /* @__PURE__ */ y(Yn, {
  target: "e18mxoo51"
})({
  name: "k9g07u",
  styles: "margin-inline-start:auto;color:#000000"
}), iC = /* @__PURE__ */ y(N1, {
  target: "e18mxoo50"
})({
  name: "1k060r5",
  styles: "display:block;margin:auto;color:#4585ff"
}), Ol = ({
  notificationListQuery: e
}) => {
  const [t, n] = ve("list"), {
    isNotificationSupported: r
  } = Uc(), {
    handleTrackGA4: a
  } = B(), [i, o] = ve(!1);
  De(() => {
    o(!0);
  });
  const s = ME();
  switch (ne(() => {
    !s || !i || a({
      action: "imp",
      category: "noticenter",
      customized_parameters: void 0,
      subcategory: ""
    });
  }, [a, s, i]), t) {
    case "list":
      return /* @__PURE__ */ m.createElement(qA, null, /* @__PURE__ */ m.createElement(i1, null, /* @__PURE__ */ m.createElement(eC, null, "Notifications"), /* @__PURE__ */ m.createElement(tC, {
        onClick: () => {
          n("setting");
        }
      }, /* @__PURE__ */ m.createElement(UE, null), "Alerts")), /* @__PURE__ */ m.createElement(b1, {
        fallback: /* @__PURE__ */ m.createElement(iC, {
          color: "inherit"
        })
      }, e && /* @__PURE__ */ m.createElement(wl, {
        queryReference: e
      })));
    case "setting":
      return /* @__PURE__ */ m.createElement(JA, null, /* @__PURE__ */ m.createElement(i1, null, /* @__PURE__ */ m.createElement(rC, {
        onClick: () => n("list")
      }, /* @__PURE__ */ m.createElement(BE, {
        fontSize: "inherit"
      })), /* @__PURE__ */ m.createElement(nC, null, "Alerts")), /* @__PURE__ */ m.createElement(Nl, {
        isNotificationSupported: r,
        onPermissionDenied: () => n("instructions")
      }));
    case "instructions":
      return /* @__PURE__ */ m.createElement($A, null, /* @__PURE__ */ m.createElement(aC, {
        "aria-label": "close",
        onClick: () => n("setting")
      }, /* @__PURE__ */ m.createElement(Al, {
        color: "inherit"
      })), /* @__PURE__ */ m.createElement(bl, null));
  }
};
Ol.displayName = "NotificationPanel";
const kl = {
  kind: "InlineDataFragment",
  name: "readingHistoryPanelArticle"
};
kl.hash = "af787a050af248c5e8bd042565039780";
var ni = {}, oC = Ee;
Object.defineProperty(ni, "__esModule", {
  value: !0
});
var Ml = ni.default = void 0, sC = oC(El()), cC = K;
Ml = ni.default = (0, sC.default)(/* @__PURE__ */ (0, cC.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");
function lC(e, t, n, r) {
  for (var a = -1, i = e == null ? 0 : e.length; ++a < i; ) {
    var o = e[a];
    t(r, o, n(o), e);
  }
  return r;
}
var uC = lC, dC = wa;
function pC(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!dC(n))
      return e(n, r);
    for (var a = n.length, i = t ? a : -1, o = Object(n); (t ? i-- : ++i < a) && r(o[i], i, o) !== !1; )
      ;
    return n;
  };
}
var fC = pC, mC = Xc, gC = fC, vC = gC(mC), hC = vC, EC = hC;
function AC(e, t, n, r) {
  return EC(e, function(a, i, o) {
    t(r, a, n(a), o);
  }), r;
}
var CC = AC, bC = uC, yC = CC, IC = Ka, wC = Pe;
function RC(e, t) {
  return function(n, r) {
    var a = wC(n) ? bC : yC, i = t ? t() : {};
    return a(n, e, IC(r), i);
  };
}
var TC = RC, SC = Fc, _C = TC, PC = Object.prototype, LC = PC.hasOwnProperty, NC = _C(function(e, t, n) {
  LC.call(e, n) ? e[n].push(t) : SC(e, n, [t]);
}), xC = NC;
const OC = /* @__PURE__ */ tn(xC), Bl = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuBookmarkButtonArticle"
};
Bl.hash = "a7c80ae823596510ff3e2edc0684d236";
const Ul = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuSocialButtonArticle"
};
Ul.hash = "f4c88864c5a03b3f32c07b9080058e99";
const kC = () => {
  const {
    bookmark: e
  } = B(), t = te(({
    entityId: r
  }) => e.check({
    entityId: r
  }), [e]);
  return {
    bindBookmarkButton: te(({
      entityId: r,
      trackings: a
    }, i) => ({
      isBookmarked: t({
        entityId: r
      }),
      onClick: (c) => {
        e.update({
          action: c,
          entityId: r,
          trackings: a
        }), i == null || i();
      }
    }), [e, t]),
    checkIsBookmarked: t
  };
}, MC = (e) => /* @__PURE__ */ E.createElement("svg", { width: "16px", height: "18px", viewBox: "0 0 16 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("filter", { id: "filter-1" }, /* @__PURE__ */ E.createElement("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: "0 0 0 0 0.000000 0 0 0 0 0.070588 0 0 0 0 0.274510 0 0 0 1.000000 0" }))), /* @__PURE__ */ E.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ E.createElement("g", { id: "icon_savearticle", transform: "translate(-306.000000, -22.000000)" }, /* @__PURE__ */ E.createElement("g", { transform: "translate(306.000000, 22.000000)", fill: "#4585FF", id: "Fill-14" }, /* @__PURE__ */ E.createElement("path", { d: "M14.8618719,3.16414286 C14.8618719,2.62542857 14.6777537,2.15678571 14.3101478,1.75757143 C13.9425419,1.35964286 13.5055764,1.16035714 12.9998818,1.16035714 L3.00011823,1.16035714 C2.49442365,1.16035714 2.05682759,1.35964286 1.68922167,1.75757143 C1.32161576,2.15678571 1.13749754,2.62542857 1.13749754,3.16414286 L1.13749754,16.1016429 L8.06904433,11.5662857 L14.8618719,16.0662857 L14.8618719,3.16414286 Z M15.1374187,0.914142857 C15.7124729,1.52357143 16,2.26221429 16,3.12878571 L16,18 L8.06904433,12.7967143 L0,18 L0,3.12878571 C0,2.26221429 0.287527094,1.52357143 0.861950739,0.914142857 C1.43637438,0.305357143 2.12618719,0 2.93075862,0 L13.0686108,0 C13.8738128,0 14.5629951,0.305357143 15.1374187,0.914142857 L15.1374187,0.914142857 Z" }))))), BC = (e) => /* @__PURE__ */ E.createElement("svg", { width: "25px", height: "28px", viewBox: "0 0 25 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ E.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ E.createElement("g", { id: "icons_bookmarks-copy", transform: "translate(-272.000000, -439.000000)" }, /* @__PURE__ */ E.createElement("g", { id: "icon_bookmark_desktop_on", transform: "translate(272.000000, 439.000000)" }, /* @__PURE__ */ E.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z", id: "Path", fill: "#4585FF", opacity: 0.30392674 }), /* @__PURE__ */ E.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z M23.6522167,1.422 C24.5507389,2.37 25,3.519 25,4.867 L25,28 L12.6078818,19.906 L0,28 L0,4.867 C0,3.519 0.449261084,2.37 1.34679803,1.422 C2.24433498,0.475 3.32216749,0 4.57931034,0 L20.4197044,0 C21.6778325,0 22.7546798,0.475 23.6522167,1.422 L23.6522167,1.422 Z", id: "Fill-14", fill: "#4585ff" }))))), UC = /* @__PURE__ */ y("button", {
  target: "e1wwhs9u2"
})({
  name: "6o7kh4",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;padding:7.5px;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), Dl = {
  name: "16o2qwc",
  styles: "inline-size:100%;block-size:100%"
}, DC = /* @__PURE__ */ y(MC, {
  target: "e1wwhs9u1"
})(Dl, ";"), HC = /* @__PURE__ */ y(BC, {
  target: "e1wwhs9u0"
})(Dl, ";"), Hl = ({
  className: e,
  isBookmarked: t,
  onClick: n
}) => {
  const r = (a) => {
    n == null || n(t ? "unbookmark" : "bookmark", a);
  };
  return /* @__PURE__ */ m.createElement(UC, {
    "aria-label": t ? "unbookmark" : "bookmark",
    className: e,
    onClick: r,
    "data-qa": "bookmark-button"
  }, t ? /* @__PURE__ */ m.createElement(HC, null) : /* @__PURE__ */ m.createElement(DC, null));
};
Hl.displayName = "BookmarkButton";
var pe = "top", Re = "bottom", Te = "right", fe = "left", ri = "auto", ln = [pe, Re, Te, fe], bt = "start", qt = "end", FC = "clippingParents", Fl = "viewport", Ft = "popper", GC = "reference", o1 = /* @__PURE__ */ ln.reduce(function(e, t) {
  return e.concat([t + "-" + bt, t + "-" + qt]);
}, []), Gl = /* @__PURE__ */ [].concat(ln, [ri]).reduce(function(e, t) {
  return e.concat([t, t + "-" + bt, t + "-" + qt]);
}, []), zC = "beforeRead", VC = "read", jC = "afterRead", XC = "beforeMain", YC = "main", WC = "afterMain", QC = "beforeWrite", ZC = "write", KC = "afterWrite", qC = [zC, VC, jC, XC, YC, WC, QC, ZC, KC];
function Ue(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function he(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ot(e) {
  var t = he(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ie(e) {
  var t = he(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ai(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = he(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function JC(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, i = t.elements[n];
    !Ie(i) || !Ue(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function $C(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], i = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !Ie(a) || !Ue(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(c) {
        a.removeAttribute(c);
      }));
    });
  };
}
const eb = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: JC,
  effect: $C,
  requires: ["computeStyles"]
};
function Be(e) {
  return e.split("-")[0];
}
var it = Math.max, Gn = Math.min, yt = Math.round;
function va() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function zl() {
  return !/^((?!chrome|android).)*safari/i.test(va());
}
function It(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, i = 1;
  t && Ie(e) && (a = e.offsetWidth > 0 && yt(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && yt(r.height) / e.offsetHeight || 1);
  var o = ot(e) ? he(e) : window, s = o.visualViewport, c = !zl() && n, l = (r.left + (c && s ? s.offsetLeft : 0)) / a, u = (r.top + (c && s ? s.offsetTop : 0)) / i, f = r.width / a, d = r.height / i;
  return {
    width: f,
    height: d,
    top: u,
    right: l + f,
    bottom: u + d,
    left: l,
    x: l,
    y: u
  };
}
function ii(e) {
  var t = It(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Vl(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ai(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ge(e) {
  return he(e).getComputedStyle(e);
}
function tb(e) {
  return ["table", "td", "th"].indexOf(Ue(e)) >= 0;
}
function $e(e) {
  return ((ot(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function gr(e) {
  return Ue(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ai(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    $e(e)
  );
}
function s1(e) {
  return !Ie(e) || // https://github.com/popperjs/popper-core/issues/837
  Ge(e).position === "fixed" ? null : e.offsetParent;
}
function nb(e) {
  var t = /firefox/i.test(va()), n = /Trident/i.test(va());
  if (n && Ie(e)) {
    var r = Ge(e);
    if (r.position === "fixed")
      return null;
  }
  var a = gr(e);
  for (ai(a) && (a = a.host); Ie(a) && ["html", "body"].indexOf(Ue(a)) < 0; ) {
    var i = Ge(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function un(e) {
  for (var t = he(e), n = s1(e); n && tb(n) && Ge(n).position === "static"; )
    n = s1(n);
  return n && (Ue(n) === "html" || Ue(n) === "body" && Ge(n).position === "static") ? t : n || nb(e) || t;
}
function oi(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Yt(e, t, n) {
  return it(e, Gn(t, n));
}
function rb(e, t, n) {
  var r = Yt(e, t, n);
  return r > n ? n : r;
}
function jl() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Xl(e) {
  return Object.assign({}, jl(), e);
}
function Yl(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var ab = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Xl(typeof t != "number" ? t : Yl(t, ln));
};
function ib(e) {
  var t, n = e.state, r = e.name, a = e.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Be(n.placement), c = oi(s), l = [fe, Te].indexOf(s) >= 0, u = l ? "height" : "width";
  if (!(!i || !o)) {
    var f = ab(a.padding, n), d = ii(i), v = c === "y" ? pe : fe, g = c === "y" ? Re : Te, p = n.rects.reference[u] + n.rects.reference[c] - o[c] - n.rects.popper[u], h = o[c] - n.rects.reference[c], A = un(i), C = A ? c === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, b = p / 2 - h / 2, I = f[v], w = C - d[u] - f[g], R = C / 2 - d[u] / 2 + b, T = Yt(I, R, w), S = c;
    n.modifiersData[r] = (t = {}, t[S] = T, t.centerOffset = T - R, t);
  }
}
function ob(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Vl(t.elements.popper, a) && (t.elements.arrow = a));
}
const sb = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ib,
  effect: ob,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function wt(e) {
  return e.split("-")[1];
}
var cb = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function lb(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: yt(n * a) / a || 0,
    y: yt(r * a) / a || 0
  };
}
function c1(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, f = e.isFixed, d = o.x, v = d === void 0 ? 0 : d, g = o.y, p = g === void 0 ? 0 : g, h = typeof u == "function" ? u({
    x: v,
    y: p
  }) : {
    x: v,
    y: p
  };
  v = h.x, p = h.y;
  var A = o.hasOwnProperty("x"), C = o.hasOwnProperty("y"), b = fe, I = pe, w = window;
  if (l) {
    var R = un(n), T = "clientHeight", S = "clientWidth";
    if (R === he(n) && (R = $e(n), Ge(R).position !== "static" && s === "absolute" && (T = "scrollHeight", S = "scrollWidth")), R = R, a === pe || (a === fe || a === Te) && i === qt) {
      I = Re;
      var P = f && R === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        R[T]
      );
      p -= P - r.height, p *= c ? 1 : -1;
    }
    if (a === fe || (a === pe || a === Re) && i === qt) {
      b = Te;
      var _ = f && R === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        R[S]
      );
      v -= _ - r.width, v *= c ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: s
  }, l && cb), L = u === !0 ? lb({
    x: v,
    y: p
  }, he(n)) : {
    x: v,
    y: p
  };
  if (v = L.x, p = L.y, c) {
    var x;
    return Object.assign({}, N, (x = {}, x[I] = C ? "0" : "", x[b] = A ? "0" : "", x.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + p + "px)" : "translate3d(" + v + "px, " + p + "px, 0)", x));
  }
  return Object.assign({}, N, (t = {}, t[I] = C ? p + "px" : "", t[b] = A ? v + "px" : "", t.transform = "", t));
}
function ub(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, c = s === void 0 ? !0 : s, l = {
    placement: Be(t.placement),
    variation: wt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, c1(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, c1(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const db = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ub,
  data: {}
};
var wn = {
  passive: !0
};
function pb(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, c = he(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(u) {
    u.addEventListener("scroll", n.update, wn);
  }), s && c.addEventListener("resize", n.update, wn), function() {
    i && l.forEach(function(u) {
      u.removeEventListener("scroll", n.update, wn);
    }), s && c.removeEventListener("resize", n.update, wn);
  };
}
const fb = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: pb,
  data: {}
};
var mb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ln(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return mb[t];
  });
}
var gb = {
  start: "end",
  end: "start"
};
function l1(e) {
  return e.replace(/start|end/g, function(t) {
    return gb[t];
  });
}
function si(e) {
  var t = he(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function ci(e) {
  return It($e(e)).left + si(e).scrollLeft;
}
function vb(e, t) {
  var n = he(e), r = $e(e), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    var l = zl();
    (l || !l && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + ci(e),
    y: c
  };
}
function hb(e) {
  var t, n = $e(e), r = si(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = it(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = it(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + ci(e), c = -r.scrollTop;
  return Ge(a || n).direction === "rtl" && (s += it(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function li(e) {
  var t = Ge(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function Wl(e) {
  return ["html", "body", "#document"].indexOf(Ue(e)) >= 0 ? e.ownerDocument.body : Ie(e) && li(e) ? e : Wl(gr(e));
}
function Wt(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Wl(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = he(r), o = a ? [i].concat(i.visualViewport || [], li(r) ? r : []) : r, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Wt(gr(o)))
  );
}
function ha(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Eb(e, t) {
  var n = It(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function u1(e, t, n) {
  return t === Fl ? ha(vb(e, n)) : ot(t) ? Eb(t, n) : ha(hb($e(e)));
}
function Ab(e) {
  var t = Wt(gr(e)), n = ["absolute", "fixed"].indexOf(Ge(e).position) >= 0, r = n && Ie(e) ? un(e) : e;
  return ot(r) ? t.filter(function(a) {
    return ot(a) && Vl(a, r) && Ue(a) !== "body";
  }) : [];
}
function Cb(e, t, n, r) {
  var a = t === "clippingParents" ? Ab(e) : [].concat(t), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(c, l) {
    var u = u1(e, l, r);
    return c.top = it(u.top, c.top), c.right = Gn(u.right, c.right), c.bottom = Gn(u.bottom, c.bottom), c.left = it(u.left, c.left), c;
  }, u1(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Ql(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? Be(r) : null, i = r ? wt(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, c;
  switch (a) {
    case pe:
      c = {
        x: o,
        y: t.y - n.height
      };
      break;
    case Re:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Te:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case fe:
      c = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = a ? oi(a) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (i) {
      case bt:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case qt:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function Jt(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, i = n.strategy, o = i === void 0 ? e.strategy : i, s = n.boundary, c = s === void 0 ? FC : s, l = n.rootBoundary, u = l === void 0 ? Fl : l, f = n.elementContext, d = f === void 0 ? Ft : f, v = n.altBoundary, g = v === void 0 ? !1 : v, p = n.padding, h = p === void 0 ? 0 : p, A = Xl(typeof h != "number" ? h : Yl(h, ln)), C = d === Ft ? GC : Ft, b = e.rects.popper, I = e.elements[g ? C : d], w = Cb(ot(I) ? I : I.contextElement || $e(e.elements.popper), c, u, o), R = It(e.elements.reference), T = Ql({
    reference: R,
    element: b,
    strategy: "absolute",
    placement: a
  }), S = ha(Object.assign({}, b, T)), P = d === Ft ? S : R, _ = {
    top: w.top - P.top + A.top,
    bottom: P.bottom - w.bottom + A.bottom,
    left: w.left - P.left + A.left,
    right: P.right - w.right + A.right
  }, N = e.modifiersData.offset;
  if (d === Ft && N) {
    var L = N[a];
    Object.keys(_).forEach(function(x) {
      var k = [Te, Re].indexOf(x) >= 0 ? 1 : -1, O = [pe, Re].indexOf(x) >= 0 ? "y" : "x";
      _[x] += L[O] * k;
    });
  }
  return _;
}
function bb(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? Gl : c, u = wt(r), f = u ? s ? o1 : o1.filter(function(g) {
    return wt(g) === u;
  }) : ln, d = f.filter(function(g) {
    return l.indexOf(g) >= 0;
  });
  d.length === 0 && (d = f);
  var v = d.reduce(function(g, p) {
    return g[p] = Jt(e, {
      placement: p,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Be(p)], g;
  }, {});
  return Object.keys(v).sort(function(g, p) {
    return v[g] - v[p];
  });
}
function yb(e) {
  if (Be(e) === ri)
    return [];
  var t = Ln(e);
  return [l1(e), t, l1(t)];
}
function Ib(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, c = n.fallbackPlacements, l = n.padding, u = n.boundary, f = n.rootBoundary, d = n.altBoundary, v = n.flipVariations, g = v === void 0 ? !0 : v, p = n.allowedAutoPlacements, h = t.options.placement, A = Be(h), C = A === h, b = c || (C || !g ? [Ln(h)] : yb(h)), I = [h].concat(b).reduce(function(W, Q) {
      return W.concat(Be(Q) === ri ? bb(t, {
        placement: Q,
        boundary: u,
        rootBoundary: f,
        padding: l,
        flipVariations: g,
        allowedAutoPlacements: p
      }) : Q);
    }, []), w = t.rects.reference, R = t.rects.popper, T = /* @__PURE__ */ new Map(), S = !0, P = I[0], _ = 0; _ < I.length; _++) {
      var N = I[_], L = Be(N), x = wt(N) === bt, k = [pe, Re].indexOf(L) >= 0, O = k ? "width" : "height", M = Jt(t, {
        placement: N,
        boundary: u,
        rootBoundary: f,
        altBoundary: d,
        padding: l
      }), D = k ? x ? Te : fe : x ? Re : pe;
      w[O] > R[O] && (D = Ln(D));
      var F = Ln(D), V = [];
      if (i && V.push(M[L] <= 0), s && V.push(M[D] <= 0, M[F] <= 0), V.every(function(W) {
        return W;
      })) {
        P = N, S = !1;
        break;
      }
      T.set(N, V);
    }
    if (S)
      for (var ee = g ? 3 : 1, X = function(Q) {
        var re = I.find(function(Le) {
          var ce = T.get(Le);
          if (ce)
            return ce.slice(0, Q).every(function(Z) {
              return Z;
            });
        });
        if (re)
          return P = re, "break";
      }, Y = ee; Y > 0; Y--) {
        var J = X(Y);
        if (J === "break") break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const wb = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Ib,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function d1(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function p1(e) {
  return [pe, Te, Re, fe].some(function(t) {
    return e[t] >= 0;
  });
}
function Rb(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = Jt(t, {
    elementContext: "reference"
  }), s = Jt(t, {
    altBoundary: !0
  }), c = d1(o, r), l = d1(s, a, i), u = p1(c), f = p1(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const Tb = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Rb
};
function Sb(e, t, n) {
  var r = Be(e), a = [fe, pe].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [fe, Te].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function _b(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = Gl.reduce(function(u, f) {
    return u[f] = Sb(f, t.rects, i), u;
  }, {}), s = o[t.placement], c = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = o;
}
const Pb = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: _b
};
function Lb(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ql({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Nb = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Lb,
  data: {}
};
function xb(e) {
  return e === "x" ? "y" : "x";
}
function Ob(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, c = n.boundary, l = n.rootBoundary, u = n.altBoundary, f = n.padding, d = n.tether, v = d === void 0 ? !0 : d, g = n.tetherOffset, p = g === void 0 ? 0 : g, h = Jt(t, {
    boundary: c,
    rootBoundary: l,
    padding: f,
    altBoundary: u
  }), A = Be(t.placement), C = wt(t.placement), b = !C, I = oi(A), w = xb(I), R = t.modifiersData.popperOffsets, T = t.rects.reference, S = t.rects.popper, P = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, _ = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), N = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (R) {
    if (i) {
      var x, k = I === "y" ? pe : fe, O = I === "y" ? Re : Te, M = I === "y" ? "height" : "width", D = R[I], F = D + h[k], V = D - h[O], ee = v ? -S[M] / 2 : 0, X = C === bt ? T[M] : S[M], Y = C === bt ? -S[M] : -T[M], J = t.elements.arrow, W = v && J ? ii(J) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : jl(), re = Q[k], Le = Q[O], ce = Yt(0, T[M], W[M]), Z = b ? T[M] / 2 - ee - ce - re - _.mainAxis : X - ce - re - _.mainAxis, Ne = b ? -T[M] / 2 + ee + ce + Le + _.mainAxis : Y + ce + Le + _.mainAxis, Ot = t.elements.arrow && un(t.elements.arrow), vr = Ot ? I === "y" ? Ot.clientTop || 0 : Ot.clientLeft || 0 : 0, dn = (x = N == null ? void 0 : N[I]) != null ? x : 0, hr = D + Z - dn - vr, Er = D + Ne - dn, pn = Yt(v ? Gn(F, hr) : F, D, v ? it(V, Er) : V);
      R[I] = pn, L[I] = pn - D;
    }
    if (s) {
      var fn, Ar = I === "x" ? pe : fe, Cr = I === "x" ? Re : Te, Se = R[w], je = w === "y" ? "height" : "width", mn = Se + h[Ar], gn = Se - h[Cr], Xe = [pe, fe].indexOf(A) !== -1, Ye = (fn = N == null ? void 0 : N[w]) != null ? fn : 0, vn = Xe ? mn : Se - T[je] - S[je] - Ye + _.altAxis, kt = Xe ? Se + T[je] + S[je] - Ye - _.altAxis : gn, hn = v && Xe ? rb(vn, Se, kt) : Yt(v ? vn : mn, Se, v ? kt : gn);
      R[w] = hn, L[w] = hn - Se;
    }
    t.modifiersData[r] = L;
  }
}
const kb = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ob,
  requiresIfExists: ["offset"]
};
function Mb(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Bb(e) {
  return e === he(e) || !Ie(e) ? si(e) : Mb(e);
}
function Ub(e) {
  var t = e.getBoundingClientRect(), n = yt(t.width) / e.offsetWidth || 1, r = yt(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Db(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ie(t), a = Ie(t) && Ub(t), i = $e(t), o = It(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Ue(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  li(i)) && (s = Bb(t)), Ie(t) ? (c = It(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = ci(i))), {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function Hb(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var c = t.get(s);
        c && a(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function Fb(e) {
  var t = Hb(e);
  return qC.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Gb(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function zb(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var f1 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function m1() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Vb(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, i = a === void 0 ? f1 : a;
  return function(s, c, l) {
    l === void 0 && (l = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, f1, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], d = !1, v = {
      state: u,
      setOptions: function(A) {
        var C = typeof A == "function" ? A(u.options) : A;
        p(), u.options = Object.assign({}, i, u.options, C), u.scrollParents = {
          reference: ot(s) ? Wt(s) : s.contextElement ? Wt(s.contextElement) : [],
          popper: Wt(c)
        };
        var b = Fb(zb([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = b.filter(function(I) {
          return I.enabled;
        }), g(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var A = u.elements, C = A.reference, b = A.popper;
          if (m1(C, b)) {
            u.rects = {
              reference: Db(C, un(b), u.options.strategy === "fixed"),
              popper: ii(b)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(_) {
              return u.modifiersData[_.name] = Object.assign({}, _.data);
            });
            for (var I = 0; I < u.orderedModifiers.length; I++) {
              if (u.reset === !0) {
                u.reset = !1, I = -1;
                continue;
              }
              var w = u.orderedModifiers[I], R = w.fn, T = w.options, S = T === void 0 ? {} : T, P = w.name;
              typeof R == "function" && (u = R({
                state: u,
                options: S,
                name: P,
                instance: v
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Gb(function() {
        return new Promise(function(h) {
          v.forceUpdate(), h(u);
        });
      }),
      destroy: function() {
        p(), d = !0;
      }
    };
    if (!m1(s, c))
      return v;
    v.setOptions(l).then(function(h) {
      !d && l.onFirstUpdate && l.onFirstUpdate(h);
    });
    function g() {
      u.orderedModifiers.forEach(function(h) {
        var A = h.name, C = h.options, b = C === void 0 ? {} : C, I = h.effect;
        if (typeof I == "function") {
          var w = I({
            state: u,
            name: A,
            instance: v,
            options: b
          }), R = function() {
          };
          f.push(w || R);
        }
      });
    }
    function p() {
      f.forEach(function(h) {
        return h();
      }), f = [];
    }
    return v;
  };
}
var jb = [fb, Nb, db, eb, Pb, wb, kb, sb, Tb], Xb = /* @__PURE__ */ Vb({
  defaultModifiers: jb
});
function Yb(e) {
  return typeof e == "function" ? e() : e;
}
const Wb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    children: r,
    container: a,
    disablePortal: i = !1
  } = t, [o, s] = E.useState(null), c = Ke(/* @__PURE__ */ E.isValidElement(r) ? r.ref : null, n);
  if (Ct(() => {
    i || s(Yb(a) || document.body);
  }, [a, i]), Ct(() => {
    if (o && !i)
      return Vr(n, o), () => {
        Vr(n, null);
      };
  }, [n, o, i]), i) {
    if (/* @__PURE__ */ E.isValidElement(r)) {
      const l = {
        ref: c
      };
      return /* @__PURE__ */ E.cloneElement(r, l);
    }
    return /* @__PURE__ */ K.jsx(E.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ K.jsx(E.Fragment, {
    children: o && /* @__PURE__ */ B2.createPortal(r, o)
  });
}), Zl = "Popper";
function Qb(e) {
  return ei(Zl, e);
}
_l(Zl, ["root"]);
const Zb = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], Kb = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function qb(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Ea(e) {
  return typeof e == "function" ? e() : e;
}
function Jb(e) {
  return e.nodeType !== void 0;
}
const $b = () => an({
  root: ["root"]
}, Tl(Qb)), ey = {}, ty = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var r;
  const {
    anchorEl: a,
    children: i,
    direction: o,
    disablePortal: s,
    modifiers: c,
    open: l,
    placement: u,
    popperOptions: f,
    popperRef: d,
    slotProps: v = {},
    slots: g = {},
    TransitionProps: p
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, h = ze(t, Zb), A = E.useRef(null), C = Ke(A, n), b = E.useRef(null), I = Ke(b, d), w = E.useRef(I);
  Ct(() => {
    w.current = I;
  }, [I]), E.useImperativeHandle(d, () => b.current, []);
  const R = qb(u, o), [T, S] = E.useState(R), [P, _] = E.useState(Ea(a));
  E.useEffect(() => {
    b.current && b.current.forceUpdate();
  }), E.useEffect(() => {
    a && _(Ea(a));
  }, [a]), Ct(() => {
    if (!P || !l)
      return;
    const O = (F) => {
      S(F.placement);
    };
    let M = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: F
      }) => {
        O(F);
      }
    }];
    c != null && (M = M.concat(c)), f && f.modifiers != null && (M = M.concat(f.modifiers));
    const D = Xb(P, A.current, H({
      placement: R
    }, f, {
      modifiers: M
    }));
    return w.current(D), () => {
      D.destroy(), w.current(null);
    };
  }, [P, s, c, l, f, R]);
  const N = {
    placement: T
  };
  p !== null && (N.TransitionProps = p);
  const L = $b(), x = (r = g.root) != null ? r : "div", k = Vt({
    elementType: x,
    externalSlotProps: v.root,
    externalForwardedProps: h,
    additionalProps: {
      role: "tooltip",
      ref: C
    },
    ownerState: t,
    className: L.root
  });
  return /* @__PURE__ */ K.jsx(x, H({}, k, {
    children: typeof i == "function" ? i(N) : i
  }));
}), ny = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: a,
    container: i,
    direction: o = "ltr",
    disablePortal: s = !1,
    keepMounted: c = !1,
    modifiers: l,
    open: u,
    placement: f = "bottom",
    popperOptions: d = ey,
    popperRef: v,
    style: g,
    transition: p = !1,
    slotProps: h = {},
    slots: A = {}
  } = t, C = ze(t, Kb), [b, I] = E.useState(!0), w = () => {
    I(!1);
  }, R = () => {
    I(!0);
  };
  if (!c && !u && (!p || b))
    return null;
  let T;
  if (i)
    T = i;
  else if (r) {
    const _ = Ea(r);
    T = _ && Jb(_) ? Bn(_).body : Bn(null).body;
  }
  const S = !u && c && (!p || b) ? "none" : void 0, P = p ? {
    in: u,
    onEnter: w,
    onExited: R
  } : void 0;
  return /* @__PURE__ */ K.jsx(Wb, {
    disablePortal: s,
    container: T,
    children: /* @__PURE__ */ K.jsx(ty, H({
      anchorEl: r,
      direction: o,
      disablePortal: s,
      modifiers: l,
      ref: n,
      open: p ? !b : u,
      placement: f,
      popperOptions: d,
      popperRef: v,
      slotProps: h,
      slots: A
    }, C, {
      style: H({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: S
      }, g),
      TransitionProps: P,
      children: a
    }))
  });
}), ry = /* @__PURE__ */ y("button", {
  target: "e1qkx15u2"
})({
  name: "1hq88fc",
  styles: "padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), ay = /* @__PURE__ */ y(ny, {
  target: "e1qkx15u1"
})("z-index:", Zn.Tooltip, ";"), iy = /* @__PURE__ */ y("div", {
  target: "e1qkx15u0"
})("inline-size:117px;block-size:30px;color:#ffffff;font-size:14px;font-family:", q, ";line-height:30px;text-align:center;border-radius:15px;background-color:rgba(0, 0, 0, 0.5);"), Kl = ({
  children: e,
  className: t,
  disablePortal: n = !0,
  LabelComponent: r,
  onClick: a,
  showLabel: i,
  tooltipPlacement: o = "right",
  url: s,
  variant: c
}) => {
  const [l, u] = M2(), [f, d] = ve(!1), [v, g] = ve(!1), p = ya(null), h = Et(ht.breakpoints.up("tablet")), A = () => {
    u(s);
    const I = () => {
      d(!0), setTimeout(() => {
        d(!1), a == null || a();
      }, 1e3);
    }, w = () => {
      u(s), g(!0), a == null || a();
    };
    switch (c) {
      case "tooltip":
        I();
        break;
      case "label":
        w();
        break;
      case "responsive":
        h ? I() : w();
        break;
    }
  }, C = () => {
    const I = "Copy Link", w = v ? "Link Copied" : "Copy Link";
    switch (c) {
      case "tooltip":
        return I;
      case "label":
        return w;
    }
  }, b = we(() => [{
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }], []);
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(ry, {
    className: t,
    ref: p,
    type: "button",
    onClick: () => A()
  }, e, i && /* @__PURE__ */ m.createElement(r, null, C())), /* @__PURE__ */ m.createElement(ay, {
    anchorEl: p.current,
    disablePortal: n,
    modifiers: b,
    open: f,
    placement: o
  }, /* @__PURE__ */ m.createElement(iy, null, "Link Copied")));
};
Kl.displayName = "CopyLinkButton";
const oy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0662 16.9829C19.2728 16.7763 19.376 16.5187 19.376 16.2098C19.376 15.901 19.2718 15.6566 19.0662 15.4766L16.7879 13.1973C16.6079 12.9907 16.3502 12.8884 16.0148 12.8884C15.7316 12.8884 15.4749 13.004 15.2428 13.2361L15.6672 13.6605C15.7448 13.7382 15.8093 13.8149 15.8604 13.8926C15.8972 13.9273 15.9266 13.9691 15.9466 14.0155C15.9667 14.062 15.977 14.112 15.9769 14.1626C16.0025 14.2147 16.0148 14.317 16.0148 14.4714C16.0148 14.7812 15.9125 15.0256 15.706 15.2056C15.6112 15.3046 15.4972 15.383 15.3709 15.4361C15.2446 15.4892 15.1088 15.5159 14.9718 15.5145C14.8675 15.518 14.7633 15.5052 14.663 15.4766C14.5678 15.4343 14.4774 15.3822 14.393 15.3212C14.343 15.2968 14.2972 15.2645 14.2575 15.2255C14.2196 15.1867 14.1865 15.1668 14.1609 15.1668L13.7365 14.7424C13.5044 14.9224 13.3888 15.1801 13.3888 15.5145C13.3888 15.8498 13.4911 16.1066 13.6976 16.2875L15.9381 18.5659C16.1958 18.7724 16.4525 18.8757 16.7102 18.8757C16.9944 18.8757 17.2379 18.7714 17.4444 18.5659L19.0662 16.9829ZM11.2639 9.25723C11.3743 9.15307 11.4621 9.02735 11.5219 8.88785C11.5817 8.74836 11.6122 8.59807 11.6116 8.4463C11.6116 8.13747 11.5093 7.89305 11.3027 7.71211L9.06226 5.3949C8.80458 5.18837 8.54785 5.08606 8.29017 5.08606C8.00596 5.08606 7.76249 5.18837 7.55597 5.3949L5.93506 7.01675C5.72854 7.19675 5.62528 7.44211 5.62528 7.75095C5.62528 8.05978 5.72949 8.3042 5.93506 8.48514L8.21343 10.8024C8.41995 11.0089 8.67763 11.1112 8.98647 11.1112C9.26972 11.1112 9.52646 10.9956 9.75856 10.7635C9.75856 10.7379 9.69414 10.6612 9.5653 10.5324L9.14089 10.107C9.0632 9.97816 9.02436 9.88911 9.02436 9.83701C8.99576 9.73666 8.98298 9.63246 8.98647 9.52817C8.98647 9.21839 9.08878 8.96166 9.2953 8.75514C9.39015 8.65631 9.50421 8.57793 9.63047 8.52481C9.75673 8.4717 9.89253 8.44498 10.0295 8.4463C10.0816 8.44626 10.1334 8.45263 10.1839 8.46525C10.2344 8.47787 10.2863 8.48424 10.3383 8.4842C10.4928 8.56188 10.5827 8.61398 10.6083 8.63956L10.8404 8.79398L11.0716 9.02608C11.1184 9.07097 11.1578 9.12311 11.1881 9.1805L11.2648 9.25723H11.2639ZM21.5 16.2108C21.5 17.1373 21.1911 17.8838 20.5725 18.4503L18.9507 20.0722C18.6604 20.3716 18.3118 20.6084 17.9265 20.7679C17.5411 20.9274 17.1272 21.0063 16.7102 20.9996C15.8093 20.9996 15.0618 20.6908 14.4697 20.0722L12.1913 17.7549C11.5727 17.1629 11.2639 16.4163 11.2639 15.5145C11.2639 14.6135 11.586 13.8538 12.2302 13.2361L11.2639 12.2698C10.6197 12.914 9.86087 13.2361 8.98552 13.2361C8.08364 13.2361 7.32387 12.9273 6.7062 12.3086L4.42878 9.99143C4.12915 9.70123 3.89219 9.3527 3.73251 8.96735C3.57283 8.582 3.49383 8.16802 3.50038 7.75095C3.50038 6.8756 3.80921 6.12909 4.42783 5.51047L6.04874 3.88861C6.64178 3.29652 7.38829 3 8.29017 3C9.19109 3 9.93855 3.30884 10.5306 3.92745L12.809 6.20583C13.4276 6.8235 13.7365 7.57001 13.7365 8.4463C13.7365 9.34723 13.4144 10.1203 12.7702 10.7635L13.7365 11.7298C14.3541 11.0856 15.1139 10.7635 16.0148 10.7635C16.9167 10.7635 17.6765 11.0724 18.2942 11.691L20.5725 13.9693C21.1911 14.588 21.5 15.3354 21.5 16.2108Z", fill: "white" })), sy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 18, viewBox: "0 0 24 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M2.551 17.21H21.4493C21.8605 17.2095 22.2546 17.0459 22.5453 16.7551C22.836 16.4644 22.9995 16.0702 23 15.659V2.551C22.9996 2.13983 22.8361 1.7456 22.5454 1.45483C22.2547 1.16405 21.8605 1.00048 21.4493 1H2.551C2.13976 1.00038 1.74549 1.16391 1.4547 1.4547C1.16391 1.74549 1.00038 2.13977 1 2.551V15.659C1.00048 16.0702 1.16405 16.4645 1.45481 16.7552C1.74558 17.046 2.13979 17.2096 2.551 17.21ZM22.2756 14.3171L14.926 9.08379L22.2756 3.85124V14.3171ZM1.72432 2.551C1.72452 2.33182 1.81167 2.12166 1.96666 1.96667C2.12165 1.81168 2.33181 1.72453 2.551 1.72433H21.4493C21.6685 1.72453 21.8786 1.81169 22.0335 1.96669C22.1885 2.12169 22.2755 2.33185 22.2756 2.551V2.96216L21.9011 3.22889L14.3018 8.63925L13.9894 8.8617L13.6773 9.08379L13.1841 9.43507C12.8384 9.68116 12.4246 9.81341 12.0002 9.81341C11.5758 9.81341 11.162 9.68116 10.8162 9.43507L10.3231 9.08379L10.011 8.8617L9.69852 8.63925L2.0992 3.22889L1.72432 2.96216V2.551ZM1.72432 3.85124L9.07398 9.08379L1.72432 14.3171V3.85124ZM1.72432 15.2062L2.09955 14.9394L9.69852 9.5287L10.396 10.0251C10.8645 10.3584 11.4252 10.5375 12.0002 10.5375C12.5751 10.5375 13.1358 10.3584 13.6044 10.0251L14.3018 9.5287L21.9011 14.9394L22.2756 15.2062V15.659C22.2754 15.8782 22.1884 16.0883 22.0335 16.2432C21.8785 16.3982 21.6685 16.4854 21.4493 16.4857H2.551C2.33184 16.4854 2.12174 16.3982 1.96677 16.2433C1.8118 16.0883 1.72461 15.8782 1.72432 15.659V15.2062Z", fill: "black", stroke: "black", strokeWidth: 0.3 })), cy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 10.0606V18.1419C22.5 18.6539 22.3039 19.0912 21.9108 19.4547C21.5178 19.8182 21.0465 20 20.4961 20H4.50388C3.95423 20 3.48218 19.8182 3.08917 19.4547C2.69687 19.0912 2.5 18.6539 2.5 18.1419V10.0606L12.5194 14.1818L22.5 10.0606ZM22.5 8.80827L12.5194 12.9701L2.5 8.80827V5.85888C2.5 5.34688 2.69687 4.90876 3.08917 4.54525C3.48218 4.18175 3.95423 4 4.50388 4H20.4961C21.0465 4 21.5178 4.18175 21.9108 4.54525C22.3039 4.90876 22.5 5.34688 22.5 5.85888V8.80827Z", fill: "white" })), ly = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.0509 8.56273C20.0509 8.6817 19.9552 8.77825 19.8371 8.77825H17.7405V9.59119H19.8371C19.9552 9.59119 20.0509 9.68774 20.0509 9.80671V10.5808C20.0509 10.6998 19.9552 10.7964 19.8371 10.7964H17.7405V11.6093H19.8371C19.9552 11.6093 20.0509 11.7059 20.0509 11.8248V12.599C20.0509 12.7179 19.9552 12.8145 19.8371 12.8145H16.7543C16.7262 12.8145 16.6984 12.809 16.6725 12.7982C16.6466 12.7874 16.6232 12.7715 16.6034 12.7516L16.6 12.7481C16.5614 12.7084 16.5397 12.6552 16.5397 12.5998V7.78773C16.5397 7.72997 16.5629 7.67738 16.6 7.63945C16.6 7.63773 16.6017 7.63686 16.6034 7.63514L16.6052 7.63342C16.6451 7.59457 16.6986 7.57291 16.7543 7.57307H19.8371C19.9552 7.57307 20.0509 7.66876 20.0509 7.78859V8.56187V8.56273ZM15.7905 12.5998C15.7905 12.6568 15.7679 12.7114 15.7276 12.7516C15.6874 12.7919 15.6328 12.8145 15.5759 12.8145H14.8043C14.7857 12.8143 14.7671 12.8117 14.7491 12.8067H14.7466C14.7416 12.8053 14.7367 12.8036 14.7319 12.8016C14.7293 12.8016 14.7276 12.7998 14.7259 12.799L14.7147 12.7947C14.7111 12.7931 14.7077 12.7914 14.7043 12.7895L14.6983 12.7869C14.6933 12.7836 14.6884 12.7802 14.6836 12.7766C14.6621 12.7626 14.6434 12.7448 14.6284 12.724L12.431 9.74119V12.5998C12.431 12.6281 12.4255 12.6561 12.4146 12.6822C12.4038 12.7083 12.3879 12.732 12.3679 12.7519C12.3478 12.7719 12.3241 12.7877 12.2979 12.7984C12.2718 12.8091 12.2438 12.8146 12.2155 12.8145H11.4448C11.4166 12.8145 11.3886 12.8089 11.3625 12.7981C11.3364 12.7872 11.3127 12.7713 11.2927 12.7513C11.2728 12.7313 11.257 12.7075 11.2463 12.6814C11.2355 12.6552 11.2301 12.6272 11.2302 12.599V7.78859C11.2302 7.73158 11.2528 7.67689 11.293 7.6365C11.3332 7.59611 11.3878 7.5733 11.4448 7.57307H12.2233L12.2345 7.5748L12.2457 7.57566L12.2543 7.57738C12.2595 7.57738 12.2629 7.57911 12.2672 7.57997L12.275 7.58169L12.2879 7.586L12.294 7.58859L12.3069 7.59376C12.3095 7.59376 12.3112 7.59549 12.3138 7.59721C12.3198 7.60029 12.3255 7.60374 12.331 7.60755C12.3353 7.60928 12.3388 7.61273 12.3422 7.61531C12.3484 7.61939 12.3542 7.624 12.3595 7.62911L12.3638 7.63255L12.3767 7.64549L12.3776 7.64721C12.3838 7.654 12.3896 7.6612 12.3948 7.66876L14.5905 10.6464V7.78773C14.5907 7.73087 14.6134 7.6764 14.6536 7.63619C14.6938 7.59599 14.7483 7.5733 14.8052 7.57307H15.5767C15.6337 7.5733 15.6883 7.59611 15.7286 7.6365C15.7688 7.67689 15.7914 7.73158 15.7914 7.78859V12.599L15.7905 12.5998ZM10.4793 12.5998C10.4793 12.628 10.4738 12.6559 10.463 12.682C10.4522 12.708 10.4364 12.7317 10.4164 12.7516C10.3965 12.7715 10.3728 12.7874 10.3468 12.7981C10.3208 12.8089 10.2928 12.8145 10.2647 12.8145H9.4931C9.46491 12.8144 9.43702 12.8087 9.41102 12.7978C9.38502 12.7869 9.36142 12.771 9.34157 12.751C9.32172 12.731 9.306 12.7073 9.29532 12.6812C9.28464 12.6551 9.2792 12.6272 9.27931 12.599V7.78859C9.27931 7.66962 9.375 7.57307 9.4931 7.57307H10.2647C10.3217 7.5733 10.3763 7.59611 10.4165 7.6365C10.4567 7.67689 10.4793 7.73158 10.4793 7.78859V12.599V12.5998ZM8.61897 12.5998C8.61897 12.6566 8.59647 12.7111 8.5564 12.7513C8.51633 12.7915 8.46195 12.8143 8.40517 12.8145H5.32328C5.26788 12.8144 5.21469 12.7928 5.175 12.7541C5.17328 12.7541 5.17155 12.7516 5.17155 12.7516L5.1681 12.7481C5.12994 12.7082 5.10863 12.6551 5.10862 12.5998V7.78773C5.10862 7.73072 5.13121 7.67603 5.17144 7.63564C5.21167 7.59524 5.26627 7.57244 5.32328 7.57221H6.09483C6.21293 7.57221 6.30862 7.66876 6.30862 7.78773V11.6084H8.40517C8.52328 11.6084 8.61897 11.705 8.61897 11.824V12.5981V12.5998ZM23.5 9.96102C23.5 5.01961 18.5655 0.999756 12.5 0.999756C6.43535 0.999756 1.5 5.01961 1.5 9.96102C1.5 14.3912 5.41379 18.1007 10.6991 18.8025C11.0578 18.88 11.5457 19.0395 11.669 19.3464C11.7793 19.6257 11.7414 20.0637 11.7043 20.3456L11.5474 21.2904C11.4991 21.5697 11.3259 22.3826 12.5 21.8852C13.6741 21.3895 18.8345 18.1412 21.1431 15.4748H21.1422C22.7362 13.7197 23.5 11.9386 23.5 9.96102Z", fill: "white" })), uy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1923 3.11364V5.99353H15.4265C14.7463 5.99353 14.3143 6.12034 14.1314 6.37257C13.896 6.65045 13.7783 7.04265 13.7783 7.54712V9.59409H17.0746L16.6427 12.8149H13.7783V21H10.3644V12.8149H7.5V9.59409H10.3644V7.2443C10.3644 5.93047 10.7439 4.88274 11.5023 4.09901C12.3131 3.36657 13.36 3 14.6415 3C15.7142 3 16.5645 3.03811 17.1923 3.11364Z", fill: "white" })), dy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M12.5 1C6.425 1 1.5 5.56 1.5 11.185C1.5 14.39 3.1 17.25 5.6 19.117V23L9.345 20.944C10.345 21.221 11.403 21.37 12.5 21.37C18.575 21.37 23.5 16.81 23.5 11.185C23.5 5.56 18.575 1 12.5 1ZM13.018 14.895L10.292 11.643L4.974 14.895L10.824 7.947L13.616 11.199L18.868 7.947L13.018 14.895Z", fill: "white" })), py = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M1.22617 11.5325C1.22617 11.5325 10.0717 8.23976 13.1395 7.08029C14.3155 6.61654 18.3036 5.13241 18.3036 5.13241C18.3036 5.13241 20.1443 4.48316 19.9909 6.05997C19.9398 6.70929 19.5307 8.98175 19.1217 11.4398C18.5081 14.9181 17.8434 18.7211 17.8434 18.7211C17.8434 18.7211 17.7412 19.7878 16.872 19.9733C16.0028 20.1588 14.5711 19.324 14.3155 19.1385C14.1109 18.9994 10.4807 16.9123 9.15133 15.892C8.7934 15.6138 8.38439 15.0573 9.20242 14.408C11.0431 12.8775 13.2417 10.976 14.5711 9.77022C15.1847 9.21366 15.7982 7.9151 13.2417 9.49191C9.61151 11.7644 6.0324 13.8978 6.0324 13.8978C6.0324 13.8978 5.21429 14.3616 3.68041 13.9442C2.14645 13.5268 0.356899 12.9703 0.356899 12.9703C0.356899 12.9703 -0.870152 12.2746 1.22617 11.5325V11.5325Z", fill: "white" })), fy = (e) => /* @__PURE__ */ E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...e }, /* @__PURE__ */ E.createElement("path", { d: "M11.2349 8.85148L16.6988 2.5H15.4041L10.6598 8.0149L6.87048 2.5H2.5L8.23013 10.8395L2.5 17.5H3.79485L8.80497 11.6761L12.8067 17.5H17.1772L11.2346 8.85148H11.2349ZM9.46146 10.913L8.88088 10.0825L4.2614 3.47476H6.25021L9.97818 8.80746L10.5588 9.63788L15.4047 16.5696H13.4159L9.46146 10.9133V10.913Z", fill: "white" })), my = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.614 13.205C15.782 13.205 16.25 13.423 17.021 13.858C17.791 14.26 18.209 14.511 18.276 14.612C18.31 14.645 18.326 14.712 18.326 14.812C18.326 15.114 18.243 15.482 18.076 15.918C17.908 16.286 17.573 16.604 17.071 16.872C16.568 17.107 16.083 17.224 15.614 17.224C15.112 17.224 14.191 16.939 12.852 16.37C11.9614 15.9346 11.1472 15.3578 10.441 14.662C9.771 13.992 9.068 13.105 8.331 12C7.628 10.995 7.276 10.075 7.276 9.237V9.087C7.343 8.217 7.695 7.463 8.331 6.827C8.565 6.626 8.817 6.525 9.084 6.525H9.336C9.436 6.559 9.536 6.575 9.637 6.575C9.837 6.575 9.955 6.609 9.989 6.675C10.056 6.709 10.139 6.826 10.239 7.027C10.239 7.094 10.299 7.27 10.416 7.555C10.533 7.839 10.625 8.099 10.692 8.333C10.926 8.936 11.043 9.288 11.043 9.388C11.043 9.589 10.893 9.857 10.591 10.192C10.256 10.527 10.089 10.761 10.089 10.895C10.089 10.962 10.106 11.029 10.139 11.095C10.4881 11.8396 10.9836 12.5062 11.596 13.055C12.2362 13.6494 12.9649 14.1406 13.756 14.511C13.956 14.578 14.074 14.611 14.107 14.611C14.241 14.611 14.492 14.377 14.861 13.909C15.263 13.439 15.514 13.205 15.614 13.205ZM12.701 20.84C13.9129 20.8388 15.1109 20.5822 16.217 20.087C17.2904 19.6504 18.2643 19.001 19.08 18.178C19.903 17.3623 20.5524 16.3884 20.989 15.315C21.457 14.277 21.692 13.105 21.692 11.799C21.692 10.527 21.457 9.371 20.989 8.333C20.519 7.195 19.884 6.223 19.079 5.42C18.343 4.683 17.389 4.047 16.217 3.511C15.011 3.043 13.839 2.808 12.701 2.808C11.562 2.808 10.391 3.043 9.185 3.511C8.013 4.047 7.059 4.683 6.322 5.421C5.518 6.224 4.882 7.195 4.413 8.333C3.944 9.371 3.71 10.527 3.71 11.799C3.71 13.775 4.28 15.533 5.418 17.073L4.263 20.438L7.728 19.333C9.302 20.338 10.96 20.84 12.701 20.84ZM12.7 1C14.106 1 15.513 1.285 16.92 1.854C18.1982 2.39371 19.3584 3.17847 20.335 4.164C21.305 5.102 22.075 6.257 22.645 7.63C23.215 8.87 23.499 10.259 23.499 11.8C23.499 13.34 23.214 14.746 22.645 16.018C22.075 17.358 21.305 18.513 20.335 19.484C19.431 20.388 18.292 21.158 16.919 21.794C15.513 22.364 14.106 22.648 12.699 22.648C10.8695 22.6597 9.06879 22.1922 7.476 21.292L1.5 23.201L3.409 17.374C2.404 15.734 1.902 13.875 1.902 11.8C1.902 10.26 2.186 8.87 2.756 7.631C3.325 6.258 4.096 5.103 5.066 4.165C6.04284 3.179 7.20336 2.39389 8.482 1.854C9.888 1.284 11.295 1 12.7 1Z", fill: "white" })), gy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1111 2.99978H5.88889V5.57121H18.1111V2.99978ZM3.25 6.85669H20.75C21.4375 6.85669 22 7.43527 22 8.14241V14.571C22 15.2781 21.4375 15.8567 20.75 15.8567H18.1111V20.9996H5.88889V15.8567H3.25C2.56242 15.8567 2 15.2781 2 14.571V8.14241C2 7.43527 2.5625 6.85669 3.25 6.85669ZM16.8609 19.7142H7.13867V13.2857H16.8609V19.7142ZM20.125 9.71766C20.6254 9.71766 21.0312 9.30033 21.0312 8.78552C21.0312 8.27071 20.6255 7.85337 20.125 7.85337C19.6246 7.85337 19.2188 8.27071 19.2188 8.78552C19.2188 9.30033 19.6246 9.71766 20.125 9.71766Z", fill: "white" })), vy = /* @__PURE__ */ y("button", {
  target: "e1uptd6o1"
})({
  name: "pt3bba",
  styles: "position:relative;padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), hy = /* @__PURE__ */ y("div", {
  target: "e1uptd6o0"
})({
  name: "wrqbg1",
  styles: "position:relative;z-index:2"
}), ql = ({
  children: e,
  className: t,
  onClick: n,
  url: r
}) => {
  const a = () => {
    window.open(`/print${r}`, "_blank"), n == null || n();
  };
  return /* @__PURE__ */ m.createElement(vy, {
    className: t,
    type: "button",
    onClick: a,
    "data-qa": "print-button"
  }, /* @__PURE__ */ m.createElement(hy, null, e));
};
ql.displayName = "PrintButton";
const g1 = /* @__PURE__ */ y("span", {
  target: "e136m1kq1"
})("padding-block-start:11px;font-size:14px;font-family:", q, ";line-height:16px;white-space:nowrap;"), Ey = /* @__PURE__ */ y("div", {
  ...L1,
  target: "e136m1kq0"
})("display:flex;inline-size:", (e) => e.$size + e.$mobilePadding * 2, "px;block-size:", (e) => e.$size + e.$mobilePadding * 2, "px;padding:", (e) => e.$mobilePadding, "px;border-radius:200px;background-color:", (e) => e.$backgroundColor, ";", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:", (e) => e.$size + e.$padding * 2, "px;block-size:", (e) => e.$size + e.$padding * 2, "px;padding:", (e) => e.$padding, "px;}svg{inline-size:", (e) => e.$size, "px;block-size:", (e) => e.$size, "px;", (e) => e.$svgTransform && /* @__PURE__ */ jt("transform:", e.$svgTransform, ";", ""), ";path{fill:", (e) => e.$iconFillColor, ";}}"), Jl = ({
  children: e,
  className: t,
  disableTrackMixpanel: n,
  extraProps: r,
  hideIcon: a = !1,
  onClick: i,
  position: o,
  relativeUrl: s,
  shortUrl: c,
  showLabel: l = !1,
  style: u,
  title: f,
  type: d,
  utm: v
}) => {
  var g, p, h, A;
  const {
    config: C,
    handleTrackGA4: b,
    handleTrackMixPanel: I,
    userCountry: w
  } = B(), R = new URL(c ?? s, C.siteUrl), T = () => {
    var O, M, D, F, V;
    if (a) return null;
    const X = {
      "copy-link": oy,
      email: cy,
      email1: sy,
      facebook: uy,
      line: ly,
      messenger: dy,
      print: gy,
      telegram: py,
      twitter: fy,
      whatsapp: my
    }[d];
    return /* @__PURE__ */ m.createElement(Ey, {
      $backgroundColor: (O = u == null ? void 0 : u.backgroundColor) !== null && O !== void 0 ? O : "#001246",
      $iconFillColor: (M = u == null ? void 0 : u.color) !== null && M !== void 0 ? M : "white",
      $mobilePadding: (D = u == null ? void 0 : u.mobilePadding) !== null && D !== void 0 ? D : 12,
      $padding: (F = u == null ? void 0 : u.padding) !== null && F !== void 0 ? F : 5,
      $size: (V = u == null ? void 0 : u.size) !== null && V !== void 0 ? V : 24,
      $svgTransform: u == null ? void 0 : u.svgTransform,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ m.createElement(X, null));
  }, S = (O) => l && /* @__PURE__ */ m.createElement(g1, null, O), P = () => {
    switch (d) {
      case "copy-link":
        return "copy_link";
      case "messenger":
        return "facebook_messenger";
      case "email1":
        return "email";
      default:
        return d;
    }
  }, _ = () => {
    const O = P(), M = new URL(s, C.siteUrl).href;
    o && b({
      action: "click",
      category: "share",
      customized_parameters: {
        action_type: "share",
        method: O,
        position: o,
        share_url: M
      },
      subcategory: ""
    });
  }, N = () => {
    if (n) return;
    I({
      name: "Article Share",
      property: {
        Location: "Share Button",
        "Share Channel": {
          "copy-link": "Copy Link",
          email: "Email",
          email1: "Email",
          facebook: "Facebook",
          line: "Line",
          messenger: "Facebook Messenger",
          print: "Print",
          telegram: "Telegram",
          twitter: "Twitter",
          whatsapp: "Whatsapp"
        }[d]
      }
    });
  }, L = () => {
    _(), N(), i == null || i();
  }, k = (() => {
    if (!(v != null && v.campaign)) return R.href;
    const O = new URL(R);
    return O.searchParams.set("utm_source", d), O.searchParams.set("utm_campaign", v.campaign), v.medium && O.searchParams.set("utm_medium", v.medium), v.content && O.searchParams.set("utm_content", v.content), O.href;
  })();
  switch (d) {
    case "copy-link":
      return /* @__PURE__ */ m.createElement(Kl, {
        className: t,
        disablePortal: r == null || (g = r.copyLink) === null || g === void 0 ? void 0 : g.disablePortal,
        LabelComponent: g1,
        showLabel: l,
        tooltipPlacement: r == null || (p = r.copyLink) === null || p === void 0 ? void 0 : p.tooltipPlacement,
        url: k,
        variant: (h = r == null || (A = r.copyLink) === null || A === void 0 ? void 0 : A.variant) !== null && h !== void 0 ? h : "responsive",
        onClick: L
      }, T(), e);
    case "email":
    case "email1":
      const O = `\r
`, M = `${f}${O}${k}${O}------------------------------${O}` + (w === "HK" ? "Join our Telegram to get the latest Hong Kong updates https://sc.mp/join-our-telegram" : "Download the SCMP app to explore our daily digest of Hong Kong news. https://scmp.onelink.me/3586748601/kdat6bde");
      return /* @__PURE__ */ m.createElement(k2, {
        beforeOnClick: L,
        body: M,
        className: t,
        separator: O,
        subject: "Shared from South China Morning Post",
        url: ""
      }, T(), S("Email"), e);
    case "facebook":
      return /* @__PURE__ */ m.createElement(O2, {
        className: t,
        url: k,
        onClick: L
      }, T(), S("Facebook"), e);
    case "line":
      return /* @__PURE__ */ m.createElement(x2, {
        className: t,
        title: f,
        url: k,
        onClick: L
      }, T(), S("Line"), e);
    case "messenger":
      return /* @__PURE__ */ m.createElement(N2, {
        appId: C.facebook.appId,
        className: t,
        title: f,
        url: k,
        onClick: L
      }, T(), S("Messenger"), e);
    case "print":
      return /* @__PURE__ */ m.createElement(ql, {
        className: t,
        url: s,
        onClick: L
      }, T(), S("Print"), e);
    case "telegram":
      return /* @__PURE__ */ m.createElement(L2, {
        className: t,
        title: `${f}

Join SCMP's Channel: t.me/scmp_news - Get Daily News Update`,
        url: k,
        onClick: L
      }, T(), S("Telegram"), e);
    case "twitter":
      return /* @__PURE__ */ m.createElement(P2, {
        className: t,
        title: f,
        url: k,
        via: C.twitter.accountName.toLowerCase(),
        onClick: L
      }, T(), S("X/Twitter"), e);
    case "whatsapp":
      return /* @__PURE__ */ m.createElement(_2, {
        className: t,
        separator: `

`,
        title: f,
        url: k,
        onClick: L
      }, T(), S("Whatsapp"), e);
    default:
      return null;
  }
};
Jl.displayName = "ShareButton";
const Ay = /* @__PURE__ */ y(Wu, {
  target: "e109f9ks5"
})("z-index:", Zn.Tooltip, ";"), Cy = /* @__PURE__ */ y("div", {
  target: "e109f9ks4"
})({
  name: "12xxavj",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;padding:20px"
}), by = /* @__PURE__ */ y(Hl, {
  target: "e109f9ks3"
})({
  name: "hnshaw",
  styles: "inline-size:15px;block-size:19px;margin-inline-end:14px;padding:0;& path:last-of-type{fill:#001246;}"
}), yy = /* @__PURE__ */ y("button", {
  target: "e109f9ks2"
})("margin-inline-start:10px;padding:0;color:#4585ff;font-size:14px;font-family:", q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), Iy = /* @__PURE__ */ y(Jl, {
  target: "e109f9ks1"
})({
  name: "ghntb1",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px"
}), v1 = /* @__PURE__ */ y("div", {
  target: "e109f9ks0"
})({
  name: "y1gwey",
  styles: "inline-size:1px;block-size:20px;margin-inline:5px;background:#bbbbbb"
});
function zn() {
  return zn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zn.apply(null, arguments);
}
const $l = ({
  children: e
}) => {
  const {
    removeReadingHistory: t
  } = Ja(), [n, r] = ve(), {
    bindBookmarkButton: a
  } = kC();
  return /* @__PURE__ */ m.createElement(R2, {
    popupId: "reading-history-item-popover",
    variant: "popover",
    "data-qa": "reading-history-action-menu"
  }, (i) => {
    const o = T2(i), s = (g) => {
      const p = {
        ...o
      };
      return p.onClick = (h) => {
        r(g), o.onClick(h);
      }, p;
    }, c = S2(i), l = () => {
      c.onClose(), setTimeout(() => {
        r(void 0);
      }, 500);
    }, u = () => {
      const g = {
        ...c
      };
      return g.onClose = l, g;
    }, f = (g) => i.isOpen && !!n && n.entityUuid === g.entityUuid && n.createdAt === g.createdAt, d = (g) => {
      const p = Nn(Ul, g.article);
      return ["facebook", "twitter", "copy-link", "email"].map((A) => /* @__PURE__ */ m.createElement(Iy, {
        extraProps: {
          copyLink: {
            tooltipPlacement: "top",
            variant: "tooltip"
          }
        },
        key: A,
        position: "history",
        relativeUrl: p.urlAlias,
        shortUrl: p.urlAlias,
        showLabel: !1,
        style: {
          /* stylelint-disable csstree/validator */
          /* stylelint-disable property-no-unknown */
          backgroundColor: "transparent",
          color: "#001246",
          svgTransform: "scale(0.75)"
        },
        title: ku(p.socialHeadline, p.headline),
        type: A,
        utm: {
          campaign: p.entityId,
          medium: "share_widget"
        },
        onClick: () => {
          l();
        }
      }));
    }, v = (g) => {
      const p = Nn(Bl, g.article);
      return /* @__PURE__ */ m.createElement(by, zn({}, a({
        entityId: p.entityId,
        trackings: {
          events: {
            bookmark: {
              action: "My Account/Overlay/Reading History/Bookmark/Switch on",
              category: "My Account",
              label: p.urlAlias
            },
            click: {
              action: "Bookmark/Article/Click",
              category: "Bookmark",
              label: p.urlAlias
            },
            unbookmark: {
              action: "My Account/Overlay/Reading History/Bookmark/Switch off",
              category: "My Account",
              label: p.urlAlias
            }
          },
          ga4Events: {
            click: {
              action: "click",
              category: "bookmark",
              customized_parameters: {
                action_type: "add",
                article_id: p.entityId,
                trigger_point: "history"
              },
              subcategory: ""
            }
          }
        }
      }, () => {
        setTimeout(l, 500);
      }), {
        "data-qa": "render-bookmark-button"
      }));
    };
    return /* @__PURE__ */ m.createElement(m.Fragment, null, e({
      bindTrigger: s,
      isCurrentItem: f
    }), /* @__PURE__ */ m.createElement(Ay, zn({
      anchorOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      elevation: 4,
      transformOrigin: {
        horizontal: "left",
        vertical: "bottom"
      }
    }, u()), n ? /* @__PURE__ */ m.createElement(Cy, null, v(n), /* @__PURE__ */ m.createElement(v1, null), d(n), /* @__PURE__ */ m.createElement(v1, null), /* @__PURE__ */ m.createElement(yy, {
      onClick: () => {
        l(), t(n.article, n.createdAt);
      }
    }, "Remove")) : null));
  });
};
$l.displayName = "ReadingHistoryActionMenu";
const wy = (e) => /* @__PURE__ */ E.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 180 203", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("circle", { cx: 90, cy: 90, r: 90, fill: "#F2F2F2" }), /* @__PURE__ */ E.createElement("circle", { cx: 90, cy: 90, r: 57.012, fill: "white" }), /* @__PURE__ */ E.createElement("path", { d: "M89.9731 63.1076C75.1285 63.1076 63.1076 75.1554 63.1076 90C63.1076 104.845 75.1285 116.892 89.9731 116.892C104.845 116.892 116.892 104.845 116.892 90C116.892 75.1554 104.845 63.1076 89.9731 63.1076ZM98.8476 102.666L87.3108 91.1026V76.5538H92.6892V88.8974L102.666 98.8745L98.8476 102.666Z", fill: "#7E8599" }), /* @__PURE__ */ E.createElement("circle", { cx: 90.3387, cy: 136.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ E.createElement("circle", { cx: 90.3387, cy: 166.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ E.createElement("circle", { cx: 90.3387, cy: 196.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.6517 89.6331C30.6872 84.8257 31.2607 80.0599 32.4238 75.4906C36.2166 60.5304 45.6985 47.4666 59.3946 39.2491C72.9853 31.1369 88.8938 28.8191 104.17 32.6118C119.552 36.4045 132.405 45.9917 140.517 59.5823C148.63 73.1728 151.053 89.0812 147.155 104.357C143.362 119.739 133.775 132.592 120.184 140.704C106.593 148.816 90.6848 151.24 75.4084 147.342C60.0267 143.549 47.1735 133.962 39.0612 120.371L42.6432 118.159C50.1234 130.801 62.1338 139.651 76.3566 143.233C90.5795 146.815 105.329 144.602 117.972 137.122C130.614 129.642 139.464 117.632 143.046 103.409C146.628 89.1865 144.416 74.4371 136.935 61.7947C129.455 49.1523 117.445 40.3026 103.222 36.7206C88.9992 33.1386 74.2495 35.351 61.607 42.8311C44.4532 53.0416 34.3254 71.5644 34.868 91.3985L41.4801 85.5759L44.4408 88.8678L32.8173 99.1825L22.9482 87.1121L26.3476 84.3689L30.6517 89.6331Z", fill: "#DAE3E9" }), /* @__PURE__ */ E.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 132, x2: 139, y2: 132, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 142, x2: 133, y2: 142, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 137, x2: 121, y2: 137, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 126, y1: 137, x2: 145, y2: 137, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ E.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 162, x2: 139, y2: 162, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 172, x2: 139, y2: 172, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 167, x2: 126, y2: 167, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 128, y1: 167, x2: 147, y2: 167, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ E.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 192, x2: 115, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 117, y1: 192, x2: 139, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 202, x2: 149, y2: 202, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ E.createElement("line", { x1: 102, y1: 197, x2: 128, y2: 197, stroke: "#7E8599", strokeWidth: 2 }))), Ry = /* @__PURE__ */ y("div", {
  target: "euvv2st11"
})("block-size:100%;padding:20px;background:#ffffff;overflow-y:auto;", xl, ";"), Ty = /* @__PURE__ */ y("div", {
  target: "euvv2st10"
})("color:#000000;font-weight:700;font-size:16px;font-family:", q, ";line-height:19px;"), Sy = /* @__PURE__ */ y("div", {
  target: "euvv2st9"
})(""), _y = /* @__PURE__ */ y("div", {
  target: "euvv2st8"
})({
  name: "84lqid",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;padding-block:20px"
}), Py = /* @__PURE__ */ y("div", {
  target: "euvv2st7"
})("color:#000000;font-size:14px;font-family:", Rt, ";line-height:18px;text-transform:uppercase;"), Ly = /* @__PURE__ */ y("button", {
  target: "euvv2st6"
})("color:#4585ff;font-size:14px;font-family:", q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), Ny = /* @__PURE__ */ y("div", {
  target: "euvv2st5"
})({
  name: "1tzhvsk",
  styles: 'position:relative;padding-block-end:28px;padding-inline-start:20px;::before{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:2;display:block;inline-size:10px;block-size:10px;border-radius:50%;background:#ffca05;}::after{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:1;display:block;inline-size:10px;block-size:calc(100% + 8px);border-radius:5px 5px 0 0;background:#f2f2f2;}:last-child{::after{block-size:calc(100% - 2px);}}'
}), xy = /* @__PURE__ */ y("div", {
  target: "euvv2st4"
})("color:#666666;font-size:16px;font-family:", q, ";line-height:22px;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:18px;}:hover{color:#4585ff;}"), Oy = /* @__PURE__ */ y(Yn, {
  ...L1,
  target: "euvv2st3"
})("padding-block:4px;padding-inline:0;color:", (e) => e.$isActive ? "#000000" : "#cccccc", ";"), ky = /* @__PURE__ */ y("div", {
  target: "euvv2st2"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;margin-block-start:16px;color:#666666;font-size:14px;font-family:", q, ";"), My = /* @__PURE__ */ y(wy, {
  target: "euvv2st1"
})("min-inline-size:180px;max-inline-size:250px;margin-block-start:28px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:180px;}"), h1 = /* @__PURE__ */ y(N1, {
  target: "euvv2st0"
})({
  name: "7rcus4",
  styles: "display:block;margin-block:30px;margin-inline:auto;color:#4585ff"
});
function Aa() {
  return Aa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Aa.apply(null, arguments);
}
const eu = ({
  state: e
}) => {
  const {
    currentPageType: t,
    handleRoutePush: n,
    handleTrackGA4: r,
    user: a
  } = B(), {
    clearReadingHistory: i
  } = Ja(), o = Object.entries(OC(e.result, (s) => gt(s.createdAt)));
  return De(() => {
    r({
      action: "imp",
      category: "readinghistory",
      subcategory: ""
    });
  }), /* @__PURE__ */ m.createElement($l, {
    "data-qa": "reading-history-panel"
  }, ({
    bindTrigger: s,
    isCurrentItem: c
  }) => {
    const l = () => {
      const d = a ? "Your recently viewed stories will appear here. This allows us to give you a more personalised experience." : "By signing up as a registered user, your recently viewed stories will appear here. This allows us to give you a more personalised experience.";
      return /* @__PURE__ */ m.createElement(ky, {
        "data-qa": "render-empty-message"
      }, d, /* @__PURE__ */ m.createElement(My, null));
    }, u = () => {
      const d = (g) => {
        const p = new Date(g);
        return F0(p) ? "Today" : z0(p) ? "Yesterday" : g;
      }, v = (g) => {
        var p;
        const h = Nn(kl, g.article);
        return /* @__PURE__ */ m.createElement(Ny, {
          key: g.entityUuid,
          "data-qa": "render-item"
        }, /* @__PURE__ */ m.createElement(xy, {
          onClick: () => {
            var A;
            r({
              action: "click",
              category: "readinghistory",
              customized_parameters: {
                action_type: "read",
                article_id: h.entityId
              },
              subcategory: ""
            }), n(h.urlAlias, {
              applicationId: (A = h.application) === null || A === void 0 ? void 0 : A.entityUuid,
              entityId: h.entityId,
              entityUuid: h.entityUuid,
              query: {
                campaign: "reading_history",
                module: "my_account_overlay",
                pgtype: t
              },
              type: T1(h.__typename)
            });
          }
        }, (p = h.socialHeadline) !== null && p !== void 0 ? p : h.headline), /* @__PURE__ */ m.createElement(Oy, Aa({
          "aria-label": "more action",
          disableRipple: !0
        }, s(g), {
          $isActive: c(g)
        }), /* @__PURE__ */ m.createElement(Ml, {
          color: "inherit"
        })));
      };
      return o.map(([g, p]) => /* @__PURE__ */ m.createElement(Sy, {
        key: g
      }, /* @__PURE__ */ m.createElement(_y, null, /* @__PURE__ */ m.createElement(Py, null, d(g)), /* @__PURE__ */ m.createElement(Ly, {
        onClick: () => void i(g)
      }, "Clear")), p.map((h) => v(h))));
    }, f = () => {
      const d = o.length === 0;
      switch (e.status) {
        case "not-executed":
          return /* @__PURE__ */ m.createElement(h1, {
            color: "inherit"
          });
        case "loading":
          return d ? /* @__PURE__ */ m.createElement(h1, {
            color: "inherit"
          }) : void 0;
        case "success":
        case "error":
          return d ? l() : u();
      }
    };
    return /* @__PURE__ */ m.createElement(Ry, null, /* @__PURE__ */ m.createElement(Ty, null, "Recently Viewed"), f());
  });
};
eu.displayName = "ReadingHistoryPanel";
const tu = ({
  beforeHeaderSlot: e,
  className: t,
  messageRenders: n
}) => {
  var r;
  const {
    config: a,
    handleOpenLoginDialog: i,
    handleRoutePush: o,
    handleTrackGA4: s,
    user: c
  } = B(), [l, u] = m.useState("notification"), f = c != null && c.firstname && c !== null && c !== void 0 && c.lastname ? `${c.firstname} ${c.lastname}` : (r = c == null ? void 0 : c.username) !== null && r !== void 0 ? r : "Guest", d = () => c ? /* @__PURE__ */ m.createElement(n1, {
    onClick: () => {
      const b = new URL(`${a.accounts.host}/settings`);
      b.searchParams.set("destination", window.location.href), o(b.toString());
    },
    "data-qa": "render-account-link"
  }, "My Account") : /* @__PURE__ */ m.createElement(n1, {
    onClick: () => {
      i({
        destination: window.location.href,
        ga4CustomParameter: {
          trigger_point: "header"
        }
      });
    }
  }, "Sign In / Register"), {
    message: v
  } = qh(n), [g, p] = m2(Rl);
  De(() => {
    p({});
  });
  const {
    state: h
  } = Qh(), {
    setIsFirstTime: A
  } = Mc(), C = () => {
    s({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "open",
        article_id: ""
      },
      subcategory: ""
    });
  };
  return /* @__PURE__ */ m.createElement(zA, {
    className: t,
    "data-qa": "dashboard-display"
  }, /* @__PURE__ */ m.createElement(VA, null, e, /* @__PURE__ */ m.createElement(jA, null, /* @__PURE__ */ m.createElement(XA, null, "Hi, ", /* @__PURE__ */ m.createElement(YA, null, f)), d(), /* @__PURE__ */ m.createElement(WA, null, v))), /* @__PURE__ */ m.createElement(h2, {
    value: l
  }, /* @__PURE__ */ m.createElement(ZA, {
    variant: "fullWidth",
    onChange: (b, I) => {
      u(I);
    }
  }, /* @__PURE__ */ m.createElement(r1, {
    "aria-label": "Notification",
    icon: /* @__PURE__ */ m.createElement(Bc, null, /* @__PURE__ */ m.createElement(Jh, {
      color: "#001246"
    })),
    value: "notification",
    disableRipple: !0,
    onClick: () => A(!1)
  }), /* @__PURE__ */ m.createElement(r1, {
    "aria-label": "Reading History",
    icon: /* @__PURE__ */ m.createElement($h, {
      color: "#001246"
    }),
    value: "reading-history",
    disableRipple: !0,
    onClick: C
  })), /* @__PURE__ */ m.createElement(QA, null, /* @__PURE__ */ m.createElement(a1, {
    value: "notification"
  }, /* @__PURE__ */ m.createElement(Ol, {
    notificationListQuery: g
  })), /* @__PURE__ */ m.createElement(a1, {
    value: "reading-history"
  }, /* @__PURE__ */ m.createElement(eu, {
    state: h
  })))), /* @__PURE__ */ m.createElement(KA, null, d()));
};
tu.displayName = "DashboardDisplay";
const By = /* @__PURE__ */ y("div", {
  target: "eprlsh16"
})({
  name: "14l2p6l",
  styles: "inline-size:fit-content"
}), Uy = /* @__PURE__ */ y(tu, {
  target: "eprlsh15"
})("block-size:100vh;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:300px;block-size:574px;}"), Dy = /* @__PURE__ */ y(Qu, {
  target: "eprlsh14"
})("z-index:", Zn.Modal, ";"), Hy = /* @__PURE__ */ y("div", {
  target: "eprlsh13"
})("display:flex;justify-content:space-between;align-items:center;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), Fy = /* @__PURE__ */ y(Zu, {
  target: "eprlsh12"
})("z-index:", Zn.Modal, ";"), Gy = /* @__PURE__ */ y("div", {
  target: "eprlsh11"
})(""), zy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.81257 8.03137L16 15.1874L15.2503 15.9999L8 8.78108L0.812571 15.9999L0 15.1874L7.18743 8.03137L0 0.81251L0.812571 -6.10352e-05L8 7.2188L15.2503 -6.10352e-05L16 0.81251L8.81257 8.03137Z", fill: "white" }));
function Ca() {
  return Ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ca.apply(null, arguments);
}
const Vy = /* @__PURE__ */ y(Yn, {
  target: "e15aj8c1"
})({
  name: "if9fso",
  styles: "flex:none;margin-inline-start:18px;padding:0"
}), jy = /* @__PURE__ */ y(({
  className: e,
  ...t
}) => /* @__PURE__ */ m.createElement(Ku, Ca({}, t, {
  classes: {
    popper: e
  }
})), {
  target: "e15aj8c0"
})("& .", vi.tooltip, "{display:flex;flex-flow:row nowrap;justify-content:end;align-items:flex-start;inline-size:max-content;max-inline-size:325px;padding:16px;color:#ffffff;font-weight:400;font-size:16px;font-family:", q, ";line-height:22px;border-radius:0;background:rgba(0, 18, 70, 0.9);cursor:pointer;user-select:none;}& .", vi.arrow, "{color:rgba(0, 18, 70, 0.9);font-size:25px;}"), nu = ({
  children: e,
  isDashboardOpen: t,
  isTooltipVisible: n,
  tooltipRenders: r
}) => {
  var a;
  const [i, o] = ct(async () => {
    if (!r) return null;
    const d = await Promise.allSettled(r.map((v) => v.current));
    for (const v of d)
      if (!(v.status === "rejected" || v.value === null))
        return v.value;
  }), [s, c] = ve(!1);
  P1(() => {
    s || o.execute();
  }, [r, s]);
  const l = n && !t && !s && i.status === "success" && !!((a = i.result) !== null && a !== void 0 && a.node), u = i.status === "success" ? i.result : void 0, {
    router: f
  } = B();
  return ne(() => {
    const d = () => {
      var v;
      !l || !u || (c(!0), u == null || (v = u.onChangeUrl) === null || v === void 0 || v.call(u));
    };
    return f.events.on("routeChangeStart", d), () => {
      f.events.off("routeChangeStart", d);
    };
  }, [u, f, l]), ne(() => {
    t && u && c(!0);
  }, [t, l, u]), /* @__PURE__ */ m.createElement(jy, {
    open: l,
    placement: "bottom-end",
    PopperProps: {
      disablePortal: !0,
      modifiers: [{
        name: "offset",
        options: {
          offset: [16, 0]
        }
      }]
    },
    title: /* @__PURE__ */ m.createElement(m.Fragment, null, u == null ? void 0 : u.node, /* @__PURE__ */ m.createElement(Vy, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => {
        var d;
        c(!0), u == null || (d = u.onClose) === null || d === void 0 || d.call(u);
      }
    }, /* @__PURE__ */ m.createElement(zy, null))),
    arrow: !0,
    "data-qa": "dashboard-tooltips"
  }, e);
};
nu.displayName = "DashboardTooltips";
function ba() {
  return ba = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ba.apply(null, arguments);
}
const YI = ({
  children: e,
  className: t,
  messageRenders: n,
  tooltipRenders: r
}) => {
  const {
    hasAcceptedGDPR: a,
    notification: i
  } = B();
  Wh(), Ap(i.firebaseApp), eh();
  const o = ya(null), [s, c] = Du(!0), [l, u] = ve(!1), f = Hu(o), d = Et(ht.breakpoints.only("mobile"), !1), v = Et(ht.breakpoints.up("desktop"), !1), g = () => /* @__PURE__ */ m.createElement(Uy, {
    beforeHeaderSlot: /* @__PURE__ */ m.createElement(Hy, null, /* @__PURE__ */ m.createElement(Kh, null), /* @__PURE__ */ m.createElement(Yn, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => u(!1)
    }, /* @__PURE__ */ m.createElement(Zh, null))),
    messageRenders: n,
    "data-qa": "render-display"
  }), {
    setIsFirstTime: p
  } = vl();
  ne(() => {
    !l || !a || p(!1);
  }, [a, l, p]), ne(() => {
    c(f == null ? void 0 : f.isIntersecting);
  }, [f == null ? void 0 : f.isIntersecting, c]);
  const h = we(() => [{
    name: "offset",
    options: {
      // This is for handling tablet placement of the popper
      offset: [v ? 0 : 42, 10]
    }
  }], [v]), A = () => u(!1);
  return ne(() => {
    if (l && v)
      window.addEventListener("scroll", A);
    else
      return () => {
        window.removeEventListener("scroll", A);
      };
    return () => {
      window.removeEventListener("scroll", A);
    };
  }, [v, l]), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Bc, null, /* @__PURE__ */ m.createElement(nu, {
    isDashboardOpen: l,
    isTooltipVisible: s,
    tooltipRenders: r
  }, /* @__PURE__ */ m.createElement(By, {
    className: t,
    ref: o,
    onClick: () => u(!0)
  }, e))), /* @__PURE__ */ m.createElement(Dy, {
    anchor: "bottom",
    open: d && l,
    SlideProps: {
      easing: {
        enter: "ease"
      },
      timeout: {
        enter: 500,
        exit: 0
      }
    },
    hideBackdrop: !0,
    onClose: () => u(!1)
  }, g()), /* @__PURE__ */ m.createElement(Fy, {
    anchorEl: o.current,
    modifiers: h,
    open: !d && l,
    placement: "bottom-end",
    transition: !0
  }, ({
    TransitionProps: C
  }) => /* @__PURE__ */ m.createElement(qu, {
    onClickAway: () => u(!1)
  }, /* @__PURE__ */ m.createElement(Ju, ba({}, C, {
    timeout: {
      enter: 500,
      exit: 0
    }
  }), /* @__PURE__ */ m.createElement(Gy, null, g())))));
}, Xy = /* @__PURE__ */ y("div", {
  target: "e6yd7ba0"
})("display:flex;flex:none;justify-content:center;align-items:center;padding-block:1px;padding-inline:5px;color:#ffffff;font-weight:700;font-size:14px;font-family:", Rt, ";line-height:18px;text-transform:uppercase;border-radius:4px;background:#eb4254;"), WI = () => {
  const {
    hasAcceptedGDPR: e
  } = B(), {
    isFirstTime: t,
    setIsFirstTime: n
  } = vl(), {
    promise: r,
    reject: a,
    resolve: i
  } = jn();
  return ne(() => e && t ? i.current({
    node: /* @__PURE__ */ m.createElement(m.Fragment, null, "Find your recently read stories and latest notifications here.", /* @__PURE__ */ m.createElement(Xy, null, "New")),
    onChangeUrl: () => {
      n(!1);
    },
    onClose: () => {
      n(!1);
    }
  }) : a.current(), [i, a, t, r, n, e]), {
    hintTooltipRender: r
  };
}, Yy = /* @__PURE__ */ y("div", {
  target: "e1nmhixk0"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), ru = ({
  message: e
}) => /* @__PURE__ */ m.createElement(Yy, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "piano-tooltip-display"
});
ru.displayName = "PianoTooltipDisplay";
const QI = () => {
  var e;
  const {
    rosettaInstance: t
  } = B(), {
    set: n,
    value: r
  } = ye("pianoTooltipHistory", {
    defaultValue: []
  }), {
    message: a,
    shortKey: i,
    version: o
  } = (e = t == null ? void 0 : t.rulesEngine.getOutcome("ui.tooltip.messageObject")) !== null && e !== void 0 ? e : {}, s = i && o && `${i}_${o.toString()}`, [c, l] = ve(), {
    promise: u,
    reject: f,
    resolve: d
  } = jn();
  return ne(() => {
    if (t) {
      if (s && r) {
        l(!r.includes(s));
        return;
      }
    } else return;
    l(!1);
  }, [r, t, s, o]), ne(() => {
    if (!(!t || c === void 0))
      return c && a && s ? d.current({
        node: /* @__PURE__ */ m.createElement(ru, {
          message: a
        }),
        onChangeUrl: () => {
          n((v) => gi(v ?? [], [s])), l(!1);
        },
        onClose: () => {
          n((v) => gi(v ?? [], [s])), l(!1);
        }
      }) : f.current();
  }, [c, a, f, d, t, n, s]), {
    pianoTooltipRender: u
  };
}, Wy = (e) => /* @__PURE__ */ E.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ E.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.414 19.6869L21.437 10.6639L19.141 8.36694L12.414 15.0389L8.914 11.4839L6.562 13.8349L12.414 19.6869ZM23.898 23.8979C21.164 26.6319 17.864 27.9999 14 27.9999C10.135 27.9999 6.836 26.6319 4.101 23.8979C1.367 21.1639 0 17.8649 0 13.9999C0 10.1349 1.367 6.83494 4.101 4.10094C6.836 1.36694 10.135 -6.10352e-05 14 -6.10352e-05C17.864 -6.10352e-05 21.164 1.36694 23.898 4.10094C26.633 6.83494 28 10.1349 28 13.9999C28 17.8649 26.633 21.1639 23.898 23.8979Z", fill: "white" })), Qy = /* @__PURE__ */ y("div", {
  target: "e1yc3qie1"
})({
  name: "zjik7",
  styles: "display:flex"
}), Zy = /* @__PURE__ */ y(Wy, {
  target: "e1yc3qie0"
})({
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
}), au = ({
  onImpression: e
}) => (De(() => {
  e();
}), /* @__PURE__ */ m.createElement(Qy, {
  "data-qa": "login-reminder-tooltip"
}, /* @__PURE__ */ m.createElement(Zy, null), "Log in again for better content recommendations."));
au.displayName = "LoginReminderTooltip";
const ZI = () => {
  const {
    hasAcceptedGDPR: e,
    user: t
  } = B(), [n] = wu("last_logout_timestamp"), {
    remove: r,
    set: a,
    value: i
  } = ye("loginReminderData"), o = Ia(i);
  ne(() => {
    t && r();
  }, [r, t]);
  const {
    promise: s,
    reject: c,
    resolve: l
  } = jn();
  return ne(() => {
    var u;
    if (!e || n === null || t) return c.current();
    const f = (u = o.current) !== null && u !== void 0 ? u : [{
      // 30 minutes
      intervalTime: 1800,
      shown: !1
    }, {
      // 1 day
      intervalTime: 86400,
      shown: !1
    }, {
      // 30 days
      intervalTime: 172800,
      shown: !1
    }], d = Xr(/* @__PURE__ */ new Date()), v = Number.parseInt(n ?? "0");
    for (const [g, p] of f.entries())
      if (d - v >= p.intervalTime && !p.shown)
        return a(() => (f[g].shown = !0, f)), l.current({
          node: /* @__PURE__ */ m.createElement(au, {
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    return c.current();
  }, [n, c, l, a, o, e, t]), {
    loginReminderTooltipRender: s
  };
}, iu = /* @__PURE__ */ function() {
  var e = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "acquisition"
    }
  }], t = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          t
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [t, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "id",
          storageKey: null
        }],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }]
    },
    params: {
      cacheID: "f8a59a268fef536b2b8a27cbc8bf3147",
      id: null,
      metadata: {},
      name: "hooksUseGroupSubscriptionDataQuery",
      operationKind: "query",
      text: `query hooksUseGroupSubscriptionDataQuery {
  appConfig(filter: {entityId: "acquisition"}) {
    json
    id
  }
}
`
    }
  };
}();
iu.hash = "10b91bd845ddc4c70e045441fbd4454d";
var Ky = jc, qy = qc, Jy = dr, $y = Pe, eI = wa, tI = Va, nI = Vc, rI = ja, aI = "[object Map]", iI = "[object Set]", oI = Object.prototype, sI = oI.hasOwnProperty;
function cI(e) {
  if (e == null)
    return !0;
  if (eI(e) && ($y(e) || typeof e == "string" || typeof e.splice == "function" || tI(e) || rI(e) || Jy(e)))
    return !e.length;
  var t = qy(e);
  if (t == aI || t == iI)
    return !e.size;
  if (nI(e))
    return !Ky(e).length;
  for (var n in e)
    if (sI.call(e, n))
      return !1;
  return !0;
}
var lI = cI;
const E1 = /* @__PURE__ */ tn(lI), uI = async (e, t) => (await e.post("/tier", {
  email: t,
  withCredentials: !0
})).data || "", dI = /* @__PURE__ */ y("div", {
  target: "e1dy73d80"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), ou = ({
  message: e,
  onImpression: t
}) => (De(() => {
  t();
}), /* @__PURE__ */ m.createElement(dI, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "group-subscriber-tooltip"
}));
ou.displayName = "GroupSubscriberTooltip";
const KI = () => {
  const {
    user: e
  } = B(), {
    remove: t,
    set: n,
    value: r
  } = ye("groupSubscriberTooltipData"), a = pI(), i = fI(), o = Ia(r), {
    promise: s,
    reject: c,
    resolve: l
  } = jn();
  return ne(() => {
    var u, f;
    if (A1(a) || A1(i)) return;
    if (!e || C1(a) || C1(i)) return c.current();
    const d = a.result, v = i.result;
    if (!d || !v) return c.current();
    (o == null || (u = o.current) === null || u === void 0 ? void 0 : u.version) !== d.tooltip.version && t();
    const g = (f = o.current) !== null && f !== void 0 ? f : {
      intervalData: [{
        intervalTime: 0,
        shown: !1
      }, {
        intervalTime: 604800,
        shown: !1
      }, {
        intervalTime: 1209600,
        shown: !1
      }, {
        intervalTime: 1814400,
        shown: !1
      }, {
        intervalTime: 2419200,
        shown: !1
      }],
      lastShownTimeStamp: Xr(Date.now()),
      version: d.tooltip.version
    }, p = Xr(Date.now()) - g.lastShownTimeStamp;
    if (!g.intervalData) return c.current();
    for (const [h] of g.intervalData.entries()) {
      const A = g.intervalData;
      if (n(() => {
        var C;
        const b = [...A];
        return b[h] = {
          intervalTime: A[h].intervalTime,
          shown: !0
        }, {
          intervalData: b,
          lastShownTimeStamp: g.lastShownTimeStamp,
          version: (C = g.version) !== null && C !== void 0 ? C : ""
        };
      }), p >= g.intervalData[h].intervalTime && !g.intervalData[h].shown)
        return l.current({
          node: /* @__PURE__ */ m.createElement(ou, {
            message: `${d.tooltip.message}`,
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    }
    return c.current();
  }, [a, i, c, t, l, n, o, e, s]), {
    groupSubscriberTooltipRender: s
  };
}, A1 = (e) => !e || e.status === "loading" || e.status === "not-executed", C1 = (e) => e.status === "error", pI = () => {
  const e = H1(), {
    config: t
  } = B(), [n, r] = ct(async () => {
    var a, i;
    const o = await F1(e, iu, {}).toPromise();
    if (o != null && (a = o.appConfig) !== null && a !== void 0 && a.json) return (o == null || (i = o.appConfig) === null || i === void 0 ? void 0 : i.json)[t.environment];
  });
  return De(() => {
    r.execute();
  }), n;
}, fI = () => {
  const {
    config: e,
    user: t
  } = B(), {
    remove: n,
    set: r,
    value: a
  } = ye("corp_subscriber_tier"), i = we(() => Vn.create({
    baseURL: e.corporateSubscriber.host,
    headers: {
      apikey: e.graphql.apiKey
    }
  }), [e]), [o, s] = ct(async () => {
    var c, l;
    const u = /* @__PURE__ */ new Set(["T2", "T3", "T4", "C-suite"]);
    if (!(t != null && t.useremail)) return !1;
    if (a && (a == null ? void 0 : a["Users Email Address"]) !== (t == null ? void 0 : t.useremail) && n(), !E1(a)) return u.has((c = a == null ? void 0 : a.Tier) !== null && c !== void 0 ? c : "");
    const f = await uI(i, t == null ? void 0 : t.useremail);
    return E1(a) && f && r(f), u.has((l = f == null ? void 0 : f.Tier) !== null && l !== void 0 ? l : "");
  });
  return De(() => void s.execute()), o;
};
export {
  Id as A,
  ks as B,
  YI as D,
  mp as F,
  Cs as G,
  kc as P,
  bs as R,
  xe as S,
  Is as U,
  Ld as a,
  hp as b,
  QI as c,
  ZI as d,
  KI as e,
  Jl as f,
  Hl as g,
  Ll as h,
  Ap as i,
  Uc as j,
  Dc as k,
  Hc as l,
  $v as m,
  eh as n,
  cl as o,
  As as p,
  ys as q,
  ka as r,
  r3 as s,
  WI as u
};
//# sourceMappingURL=hooks-13jyWGNJ.mjs.map
